import * as PIXI from 'pixi.js-legacy';
window.PIXI = PIXI;
import ScrollContainer from './ScrollContainer'
import EventEmitter from 'eventemitter3';
import { isArray, fromPairs, isString, includes, values, difference, keys, size, isEqual, map, cloneDeep, shuffle, toPairs, template, extend, clone, isObject, sortBy } from 'lodash';
const util = require('./util.js');
const sprintf = require('sprintf-js').sprintf;
const MultiStyleText = require('@/vendor/pixi-multistyle-text.js');
import LuaVm from './lua.js';
import Tweens from './tweens.js';
import UserSystems from './usersystems.js';
// remove for minimal
const Box2DNormal = require('box2d/Box2D_v2.3.1_min.js')
//import Box2DWasm from 'box2d/test/Box2D_v2.3.1_min.wasm.js'
//import Box2D from 'box2d/Box2D_v2.3.1_min.wasm.wasm'

// remove for minimal
//const bspline = require('b-spline');
// remove for minimal
//const Howl = require('howler').Howl;
// remove for minimal
//require('pixi-spine')
// remove for minimal
//const pixiTilemap = require('../../tiled-kit/pixi-tilemap.js');
// remove for minimal
//const Tiled = require('../../tiled-kit/all.js');
// remove for minimal
//const pixiTilemap2 = require('../../tiled-kit/pixi-tilemap-extension.js');
const Components = require('./components.js');
//require('../../pixi-ui.js');
// remove for minimal
//require('pixi-particles');
const $script = require('scriptjs');
import makeDebug from './debug.js';
import MakeWorldLoader from './WorldLoader.js';
import box2d_debug_draw from './box2d_debug_draw.js';

import SpriteSystem from './spritesystem.js';
import VideoSystem from './videosystem.js';
import TextSystem from './textsystem.js';
import CameraSystem from './camerasystem.js';
import SpriteMaskSystem from './spritemasksystem.js';
import TimelineSystem from './timelinesystem.js';
import TilingSpriteSystem from './tilingsprite_system.js';
import CollisionBoxSystem from './collisionboxsystem.js';

import { PlayAnimationSystem } from './animationsystems.js';
const toWorldRatio = 300;

let __BOX_2D;

const deltaDifference = 0.0005;
function CreateSystems(gameobjects, props, pixiApp, assets) {
  //console.log('CREATE SYSTEMS');
  this.enableLetterbox = props.enableLetterbox;
  gameobjects.DEBUG_DRAW = false;
  this.gameobjects = gameobjects;
  if (gameobjects.DEBUG_DRAW) {
    this.debug = makeDebug(gameobjects)
    this.gameobjects.debug = this.debug;
  } else {
    this.debug = {
      startSystem: () => {},
      stopSystem: () => {}
    }
  }
  this.entitiesByUuid = {};
  this.systemsData = {};
  this.addComponentList = [];
  this.bla_joint = [];
  this.multiRemoveComponentList = [];
  this.componentRemoveList = [];
  this.spriteCache = {};
  this.__spriteCacheLen = 0;
  this.spineCache = {};
  this.__spineCacheLen = 0;
  this.leaderboardCache = {};
  this.shapeCache = {};
  this.__shapeCacheLen = 0;
  this.scrollTransformCache = {};
  this.__scrollTransformCacheLen = 0;
  this.animatedSpriteCache = {};
  this.enableCacheAsBitmap = gameobjects.options.cacheAsBitmap;
  this.enableCacheAsBitmap = false;
  this.transparent = gameobjects.options.transparent;
  this.pathCache = {};
  this.__pathCacheLen = 0;
  this.parallaxCache = {};
  this.__parallaxCacheLen = 0;
  this.currentPressing = {};
  this.particleEmitters = {};
  this.lastRemoveOutsideEntitiesRun = 0;
  this.cooldownGametime = 0;

  this.mainIdealFps = 1.0 / 60;
  this.mainMaxFrameTime = 1.0 / 15;
  this.mainAccumulator = 0;

  // this is for communication with the outside world
  this.outEvents = new EventEmitter();

  // this if or internal events only - gets reset on scene change etc.
  this.events = new EventEmitter();

  this.userSystems = [];
  this.userScripts = {};

  this.pixiContainers = {};
  this.__pixiContainersLen = 0;

  this.PRESS_MAPPING = {
    'right':'pressRight',
    'left':'pressLeft',
    'bottom':'pressBottom',
    'top':'pressTop'
  }
  this.cooldownLast = {};

  this.tilemapCache = {};
  this.physicsBoxes2D = {};
  this.physicsJointsFrom = {};
  this.__physicBoxes2DLen = 0;
  this.SEQUENCES = {};

  this.maxInPool = 200;
  this.spritePool = {};

  this.backgroundContainer = new PIXI.Container();
  this.gameobjects.app.stage.addChild(this.backgroundContainer);

  this.cameraContainer = new PIXI.Container();
  this.cameraContainer.pivot.x = 0;
  this.cameraContainer.pivot.y = 0;
  this.cameraContainer.scale.x = 33;
  this.cameraContainer.scale.y = 33;
  this.cameraContainer.alpha = 1;

  this.particleContainer = new PIXI.ParticleContainer();
  //this.cameraContainer.position.set(0,0);
  //this.cameraContainer.scale.set(50,50);
  this.gameobjects.app.stage.addChild(this.cameraContainer);
  this.gameobjects.cameraContainer = this.cameraContainer;
  this.gameobjects.cameraContainer.addChild(this.particleContainer);

  this.graphics = new PIXI.Container();
  this.cameraContainer.addChild(this.graphics);

  const graphicsGroup = new PIXI.display.Group(999999);
  this.graphics.parentGroup = graphicsGroup;
  const graphicsLayer = new PIXI.display.Layer(graphicsGroup)
  this.gameobjects.app.stage.addChild(graphicsLayer);

  this.screenContainer = new PIXI.Container();
  this.gameobjects.app.stage.addChild(this.screenContainer);


  this.gameobjects.graphics = this.graphics;

  this.overlay = new PIXI.Container();
  this.gameobjects.app.stage.addChild(this.overlay);

  this.featureSlotData = {};
  this.toySlotsData = {};

  this.delayFirstRender = true;

  this.Components = Components.default(this);
  this.Util = require('./create.js').default(this, this.Components);

  this.endOfFrame = [];

  this.componentExtraData = {};

  this.layers = {};

  this.luaStack = {};
  this.luaHeap = {};

  this.componentsInTreeCache = {};

  this.delayCameraForFrames = 0;
  this.delayFirstRenderCounter = this.delayCameraForFrames;

  this.numberRegex = /^[\+\-]?\d*(\.|,)?\d+(?:[Ee][\+\-]?\d+)?$/;

  this.__propertiesCache = {};
  this.__rootPropertiesRevision = 0;

  this.noCamera = true;

  this.addCollisionBoxesToPhysicsBodies = false;

  this.spriteSystem = new SpriteSystem(this);
  this.videoSystem = new VideoSystem(this);
  this.textSystem = new TextSystem(this);
  this.cameraSystem = new CameraSystem(this);
  this.spriteMaskSystem = new SpriteMaskSystem(this);
  this.timelineSystem = new TimelineSystem(this);
  this.tilingSpriteSystem = new TilingSpriteSystem(this);
  this.playAnimationSystem = new PlayAnimationSystem(this);
  this.collisionBoxSystem = new CollisionBoxSystem(this);


  this.highlightTransforms = {};
  this.highlightColor = 0xff00ff;

  this.pixiApp = pixiApp;

  this.assets = assets;

  this.layerAutoComponents = {};

}

CreateSystems.prototype.emitVideoPlayingPrompt = function (data) {
  this.gameobjects.emitVideoPlayingPrompt(data);
}

CreateSystems.prototype.clearHighlightTransformSingle = function () {
  this.highlightTransforms = {}
  this.markAllAsDirty();
}
CreateSystems.prototype.setHighlighTransformSingle = function (id, color) {
  this.highlightTransforms = {}
  this.highlightTransforms[id] = true;
  this.highlightColor = parseInt(color.replace('#','0x'));
  //console.log('highlight transform', id);
  this.markAllAsDirty();
}
CreateSystems.prototype.setHighlighTransform = function (id, highlight) {
  this.highlightTransforms[id] = highlight;
  this.markAllAsDirty();
}

CreateSystems.prototype.isContainersReady = function (ent) {
  const uuid = ent.uuid.uuid;
  return !!this.pixiContainers[uuid].outer && !!this.pixiContainers[uuid].inner;
}

CreateSystems.prototype.markAllAsDirty = function () {
  let ents = this.gameobjects.entities._entities;
  let flength = ents.length;
  for (var i = flength-1; i >= 0; i--) {
    const ent = ents[i];
    this.forceSetDirty(ent);
  }
}

CreateSystems.prototype.setComponentExtraData = function (ent, comp, data) {
  if (comp && comp.id) {
    const id = comp.id;
    this.componentExtraData[ent.uuid.uuid + '-' + id] = data;
    //this.componentExtraData[id] = data;
  } else {
  }
}
CreateSystems.prototype.getComponentExtraData = function (ent, comp) {
  if (comp && comp.id) {
    //return this.componentExtraData[comp.id] || {};
    return this.componentExtraData[ent.uuid.uuid + '-' + comp.id] || {};
  } else {
    return {};
  }
}

CreateSystems.prototype.getScalar = function (ent, scalar, component) {
  if (!scalar) {
    return 0;
  }
  if (!scalar.type) {
    //if (!isNaN(parseFloat(scalar))) {
    if (typeof(scalar) === 'number') {
      return parseFloat(scalar);
    }
    if (!this.numberRegex.test(scalar)) {
      return scalar;
    }

    return parseFloat(scalar);

  }
  if (scalar.type === 'variable') {
    const props = Object.assign(this.getProperties(ent), this.getComponentExtraData(ent, component))
    if (typeof(props[scalar.name]) !== 'undefined') {
      return props[scalar.name];
    }
    return props[scalar.id];
    //return this.luaVm.props[scalar.name]
  }
}
CreateSystems.prototype.createUuid = function (ent) {
  this.Components.Uuid.create(ent);
  this.entitiesByUuid[ent.uuid.uuid] = ent;
  // load its first set of properties at end of frame
}
CreateSystems.prototype.addComponent = function (ent, component, immediate=false, data=undefined) {
  if (!immediate) {
    if (isArray(component)) {
      for (let i = 0; i < component.length; i++) {
        this.addComponentList.push([ent, component[i], data]);
      }
    } else {
      this.addComponentList.push([ent, component, data]);
    }
  } else {
    const createdComponent = this.Util.addComponent(ent, component, data);
    this.justAddedComponent(component, createdComponent);
    return createdComponent;
    //this.debug.addComponent(ent, component);
  }
}

CreateSystems.prototype.addComponents = function (dt) {

  const addComponentList = clone(this.addComponentList);
  const addComponentsLength = addComponentList.length;
  // the components added here may add other compionents?
  for (let i = 0; i < addComponentsLength; i++) {
    const ent = addComponentList[i][0];
    const component = addComponentList[i][1];
    if (!component) {
      console.warn('component is not valid', ent.uuid.uuid);
      continue;
    }
    const data = addComponentList[i][2];
    const createdComponent = this.Util.addComponent(ent, component, data);
    this.justAddedComponent(component, createdComponent);
    //this.debug.addComponent(ent, component);
  }
  this.addComponentList = [];
}

CreateSystems.prototype.justAddedComponent = function (component, addedComponent) {
  if (component.type === 'tapcontroller' || component.type === 'pancontroller' || component.type === 'swipecontroller' || component.type === 'pan' || component.type === 'feature') {
    // TODO: feature is just there as a hack for now
    // to show users to swipe when they add the floatie
    // feature
    this.outEvents.emit('addInteractiveComponent', {type:component.type});
  }
}

CreateSystems.prototype.multiRemoveComponent = function (ent, component, instance) {
  this.multiRemoveComponentList.push([ent, component, instance]);
}

CreateSystems.prototype.removeComponent = function (ent, component) {
  this.componentRemoveList.push([ent, component]);
}
CreateSystems.prototype.removeComponents = function (dt) {
  this.removeMultiComponents(dt);

  const total = this.componentRemoveList.length;
  for (let i = 0; i < total; i++) {
    const x = this.componentRemoveList[i];
    const ent = x[0];
    const component = x[1];
    //console.log('[component remove] removing', ent.id, component);
    if (component.removeFunction) {
      component.removeFunction(this, this.gameobjects, component, ent);
    }
    //debug.addDebugLine(ent, `remove component: ${component}`);
    if (ent._manager) {
      ent.removeComponent(component);
    }
  }
  this.componentRemoveList = [];
}

CreateSystems.prototype.removeMultiComponents = function (dt) {
  const total = this.multiRemoveComponentList.length;
  for (let i = 0; i < total; i++) {
    const x = this.multiRemoveComponentList[i];
    const ent = x[0];
    const component = x[1];
    const instance = x[2];

    const comp = ent[component.__name];
    if (!comp || !comp.multi) {
      //console.warn('i lost', ent, 'for', component);
      continue;
    }
    const length = comp.multi.length;
    for (let j = length-1; j>=0; j--) {
      if (comp.multi[j].c === instance) {
        if (instance.removeFunction) {
          instance.removeFunction(this, this.gameobjects, instance, ent);
        }
        delete comp.running[comp.multi[j].component.id]
        comp.multi.splice(j, 1);
        //console.log('[component remove multi] removing', ent.uuid.uuid, comp.multi.length);
      }

    }
    if (comp.multi.length === 0) {
      //console.log('[component remove multi] removing last', ent.uuid.uuid, component);
      this.removeComponent(ent, component);
    }
  }
  this.multiRemoveComponentList = [];
}

CreateSystems.prototype.findComponent = function (id) {
  return this.gameobjects.componentIdCache[id];
}

CreateSystems.prototype.findComponentExtensions = function (ent, component, name) {
  const key = ent.uuid.uuid + 'x' + component.id;
  return this.gameobjects.toyExtensions[key] || [];
}
CreateSystems.prototype.returnSlots = function (ent, components) {
  const total = components.length;
  const comps = [];
  for (let i = 0; i < total; i++) {
    const link = components[i].link;
    const component = components[i].component;
    if (link.us && link.script) {
      const script = link.script;
      const ret = this.runScript(16, ent, component, script);
      if (ret) {
        comps.push(component);
      }
    } else if (!link.stateName || !link.stateValue) {
      comps.push(component);
    } else {
      if (ent.uuid.state[link.stateName] === link.stateValue) {
        comps.push(component);
      }
    }
  }
  return comps;
}

CreateSystems.prototype.addFeatureSlots = function (ent, components, links, root) {
  const uuid = ent.uuid.uuid;
  //if (!this.featureSlots[uuid]) {
    //this.featureSlots[uuid] = [];
  //}
  const newCache = util.prePopulateCache({
    components,
    links
  })

  Object.assign(this.gameobjects.componentLinkCache, newCache);
  //extend(this.componentLinkCache, newCache);
}

CreateSystems.prototype.getSlotExtensions = function (ent, component) {
  return (ent.uuid.__extendedSlots||{})[component.id] || []
}

CreateSystems.prototype.findSlots = function (ent, component, name, notNamed, raw=false) {
  if (!ent.uuid || !ent.uuid.uuid) {
    return []
  }
  const hasExtensions = this.getSlotExtensions(ent, component).length > 0;
  let nameInKey = isArray(name) ? name.join("-") : name;
  if (notNamed) {
    nameInKey += '-' + notNamed.join(',');
  }
  const key = component.id + '-' + nameInKey;

  if (this.gameobjects.componentLinkCache[key]) {
    let slots = this.gameobjects.componentLinkCache[key] || []
    if (hasExtensions) {
      slots = slots.concat(this.getSlotExtensions(ent, component));
    }
    if (raw) {
      return slots;
    }
    return this.returnSlots(ent, slots);
  }

  const components = [];
  const myLinks = this.gameobjects.componentLinkCache[component.id + '-__ALL_LINKS']  || [];
  //const length = gameobjects.links.length;
  const length = myLinks.length;
  for (let i = 0; i < length; i++) {
    //const link = gameobjects.links[i];
    const link = myLinks[i];

    if (!name || (isString(name) ? link.name === name : isArray(name) ? includes(name, link.name) : name(link))) {
      if (link.source === component.id) {
        if (notNamed) {
          if (!includes(notNamed, link.name)) {
            components.push({component:this.findComponent(link.target),link:link});
          }
        } else {
          components.push({component:this.findComponent(link.target),link:link});
        }
      }
    }
  }

  this.gameobjects.componentLinkCache[key] = components;
  if (raw) {
    const slots = this.gameobjects.componentLinkCache[key] || []
    if (hasExtensions) {
      return slots.concat(this.getSlotExtensions(ent, component));
    } else {
      return slots;
    }
  }

  if (hasExtensions) {
    return this.returnSlots(ent, components.concat(this.getSlotExtensions(ent, components)));
  } else {
    return this.returnSlots(ent, components);
  }
}


/*
const spriteCache = new LRU({
    maxAge:5 * 1000,
    dispose: (key, sprite) => {
    }

});
*/
CreateSystems.prototype.getNextPowerOfTwo = function (x) {
  return Math.pow(2, Math.floor(Math.log(x)/Math.log(2))+1)
}
CreateSystems.prototype.clearPool = function () {
  values(this.spritePool).forEach( (spriteCache) => {
    spriteCache.forEach( (sprite) => {
      sprite.destroy();
    });
  });
  this.spritePool = {};
}
CreateSystems.prototype.returnToPool = function (texture, sprite, parent) {
  if (!this.spritePool[texture]) {
    this.spritePool[texture] = [];
  }
  if (this.spritePool[texture].length < this.maxInPool) {
    this.spritePool[texture].push(sprite);
    sprite.visible = false;
    sprite.mask = null;
    parent.removeChild(sprite);
  } else {
    parent.removeChild(sprite);
    sprite.mask = null;
    sprite.destroy();
  }
}

CreateSystems.prototype.getScaledSprite = function (textureName, texture, scalex, scaley) {

  if (this.spritePool[textureName] && this.spritePool[textureName].length) {
    const s = this.spritePool[textureName].pop();
    s.visible = true;
    s.mask = null;
    return s;
  } else {
    let sprite = new PIXI.Sprite(texture);
    sprite.scale.x = scalex;
    sprite.scale.y = scaley;
    return sprite;
  }
}

CreateSystems.prototype.addInnerContainer = function (uuid, ent) {
  if (this.pixiContainers[uuid].inner) {
    return;
  }
  //const innerContainer = new PIXI.particles.ParticleContainer();
  const innerContainer = new PIXI.Container();
  this.pixiContainers[uuid].inner = innerContainer;
  this.pixiContainers[uuid].outer.addChild(innerContainer);

  if (this.gameobjects.DEBUG_DRAW) {
    const container = this.pixiContainers[uuid].outer
    const graphics = new PIXI.Graphics();
    graphics.lineStyle(0.05, 0xff0000);
    graphics.drawRect(-0.5,-0.5,1,1);
    innerContainer.addChild(graphics);

    const graphics2 = new PIXI.Graphics();
    graphics2.lineStyle(0.05, 0xffff00);
    graphics2.drawRect(-0.5,-0.5,1,1);
    container.addChild(graphics2);
  }

}

CreateSystems.prototype.getEntByTransformId = function (id) {
  const ents = this.gameobjects.entities.queryTag(id);
  if (ents.length) {
    return ents[0];
  }
  return null;
}
CreateSystems.prototype.findRoot = function (dt) {
  if (!this.__root) {
    const roots = this.gameobjects.entities.queryTag('root');
    if (roots.length) {
      this.__root = roots[0];
      return this.__root;
    }
    console.warn('root lost');
    return null;
  }
  return this.__root;
}


CreateSystems.prototype.beforeUpdateSpine = function (dt) {
  this.spineHitkeys = [];
}
CreateSystems.prototype.afterUpdateSpine = function (dt) {
  const hitKeys = this.spineHitkeys;
  let removedSprite = false;
  if (this.__spineCacheLen !== hitKeys.length) {
    const toRemove = difference(keys(this.spineCache), hitKeys);
    const toRemoveLength = toRemove.length;
    for (let i = 0; i < toRemoveLength; i++) {
        const uuid = toRemove[i];
        const spine = this.spineCache[uuid].spine;
        spine.destroy();
        delete this.spineCache[uuid];
        this.__spineCacheLen--;
        removedSprite = true;
    }
  }
}

CreateSystems.prototype.updateSpineControl = function (dt, ent) {
  const uuid = ent.uuid.uuid;
  if (!this.spineCache[uuid]) {
    //console.warn('ent does not have a spineTransform!');
    return;
  }
  const {spine} = this.spineCache[uuid];
  const totalLength = ent.spineControl.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.spineControl.multi[j];
    const spineControl = o.c;
    const component = o.component;

    this.addComponent(ent, this.findSlots(ent, ent.spineControl, 'link'));

    const track = parseInt(spineControl.data.track);
    if (spineControl.action === 'start') {
      spine.state.setAnimation(track, spineControl.data.animation, spineControl.data.loop);
    } else if (spineControl.action === 'stop') {
      spine.state.setEmptyAnimation(track, 0)
    } else {
      //console.error('dont know spineControl action', spineControl);
    }

    this.multiRemoveComponent(ent, this.Components.SpineControl, spineControl);
  }
}
CreateSystems.prototype.updateSpine = function (dt, ent) {
  const uuid = ent.uuid.uuid;
  if (!this.spineCache[uuid]) {
    this.loadedSpine = true;
    const slots = this.findSlots(ent, ent.spineTransform);
    this.addComponent(ent, slots);
      //texture = this.gameobjects.resources[ent.sprite.atlas].textures[ent.sprite.texture]
    const spineName = ent.spineTransform.spine;
    if (!this.gameobjects.resources[spineName]) {
      throw new Error('spine not there');
    }
    const spine = new PIXI.spine.Spine(this.gameobjects.resources[spineName].spineData);

    // set the position
    //spine.x = -10
    //spine.y = 10

    spine.scale.set(1.0 / (1920.0/16));

    // set up the mixes!
    //spine.stateData.setMix('running', 'jump', 0.2);
    //spine.stateData.setMix('jump', 'running', 0.4);

    // play animation
    //spine.state.setAnimation(0, 'animation', true);

    this.addInnerContainer(uuid, ent);
    const parent = this.pixiContainers[uuid].inner;
    parent.addChild(spine);

    this.spineCache[uuid] = {
      spine
    }
    this.__spineCacheLen++;

    const transform = ent.transform;
    for (let j = 0; j < transform.children.length; j++) {
      const child = transform.children[j];
      if (child.vars.spineSlot && child.vars.spineSlot !== 'none') {
        const childEnt = this.createSceneGraphChild(ent, child, false);
        ent.spineTransform.attachments.push({
          childEnt,
          name:child.vars.spineSlot
        })
      } else {
        this.createSceneGraphChild(ent, child, false);
      }
    }

  }
  const {spine} = this.spineCache[uuid];
  const attachmentsLength = ent.spineTransform.attachments.length;
  for (let i = 0; i < attachmentsLength; i++) {
    const spineAttachment = ent.spineTransform.attachments[i];
    const {name,childEnt} = spineAttachment;
    if (!childEnt || !name) {
      //console.warn('childEnt does not exist');
      continue;
    }
    if (!childEnt.transform) {
      // child is already is destroyed
      continue;
    }
    const slot = spine.skeleton.findSlot(name)
    if (!slot) {
      //console.warn(ent.uuid.uuid, 'could not find slot', name);
      continue;
    }
    const {attachment} = slot;
    const verts = [];
    const matrix = slot.bone.matrix;
    const angle = Math.atan2(-matrix.b, matrix.a);
    const fokkenScale = this.getWorldScale(ent);
    const worldPos = this.getWorldPosition(ent)
    const bonePos = {
      x:slot.bone.worldX  * (/*this.cameraContainer.scale.x*/ 1 * spine.scale.x) + 0*worldPos.x,
      y:slot.bone.worldY  * (/*this.cameraContainer.scale.y*/ 1 * spine.scale.y) + 0*worldPos.y,
    }

    childEnt.transform.x = bonePos.x;
    childEnt.transform.y = bonePos.y;
    childEnt.transform.rotation = -angle;
    childEnt.transform.__positionUpdated2 =true;
    this.conditionallySetDirty(childEnt);

    if (false && this.gameobjects.DEBUG_DRAW) {
      const thing = new PIXI.Graphics();
      for (let i = 0; i < attachment.vertices.length; i++) {
        //const v1 = (i%2==0?1:1) * (attachment.vertices[i]/this.cameraContainer.scale.x)
        const v1 = (i%2==0?1:1) * (attachment.vertices[i]*spine.scale.x)
        //console.log('v1', v1);
        verts.push(v1)
      }

      //this.gameobjects.graphics.position.x = slot.bone.worldX / this.cameraContainer.scale.x;
      //this.gameobjects.graphics.position.y = slot.bone.worldY / this.cameraContainer.scale.x;
      this.gameobjects.graphics.position.x = bonePos.x;
      this.gameobjects.graphics.position.y = bonePos.y;
      this.gameobjects.graphics.rotation = 0*-Math.PI/8 - angle
      this.gameobjects.graphics.beginFill(0xff0000, 1);
      this.gameobjects.graphics.drawPolygon(verts);
      this.gameobjects.graphics.endFill();
    }

  }

  this.spineHitkeys.push(uuid);
  //vertices = sub.skeleton.findSlot("port_triangle").attachment.vertices;
}


function makeColor(x) {
  if (x.indexOf('#') === 0) {
    return x.replace('#', '0x')
  } else {
    return x;
  }
}

CreateSystems.prototype.beforeUpdateShapes = function (dt) {
  this.shapeHitKeys = [];
}
CreateSystems.prototype.afterUpdateShapes = function (dt) {
  const hitKeys = this.shapeHitKeys;
  if (this.__shapeCacheLen === hitKeys.length) {
    return;
  }
  const toRemove = difference(keys(this.shapeCache), hitKeys);
  const toRemoveLength = toRemove.length;
  for (let i = 0; i < toRemoveLength; i++) {
      const uuid = toRemove[i];
      const {shape,parent,cacheContainer} = this.shapeCache[uuid];
      shape.visible = false;
      shape.alpha = 0
      cacheContainer.destroy({texture:true,baseTexture:true});
      shape.destroy({texture:true,baseTexture:true});
      parent.removeChild(cacheContainer);
      //shape.parent.removeChild(shape);
      delete this.shapeCache[uuid];
  }
}


CreateSystems.prototype.updateShapes = function (dt, ent) {
  let addedShape = false;
//  this.debug.startSystem('updateShapes', length);
  const uuid = ent.uuid.uuid;
  let cache = this.shapeCache[uuid];

  if (!cache) {

    const width = 1;
    const height = 1;
    //const width = 600;
    //const height = 600;

    this.addInnerContainer(ent.uuid.uuid, ent);
    const parent = this.pixiContainers[ent.uuid.uuid].inner;
    //gfx.beginFill(0x00ff00);
    //gfx.drawRect(-0.5, -0.5, 1.0, 1.0);
    //gfx.endFill();

    const shape = new PIXI.Graphics();
    util.makeShape(this.themes, shape, ent.shape);
    /*
    if (ent.shape.type === 'circle') {
      shape.beginFill(makeColor(ent.shape.color));
      shape.drawEllipse(width/2, height/2, width/2, height/2);
      shape.endFill()
    } else {
      shape.beginFill(makeColor(ent.shape.color));
      if (ent.shape.stroke !== '') {
        shape.lineStyle(ent.shape.lineWidth || 1, ent.shape.stroke);
      }
      shape.drawRect(-width/2,-width/2,width,height);
      shape.endFill()
    }
    */

    const scaleValue = 1920/16;
    const cacheContainer = new PIXI.Container()
    cacheContainer.scale.x = 1/scaleValue;
    cacheContainer.scale.y = 1/scaleValue;
    //shape.scale.x = 1/scaleValue;
    //shape.scale.y = 1/scaleValue;
    //cacheContainer.cacheAsBitmap = false;
    if (this.enableCacheAsBitmap) {
      cacheContainer.visible = false;
    }
    cacheContainer.addChild(shape);

    parent.addChild(cacheContainer);

    //this.gameobjects.app.stage.addChild(shape);
    this.shapeCache[uuid] = {
      color:ent.shape.color,
      shape,
      parent,
      cacheContainer,
      width,
      height
    }
    this.__shapeCacheLen++;
    addedShape = true;

    // TODO: fix this
    const slots = this.findSlots(ent, ent.shape);
    this.addComponent(ent, slots);

    this.createSceneGraphChildren(ent, ent.transform);

    shape.visible = false;
    ent.shape.firstFrame = 3;

  }

  cache = this.shapeCache[uuid];
  let shape = cache.shape;
  let cacheContainer = cache.cacheContainer;

  if (ent.shape.firstFrame >= 1) {
    ent.shape.firstFrame--;
  }
  if (ent.shape.firstFrame === 0) {
    cache.shape.visible = true;
    ent.shape.firstFrame = -1;
  }


  if (cache && !cacheContainer.visible && cacheContainer.__pbcNotFirstFrame) {
    if (this.enableCacheAsBitmap && !ent.shape.dontCacheAsBitmap) {
      cacheContainer.cacheAsBitmap = true;
    }
    cacheContainer.visible = true;
  } else {
  }
  cacheContainer.__pbcNotFirstFrame = true;

  if (cache && cache.color !== ent.shape.color) {
    if (this.enableCacheAsBitmap) {
      cacheContainer.cacheAsBitmap = false;
    }
    util.makeShape(this.themes, shape, ent.shape);
    cache.color = ent.shape.color;
  }


  if (ent.transform.anchorx !== 0.5 || ent.transform.anchory !== 0.5) {
    cacheContainer.position.x = 0.5 - ent.transform.anchorx;
    cacheContainer.position.y = 0.5 - ent.transform.anchory;
  }

  this.shapeHitKeys.push(uuid);

  /*
  */

//  this.debug.stopSystem('updateShapes');

}

CreateSystems.prototype.beforeUpdateScrollTransform = function (dt) {
  this.scrollTransformHitKeys = [];
}
CreateSystems.prototype.afterUpdateScrollTransform = function (dt) {
  const hitKeys = this.scrollTransformHitKeys = [];
  if (this.__scrollTransformCacheLen === hitKeys.length) {
    return;
  }
  const toRemove = difference(keys(this.scrollTransformCache), hitKeys);
  const toRemoveLength = toRemove.length;
  for (let i = 0; i < toRemoveLength; i++) {
    const uuid = toRemove[i];
  }
}

CreateSystems.prototype.updatePixiTransform = function (ent, force=false) {
  if (!ent || !ent.uuid) {
    return;
  }
  if (this.shouldUpdateTransform(ent, force)) {
    const containers = this.pixiContainers[ent.uuid.uuid];
    if (!containers) {
      return;
    }
    let {outer} = containers;
    if (outer) {
      outer.updateTransform();
    }
  }
}
CreateSystems.prototype.updateScrollTransform = function (dt, ent) {
  if (this.isDirty(ent)) {
    return;
  }
  //this.conditionallySetDirty(ent)
//  this.debug.startSystem('updateShapes', length);
  const uuid = ent.uuid.uuid;
  let cache = this.scrollTransformCache[uuid];

  if (!cache) {

    const scale = this.getWorldScale(ent);
    const screenScale = this.getScreenPos(ent, scale);
    const referencePos = this.getScreenPos(ent, {x:0,y:0});
    const width = (screenScale.x - referencePos.x);
    const height = (screenScale.y - referencePos.y);


    const uiStage = new PIXI.UI.Stage(width,height);
    PIXI.UI.Ticker.disabled = true;
    //const scrollContainer = new PIXI.UI.Container();
    const scrollContainer = new PIXI.UI.ScrollingContainer({
      //expandMask:100,
      scrollX:true,
      scrollY:true,
      //softness:0.05
    });

    this.MASK_TEST = scrollContainer.mask;
    //scrollContainer.verticalAlign = 'middle';
    //scrollContainer.horizontalAlign = 'center';
    scrollContainer.width = '100%';
    scrollContainer.height = '100%'
    //scrollContainer.anchorLeft = 0
    //scrollContainer.anchorBottom = 0
    //scrollContainer.anchorRight = 0
    //scrollContainer.anchorTop = 40

    //scrollContainer.dragThreshold = 1/40;
    //scrollContainer.dragRestrictAxis = "y";
    scrollContainer.on('dragStart', function () {
    });

    const zIndex = 999;
    ent.transform.zIndex = 999;

    const gfx = new PIXI.Graphics();
    gfx.beginFill(0xff00ff);
    const pivot = this.gameobjects.app.stage.position;
    gfx.drawRect(0 - pivot.x, 0 - pivot.y, 300, 300);
    gfx.endFill();
    //this.screenContainer.addChild(gfx);
    this.gameobjects.app.stage.addChild(gfx);

    //this.pixiContainers[uuid].outer = scrollContainer.container;

    //const worldPos = this.getWorldPosition(ent);
    this.updatePixiTransform(ent);

    const screenPos = this.getScreenPos(ent);
    const bla = container.getGlobalPosition();
    const screenPos2 = this.cameraContainer.worldTransform.applyInverse(screenPos);

    //const worldPos = {x:-10,y:0}
    //const screenPos = this.cameraContainer.worldTransform.apply(worldPos);
    //screenPos.x -= this.cameraContainer.pivot.x;
    //screenPos.y -= this.cameraContainer.pivot.y;
    uiStage.position.set(screenPos.x - width/2, screenPos.y - height/2)
    //parent.transform.position.set(-width/2,-height/2)
    uiStage.addChild(scrollContainer);
    //this.cameraContainer.addChild(uiStage);
    this.screenContainer.addChild(uiStage);

    //const cheeseContainer = new PIXI.UI.Container();
    //scrollContainer.addChild(cheeseContainer);
    //this.pixiContainers[uuid].outer = cheeseContainer.container;

    this.__scrollTransformCacheLen++;

    // TODO: fix this
    const slots = this.findSlots(ent, ent.scrollTransform);
    this.addComponent(ent, slots);

    //this.createSceneGraphChildren(ent, ent.transform);
    this.pixiContainers[ent.uuid.uuid].mask = scrollContainer.mask;
    const children = this.createSceneGraphChildren(ent, ent.transform)

    //this.pixiContainers[uuid].outer.addChild(parallaxParent);
    //parent.removeChild(outer)
    //parent.addChild(parallaxParent);
      //parallaxParent.addChild(outer)

      const screenParent = new PIXI.Container();
      screenParent.scale.x = 40;
      screenParent.scale.y = 40;
      scrollContainer.innerContainer.addChild(screenParent);


    let top = 0;
    for (let i = 0; i < 10; i++) {
    }


    const dummyContainer = new PIXI.UI.Container('100%','300px');
    scrollContainer.addChild(dummyContainer);

    children.forEach( (child) => {
      const {outer,parent,inner} = this.pixiContainers[child.uuid.uuid]
      parent.removeChild(outer)
      screenParent.addChild(outer);
      
    });

    this.scrollTransformCache[uuid] = {
      scrollContainer,
      children,
      screenParent,
      parent
    }



  }

  cache = this.scrollTransformCache[uuid];

  this.scrollTransformHitKeys.push(uuid);

}


CreateSystems.prototype.updateCircles = function (dt, ent) {
return;
  const uuid = ent.uuid.uuid;
  let cache = this.shapeCache[uuid];

  if (!cache) {
    const graphics = new PIXI.Graphics();
    this.addInnerContainer(ent.uuid.uuid, ent);
    const parent = this.pixiContainers[ent.uuid.uuid].inner;
    this.shapeCache[uuid] = {
      shape:graphics,
      settings:{}
    }
    this.__shapeCacheLen++;
    graphics.position.x = -0.5;
    graphics.position.y = -0.5;
    parent.addChild(graphics);
  }


  const {shape,settings} = this.shapeCache[uuid];
  if (true || !isEqual(settings, ent.circle)) {
    const circle = ent.circle;
    shape.clear();
    let sx = circle.cx;
    let sy = circle.cy;

    const startAngle = this.getScalar(ent, circle.startAngle, circle);
    const endAngle = this.getScalar(ent, circle.endAngle, circle);

    if (Math.abs(endAngle - startAngle) >= (Math.PI * 2) -0.1) {
      sx = circle.cx + startAngle * this.getScalar(ent, circle.radius, circle)/2;
      sy = circle.cy + startAngle * this.getScalar(ent, circle.radius, circle)/2;
    }
    shape.moveTo(sx, sy);
    if (circle.fill) {
      shape.beginFill(parseInt(circle.color.replace('#','0x')));
    }
    if (circle.outline) {
      shape.lineStyle(
        this.getScalar(ent, circle.lineWidth, circle), circle.lineColor.replace('#','0x'));
    }

    shape.arc(
      parseFloat(circle.cx),
      parseFloat(circle.cy),
      circle.radius/2,
      startAngle,
      endAngle)
    if (circle.outline) {
      shape.lineTo(sx, sy);
    }
    if (circle.fill) {
      shape.endFill();
    }

    this.shapeCache[uuid].settings = cloneDeep(circle);
  }

  this.shapeHitKeys.push(uuid);

}


CreateSystems.prototype.updateSetState = function (dt, ent) {
  const totalLength = ent.setState.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.setState.multi[j];
    const setState = o.c;
    const component = o.component;
    ent.uuid.state[setState.stateName] = setState.stateValue;
    this.multiRemoveComponent(ent, this.Components.SetState, setState);
  }

}
CreateSystems.prototype.updateJump = function (dt, ent) {
  let canJump = true;
  if (!canJump) {
    return;
  }
  if (!ent.jump.__addComponents) {
    this.addComponent(ent, this.findSlots(ent, ent.jump, 'link'));
    ent.jump.__addComponents = true;
  }
  ent.transform.x -= ent.jump.dx * dt/1000;
  ent.transform.y -= ent.jump.dy * dt/1000;
  if (ent.jump.dy !== 0) {
      ent.jump.dy -= ent.gravityAffected.gravity * dt/1000;
  }

  if (ent.transform.y > ent.gravityAffected.originalY) {
    ent.transform.y = ent.gravityAffected.originalY;
    this.removeComponent(ent, this.Components.Jump);
  }

/*
  ents = this.gameobjects.entities.queryComponents([this.Components.Jump, this.Components.Transform, this.Components.PhysicsBody]);
  length = ents.length;
  for (let i = 0; i < length; i++) {
    const ent = ents[i];

    const tags = ent.jump.platformTags;
    let canJump = false;
    if (tags.length > 0) {
      const key = ent.uuid.uuid;
      const currentlyColliding = this.gameobjects.b2d_collisionsCurrent[key] || [];
      const currentlyCollidingLength = currentlyColliding.length;
      for (let j = 0; j < currentlyCollidingLength; j++) {
        const coll = currentlyColliding[j];
        for (let k = 0; k < tags.length; k++) {
          const tag = tags[k];
          if (coll.hasTag(tag)) {
            canJump = true;
          }
        }

      }
      
    } else {
      canJump = true;
    }

    if (!canJump) {
      this.removeComponent(ent, this.Components.Jump);
      continue;
    }

    const physicsBoxes = this.physicsBoxes2D[ent.uuid.uuid];
    for (let j = 0; j < physicsBoxes.length; j++) {
      let physicsBox = physicsBoxes[j];
      const currentVector = physicsBox.GetLinearVelocity();
      const x = currentVector.get_x();
      const y = currentVector.get_y();
      physicsBox.SetLinearVelocity(
        this.createBox2d_b2Vec2(
          ent.jump.dx ? ent.jump.dx : x,
          ent.jump.dy ? ent.jump.dy : y
        )
        //0, -5
      );

      this.removeComponent(ent, this.Components.Jump);

      this.addComponent(ent, this.findSlots(ent, ent.jump));
    }


  }
  */
//  this.debug.stopSystem('updateJump');

}

/*
function updateGravityAffeced(gameobjects, dt) {
  const ents = gameobjects.entities.queryComponents([this.Components.GravityAffected]);
  for (let i = 0; i < ents.length; i++) {
    const ent = ents[i];
    ent.transform.y += ent.gravityAffected.gravity * dt;
    if (ent.transform.y > ent.gravityAffected.originalY) {
      ent.transform.y = ent.gravityAffected.originalY;
    }
  }
}
*/

CreateSystems.prototype.updateRepeater = function (dt, ent) {
  const totalLength = ent.repeater.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.repeater.multi[j];
    const repeater = o.c;
    const component = o.component;
    const r = Math.random();
    repeater.curTime += dt;
    if (repeater.activated) {
      if (repeater.curTime > this.getScalar(ent, repeater.firetime, repeater) * 1000) {
        if (r <= this.getScalar(ent, repeater.probability, repeater)) {
          const a = this.findSlots(ent, component);
          this.addComponent(ent, a);
        }
        repeater.timesFired++;
        repeater.curTime = 0;
        if (repeater.times !== 0 && repeater.timesFired >= this.getScalar(ent, repeater.times, repeater)) {
          this.multiRemoveComponent(ent, this.Components.Repeater, repeater);
        }
      }
    } else {
      const initialDelay = this.getScalar(ent, repeater.initialDelay, repeater) * 1000;
      if (repeater.curTime > initialDelay) {
        const a = this.findSlots(ent, component);
        const r = Math.random();
        if (r <= this.getScalar(ent, repeater.probability, repeater)) {
          this.addComponent(ent, a);
        }
        repeater.activated = true;
        repeater.curTime = 0;
        repeater.timesFired++;
        if (repeater.times !== 0 && repeater.timesFired >= this.getScalar(ent, repeater.times, repeater)) {
          this.multiRemoveComponent(ent, this.Components.Repeater, repeater);
        }

        for (let j = 0; j < this.getScalar(ent, repeater.preSpawn, repeater); j++) {
          const a = this.findSlots(ent, component);
          this.addComponent(ent, a);
        }
      } else {
      }
    }

  }

}

CreateSystems.prototype.updateSpawner = function (dt, ent) {

  const totalLength = ent.spawner.multi.length;
  const transform = ent.transform;
  let totalFinished = 0;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.spawner.multi[j];
    const spawnerTransform = o.c;
    const component = o.component;
    const r = Math.random();

    if (!spawnerTransform.__addComponents) {
      const slots = this.findSlots(ent, component, 'link');
      this.addComponent(ent, slots);
      spawnerTransform.__addComponents = true;
    }

    let fired = false;
    for (let j = 0; j < transform.children.length; j++) {
      const child = transform.children[j];

      if (!spawnerTransform.spawners[child.id]) {
        spawnerTransform.spawners[child.id] = {
          firetime: child.vars.firetime,
          initialDelay: child.vars.initialDelay,
          probability: child.vars.probability,
          times: child.vars.times,
          curTime: 0,
          activated: false,
          timesFired: 0
        }
      }

      const spawner = spawnerTransform.spawners[child.id];

      spawner.curTime += dt;
      if (spawner.activated) {
        if (spawner.curTime > this.getScalar(ent, spawner.firetime, spawner) * 1000) {
          if (r <= this.getScalar(ent, spawner.probability, spawner)) {
            const newEnt = this.gameobjects.entities.createEntity();
            this.createUuid(newEnt);
            this.createSceneGraph(newEnt, child, ent, false);
            fired = true;
          }
          spawner.timesFired++;
          spawner.curTime = 0;
          if (spawner.times !== 0 && spawner.timesFired >= this.getScalar(ent, spawner.times, spawner)) {
            this.multiRemoveComponent(ent, this.Components.Spawner, spawner);
          }
        }
      } else {
        if (spawner.curTime > dt && spawner.curTime > this.getScalar(ent, spawner.initialDelay, spawner) * 1000) {
          const r = Math.random();
          if (r <= this.getScalar(ent, spawner.probability, spawner)) {
            const newEnt = this.gameobjects.entities.createEntity();
            this.createUuid(newEnt);
            this.createSceneGraph(newEnt, child, ent, false);
            fired = true;
          }
          spawner.activated = true;
          spawner.curTime = 0;
          spawner.timesFired++;

          if (spawner.times !== 0 && spawner.timesFired >= this.getScalar(ent, spawner.times, spawner)) {
            totalFinished++;
          }

        }
      }

    }

    if (fired) {
      const slots = this.findSlots(ent, component, 'create');
      this.addComponent(ent, slots);
    }


    if (totalFinished === totalLength) {
      this.multiRemoveComponent(ent, this.Components.Spawner, spawner);
    }

  }

}
CreateSystems.prototype.updateRandom = function (dt, ent) {
  const r = Math.random();
  if (r < ent.random.probability) {
    this.addComponent(ent, this.findSlots(ent, ent.random));
  }
  this.removeComponent(ent, this.Components.Random);

}

CreateSystems.prototype.movePhysicsBodies = function (dt, ent) {
  const uuid = ent.uuid.uuid;
  const physicsBoxes = this.physicsBoxes2D[uuid];
  if (!this.isDirty(ent) && !physicsBoxes[0].IsAwake()) {
    return;
  }
  for (let j = 0; j < physicsBoxes.length; j++) {
    const physicsBox = physicsBoxes[j];
    this.movePhysicsBody(dt, ent, physicsBox);
  }

}
CreateSystems.prototype.movePhysicsBody = function (dt, ent, physicsBox) {
  const worldPos = this.getWorldPosition(ent);
  let bpos = physicsBox.GetPosition();
  const inPos = {
    x:bpos.get_x(),
    y:bpos.get_y()
  }

  if (ent.transform.__positionUpdated || (Math.abs(worldPos.x - inPos.x) > deltaDifference || Math.abs(worldPos.y - inPos.y) > deltaDifference)) {
    const currentVector = physicsBox.GetLinearVelocity();
    const x = currentVector.get_x();
    const y = currentVector.get_y();
    // if its not already moving
      //physicsBox.SetTransform( this.createBox2d_b2Vec2(worldPos.x, worldPos.y), physicsBox.GetAngle());
      const x_changed = true;
      const y_changed = true;
      const targetDiff = {
        x:x_changed ? (worldPos.x - inPos.x) : 0,
        y:y_changed ? (worldPos.y - inPos.y) : 0
      }
      const targetVelocity = this.createBox2d_b2Vec2(
          targetDiff.x / (dt/1000),
          targetDiff.y / (dt/1000)
        )
      //physicsBox.SetAngularVelocity(ent.transform.rotation * (dt/1000));
      physicsBox.SetLinearVelocity(targetVelocity);
      physicsBox.SetAwake(1);

      if (ent.physicsbody2d.fixedRotation) {
        physicsBox.SetTransform(physicsBox.GetWorldCenter(), 0);
        ent.transform.rotation = 0;
        ent.transform.localRotation = 0;
      } else {
        physicsBox.SetTransform(physicsBox.GetWorldCenter(), ent.transform.rotation);
      }
    /*
      const x_changed = Math.abs(worldPos.x - inPos.x) > deltaDifference;
      const y_changed = Math.abs(worldPos.y - inPos.y) > deltaDifference;

      const new_x = x_changed ? ent.transform.x : inPos.x;
      const new_y = y_changed ? ent.transform.y : inPos.y;
      physicsBox.SetTransform( this.createBox2d_b2Vec2(new_x, new_y), ent.transform.rotation);
      //physicsBox.SetLinearVelocity(targetVelocity);
      physicsBox.SetAwake(1);
      */


    //ent.transform.x = localPos.x;
    //ent.transform.y = localPos.y;

  } else {
    ent.transform.__positionUpdated = false;
    const localPos = this.getLocalPosition(ent, inPos);
    ent.transform.x = localPos.x;
    ent.transform.y = localPos.y;
    this.conditionallySetDirty(ent);
  }


}

CreateSystems.prototype.updateAutoMove = function (dt, ent) {

  const totalLength = ent.autoMove.multi.length;

  for (let j = 0; j < totalLength; j++) {
    const o = ent.autoMove.multi[j];
    const autoMove = o.c;
    const component = o.component;

    if (!autoMove.__addComponents) {
      this.addComponent(ent, this.findSlots(ent, component, 'link'));
      autoMove.__addComponents = true;
    }

    if (ent.physicsbody2d) {
      ent.transform.__positionUpdated = true;
    }

    if (!autoMove.respectRotation) {
      ent.transform.x += this.getScalar(ent, autoMove.dx, autoMove) * dt/1000;
      ent.transform.y += this.getScalar(ent, autoMove.dy, autoMove) * dt/1000
    } else {
      const dx = this.getScalar(ent, autoMove.dx, autoMove) * dt/1000;
      const dy = this.getScalar(ent, autoMove.dy, autoMove) * dt/1000;
      ent.transform.x += Math.cos(ent.transform.rotation - 1*Math.PI/2) * dy;
      ent.transform.y += Math.sin(ent.transform.rotation - 1*Math.PI/2) * dy;
    }

  }


  this.conditionallySetDirty(ent);
}


CreateSystems.prototype.updateCollisions = function (dt) {
}


CreateSystems.prototype.updateOnDestroy = function (dt, ent) {
  if (!ent.onDestroy.activated) {
    return;
  }
  if (!ent.onDestroy.triggered) {
    this.addComponent(ent, this.findSlots(ent, ent.onDestroy));
    ent.onDestroy.triggered = true;
  }
}


CreateSystems.prototype.updateDestroy = function (dt, ent) {
  //console.log(ent.uuid.uuid, 'destroy')
  if (!ent._manager || !ent.uuid) {
    ent.remove();
    return;
  }

  if (ent.onDestroy && !ent.onDestroy.activated) {
    ent.onDestroy.activated = true;
    this.removeComponent(ent, this.Components.Destroy);
    return;
  }
//  this.debug.startSystem('updateDestroy', length);
  let destroyed = 0;
  const childrenToDestroy = [];

  const parentHack = [];
  const uuid = ent.uuid.uuid;

    // TODO: this is a hack, delete the parentEnt
    // in updateCreateToy
    if (ent.transform) {
      const childrenEnts = ent.transform.__children||[];
      const childrenEntTotals = childrenEnts.length;
      for (var j = 0; j < childrenEntTotals; j++) {
        const id = childrenEnts[j];
        const ent = this.entitiesByUuid[id];
        childrenToDestroy.push(ent);
      }
    }


    /*
    const childrenEnts = this.gameobjects.entities.queryTag('child-' + ent.uuid.uuid);
    for (var k = 0; k < childrenEnts.length; k++) {
      childrenToDestroy.push(childrenEnts[k]);
    }
    if (ent.parentUuid) {
      const parentEnts = this.gameobjects.entities.queryTag('parentEnt-' + ent.parentUuid);
      for (var k = 0; k < parentEnts.length; k++) {
        const ent = parentEnts[k];
        const childrenEnts = this.gameobjects.entities.queryTag('child-' + ent.uuid.uuid);
        // TODO: hack hack hack
        // should be === 0
        if (childrenEnts.length === 1) {
          //childrenToDestroy.push(ent);
          childrenToDestroy.push(ent);
        }
    
      }

    }
    */

  delete this.entitiesByUuid[ent.uuid.uuid];
  delete this.__propertiesCache[ent.uuid.uuid];
  //if (ent._manager) {
    ent.remove();
  //}
  //this.gameobjects.entities.removeEntity(ent);
  destroyed++;


  const childrenToDestroyLength = childrenToDestroy.length;
  for (var i = 0; i < childrenToDestroyLength; i++) {
    if (childrenToDestroy[i]) {
      childrenToDestroy[i].addComponent(this.Components.Destroy);
    }
  }
//  this.debug.stopSystem('updateDestroy');
}


CreateSystems.prototype.updateStopMovement = function (dt, ent) {
  if (ent.move && ent.stopMovement.revertToStart) {
    const startx = ent.move.startx - ent.move.dx * 0.1;
    const starty = ent.move.starty - ent.move.dy * 0.1;

    ent.transform.x = startx;
    ent.transform.y = starty;


    this.conditionallySetDirty(ent);
  }

  if (ent.physicsbody) {
    const physicsBoxes = this.physicsBoxes2D[ent.uuid.uuid];
    for (let k = 0; k < physicsBoxes.length; k++) {
      const physicsBox = physicsBoxes[k];
      physicsBox.SetLinearVelocity(
        this.createBox2d_b2Vec2(
            0,
            0
        ),
        physicsBox.GetWorldCenter()
      );
    }

  }

  this.addComponent(ent, this.findSlots(ent, ent.stopMovement, 'link'));

  this.removeComponent(ent, this.Components.Move);
  this.removeComponent(ent, this.Components.MoveTo);
  this.removeComponent(ent, this.Components.FollowPath);
  this.removeComponent(ent, this.Components.StopMovement);
  this.removeComponent(ent, this.Components.AutoMove);

}

CreateSystems.prototype.updateAllTransforms = function (dt) {
  if (!this.allTransformsHit) {
    this.allTransformsHit = {};
  }
  if (!this.allTransformsHitTimes) {
    this.allTransformsHitTimes = {};
  }
  const ents = this.gameobjects.entities.queryComponents([this.Components.AllTransforms]);
  const length = ents.length;
  for (let i = 0; i < length; i++) {
    const ent = ents[i];
    const key = ent.uuid.uuid;
    if (!this.allTransformsHit[key]) {
      this.allTransformsHit[key] = [];
    }
    if (!this.allTransformsHitTimes[key]) {
      this.allTransformsHitTimes[key] = 0;
    }
    this.allTransformsHitTimes[key] += dt;

    if (this.allTransformsHitTimes[key] < 200) {
      let allEnts = this.gameobjects.entities.queryComponents([this.Components.Transform, this.Components.Sprite]);
      allEnts = allEnts.concat(this.gameobjects.entities.queryComponents([this.Components.Transform, this.Components.GameText]));

      const allEntsLength = allEnts.length;
      const slots = this.findSlots(ent, ent.allTransforms);
      for (var j = 0; j < allEntsLength;j++) {
        const allEnt = allEnts[j];
        if (allEnt.hasTag('camera')) {
          continue;
        }
        //if (allEnt.hasTag('toyChild')) {
          //continue;
        //}
        const ignores = ent.allTransforms.ignore;
        let ignoreThis = false;
        for (var k = 0; k < ignores.length; k++) {
          const ignore = ignores[k];
          if (allEnt.hasTag(ignore)) {
            ignoreThis = true;
            break;
          }
        }
        if (ignoreThis) {
          continue;
        }
        const uuid = allEnt.uuid.uuid;
        if (!includes(this.allTransformsHit[key], uuid)) {
          this.addComponent(allEnt, slots);
          this.allTransformsHit[key].push(uuid);
        }
      }
    } else {
      this.removeComponent(ent, this.Components.AllTransforms);
      delete this.allTransformsHit[key];
      delete this.allTransformsHitTimes[key];
    }
  }
}

CreateSystems.prototype.updateSetProperties = function (dt, ent) {
  const root = this.findRoot();
  const totalLength = ent.setProperties.multi.length;

  let pairs = []
  for (let j = 0; j < totalLength; j++) {
    const o = ent.setProperties.multi[j];
    const c = o.c;
    const component = o.component;
    pairs = pairs.concat(toPairs(c.properties))
    this.addComponent(ent, this.findSlots(ent, component));
    this.multiRemoveComponent(ent, this.Components.SetProperties, c);
  }


  if (this.luaVm) {
    this.prepareGlobalAndLocalVariables(ent);
    const properties = this.getProperties(ent);
    for (let j = 0; j < pairs.length; j++) {
      let x;
      if (Array.isArray(pairs[j])) {
        x = pairs[j];
      } else {
        x = [pairs[j].name, pairs[j].value];
      }
    //toPairs(ent.changeProperties.properties).forEach( (x) => {
      const name = x[0];
      const value = this.getScalar(ent, x[1]);
      const asInt = parseFloat(value);
      if (!isNaN(asInt)) {
        properties[name] = asInt;
      } else {
        properties[name] = value;
      }
    }

    this.updateGlobalAndLocalVariables(ent, properties);
  }


}


CreateSystems.prototype.prepareGlobalAndLocalVariables = function (ent) {
  const variableView = ent.uuid.__variableView;
  const length = variableView.length;
  const propertiesCleared= {};
  for (let i = 0; i < length; i++) {
    const vv = variableView[i];
    const {key, uuid, name} = vv;
    if (!propertiesCleared[uuid]) {
      this.clearPropertiesCache(this.entitiesByUuid[uuid]);
      propertiesCleared[uuid] = true;
    }
  }
}

CreateSystems.prototype.storeVariable = function (ent, name, val) {
  this.gameobjects.storeVariable(`__pbc-${this.gameobjects.gameId}-${name}`, val);
}

CreateSystems.prototype.getVariable = function (ent, name, val) {
  const key = `__pbc-${this.gameobjects.gameId}-${name}`
  if (window.localStorage.getItem(key)) {
    return window.localStorage.getItem(key);
  }
  return null;
}

CreateSystems.prototype.shouldStoreVariable = function (ent, name) {
  if (this.gameobjects.variables[name]) {
    const v = this.gameobjects.variables[name];
    if (v.clear) {
      return true;
    } else {
      return false;
    }
  }
}

CreateSystems.prototype.updateGlobalAndLocalVariables = function (ent, properties) {
  const variableView = ent.uuid.__variableView;
  const length = variableView.length;
  const propertiesCleared= {};
  for (let i = 0; i < length; i++) {
    const vv = variableView[i];
    const {key, uuid, name} = vv;
    if (!propertiesCleared[uuid]) {
      this.clearPropertiesCache(this.entitiesByUuid[uuid]);
      propertiesCleared[uuid] = true;
    }
    if (typeof(properties[name]) !== 'undefined') {
      let prevVal = this.luaHeap[key];
      this.luaHeap[key] = properties[name];
      if (this.shouldStoreVariable(ent, name) && prevVal !== properties[name]) {
        this.storeVariable(ent, name, properties[name]);
      }
    }

  }

}

//function propertiesHandler(en
CreateSystems.prototype.updateChangeProperties = function (dt, ent) {
  const root = this.findRoot();
  const totalLength = ent.changeProperties.multi.length;

  let pairs = []
  for (let j = 0; j < totalLength; j++) {
    const o = ent.changeProperties.multi[j];
    const c = o.c;
    const component = o.component;
    pairs = pairs.concat(toPairs(c.properties))
    this.addComponent(ent, this.findSlots(ent, component));
    this.multiRemoveComponent(ent, this.Components.ChangeProperties, c);
  }

  if (this.luaVm) {
    this.prepareGlobalAndLocalVariables(ent);
    const properties = this.getProperties(ent);
    for (let j = 0; j < pairs.length; j++) {
      const x = pairs[j];
    //toPairs(ent.changeProperties.properties).forEach( (x) => {
      const name = x[0];
      const value = this.getScalar(ent, x[1]);
      const asInt = parseFloat(properties[name]) + parseFloat(value);
      if (!isNaN(asInt)) {
        properties[name] = asInt;
      } else {
        properties[name] = value;
      }
    }

    this.updateGlobalAndLocalVariables(ent, properties);


  }

}

CreateSystems.prototype.removeComponentManually = function (ent, c) {
  if (c.multi) {
    this.multiRemoveComponent(ent, c.__componentType, c)
  } else {
    this.gameobjects.debugLog({
      ent,
      component:{},
      type:'debug',
      line:`found comp to remove`
    })
    if (c.removeFunction) {
      c.removeFunction(this, this.gameobjects, c, ent);
    }
    ent.removeComponent(c.__componentType);
  }

}


CreateSystems.prototype.removeComponentFromDefinition = function (ent, component) {
  for (let compKey in ent) {
    const comp = ent[compKey];
    if (comp.multi) {
      for (let k = 0; k < comp.multi.length; k++) {
        const multi = comp.multi[k];
        if (multi.component.id === component.id) {
          this.multiRemoveComponent(ent, multi.componentType, multi.c);
        }
      }

    } else {
      if (comp.id === component.id) {
        this.removeComponent(ent, comp.__componentType);
      }
    }
  }
}

CreateSystems.prototype.updateRemoveComponent = function (dt, ent) {
  const totalLength = ent.removeComponentFromToy.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.removeComponentFromToy.multi[j];
    const c = o.c;
    const component = o.component;
    //const entity = this.Util.createEntityFromComponent(gameobjects, component);

    //removeComponent(ent, {__name:c.component});
    if (c.component && c.component !== ''){
      this.removeComponent(ent, this.Components[c.component]);
    }
    const slots = this.findSlots(ent, component, 'remove');
    const slotsTotal = slots.length;
    for (let j = 0; j < slotsTotal; j++) {
      const slot = slots[j];
      this.gameobjects.addDebug(ent, 'remove slot')
      let found = null;
      for (let compKey in ent) {
        const comp = ent[compKey];
        if (!comp.id && !comp.multi) {
          continue;
        }
        if (!comp) {
          this.gameobjects.debugLog({
            ent,
            component:{},
            type:'debug',
            line:`${compKey} has already been removed`
          })
          //console.warn(ent.uuid.uuid,'it was already removed');
          continue;
        }
        //this.debug.addDebugLine(ent, compKey + ': try to remove: ', slot.id, comp.id);
        if (comp.multi) {
          for (let k = 0; k < comp.multi.length; k++) {
            const multi = comp.multi[k];
            if (multi.component.id === slot.id) {
              found = multi.component;
              this.gameobjects.debugLog({
                ent,
                component:{},
                type:'debug',
                line:`${compKey} removing!`
              })
              this.gameobjects.addDebug(ent, compKey + ': removing', multi.c);
              this.multiRemoveComponent(ent, multi.componentType, multi.c);
            }
          }
          //this.multiRemoveComponent(ent, this.Components
        } else if (comp.id === slots[j].id) {
          found = comp;
          this.gameobjects.debugLog({
            ent,
            component:{},
            type:'debug',
            line:`found comp to remove`
          })
          this.removeComponent(ent, comp.__componentType)
        }
      }
      if (!found) {
        //this.gameobjects.debugLog({
          //ent,
          //component:{},
          //type:'debug',
          //line:`NOT removed`
        //})
      } else {
        this.gameobjects.debugLog({
          ent,
          component:{},
          type:'debug',
          line:`removed component ${found.type} - ${found.id}`
        })
      }
    }
    this.multiRemoveComponent(ent, this.Components.RemoveComponentFromToy, c);
  }
}


CreateSystems.prototype.beforeUpdatePath = function (dt) {
  this.pathHitKeys = [];
}
CreateSystems.prototype.afterUpdatePath = function (dt) {
  const hitKeys = this.pathHitKeys;
  if (this.__pathCacheLen !== hitKeys.length) {
    const toRemove = difference(keys(this.pathCache), hitKeys);
    const toRemoveLength = toRemove.length;
    for (let i = 0; i < toRemoveLength; i++) {
      delete this.pathCache[toRemove[i]];
      this.__pathCacheLen--;
    }
  }
}

CreateSystems.prototype.updatePath = function (dt, ent) {
  const uuid = ent.uuid.uuid;

  if (!ent.path.__addComponents) {
    const slots = this.findSlots(ent, ent.path);
    this.addComponent(ent, slots);
    ent.path.__addComponents = true;
  }

  if (!this.pathCache[uuid]) {
    const path = ent.path;
    const innerContainer = this.pixiContainers[uuid].inner;

    this.pathCache[uuid] = {
      path,
      innerContainer
    }
    this.__pathCacheLen++;
    path.created = true;

    this.createSceneGraphChildren(ent, ent.transform);
  }
  this.pathHitKeys.push(uuid);

}

CreateSystems.prototype.updatePoint = function (dt, ent) {
  if (!ent.point.__addComponents) {
    const slots = this.findSlots(ent, ent.point);
    this.addComponent(ent, slots);
    ent.point.__addComponents = true;
    this.createSceneGraphChildren(ent, ent.transform);
  }
}

CreateSystems.prototype.sceneGraphFind = function (ent, pred, upwards=true) {
  let found = ent._Components.filter( (C) => {
    return pred(C.__name, ent[C.__name]);
  });
  if (found.length) {
    return ent;
  } else {
    if (!upwards || !this.hasParent(ent)) {
      const tag = 'child-'+ent.uuid.uuid;
      const targetEntities = this.gameobjects.entities.queryTag(tag);
      const targetEntitiesLength = targetEntities.length;
      for (let i = 0; i < targetEntitiesLength; i++) {
        found = this.sceneGraphFind(targetEntities[i], pred, false)
        if (found) {
          return found
        }
      }

      
    } else {
      return this.sceneGraphFind(this.getEntityById(ent.uuid.parentTransform), pred);
    }
  }
}


CreateSystems.prototype.updateFollowPath = function (dt, ent) {
  const knots = [
    0, 0, 0, 1, 2, 2, 2
  ];
  const degree = 2;

  const uuid = ent.uuid.uuid;
  const followPath = ent.followPath;
  if (!ent.followPath.started) {
    const thePathEnt = this.sceneGraphFind(ent, (type, c) => {
      return type === 'path' && c.componentId === followPath.pathId;
      //return c.type === 'path' && c.componentId = followPath.pathId;
    });

    const slots = this.findSlots(ent, ent.followPath, 'link');
    this.addComponent(ent, slots);

    if (thePathEnt) {

      this.reparent(ent,thePathEnt); 

      ent.followPath.path = thePathEnt.path;
      ent.followPath.started = true;
      this.addComponent(ent, this.findSlots(ent, ent.followPath, 'begin'));

      const normalName = 'start-curve-' + ent.followPath.curCurve;
      const flipName = ent.followPath.direction + '-start-curve-' + ent.followPath.curCurve;
      const slots = this.findSlots(ent, ent.followPath, [normalName, flipName]);
      this.addComponent(ent, slots);

    } else {
      //console.warn('didnt find path for', ent);
      return;
    }
  }




  if (Math.abs(ent.followPath.t) < 0.01 || Math.abs(ent.followPath.t - ent.followPath.speed) < 0.01) {
  }
  const path = ent.followPath.path;
  const edge = ent.followPath.path.edges[ent.followPath.curCurve];

  let point, nextPoint;
  let t = this.applyTween(ent.followPath.tween || 'linear', ent.followPath.t / ent.followPath.speed);
  const nextT = Math.min(1, t + 0.05);
  if (edge.type === 'bspline') {
    const points = [
      [edge.p1.x, edge.p1.y],
      [edge.cps[0].x, edge.cps[0].y], 
      [edge.cps[1].x, edge.cps[1].y],
      [edge.p2.x, edge.p2.y]
    ];
    point = bspline(t, degree, points, knots);
    nextPoint = bspline(nextT, degree, points, knots);
    //point[0] += edge.p1.x;
    //point[1] += edge.p1.y;
  } else {
    point = [
      edge.p1.x + t * (edge.p2.x - edge.p1.x),
      edge.p1.y + t * (edge.p2.y - edge.p1.y)
    ];
    nextPoint = [
      edge.p1.x + nextT * (edge.p2.x - edge.p1.x),
      edge.p1.y + nextT * (edge.p2.y - edge.p1.y)
    ];

  }


  const x = point[0];
  const y = point[1];

  ent.transform.x = x;
  ent.transform.y = y;

  if (ent.followPath.changeAngle) {
    const angle = Math.atan2(nextPoint[1] - point[1], nextPoint[0] - point[0]) + Math.PI/2 + ent.followPath.offsetAngle;
    ent.transform.rotation = angle;
  }

  //const angle = Math.atan2(point[1] - nextPoint[1], point[0] - nextPoint[0]);

  if (ent.followPath.direction === 'forward') {
    ent.followPath.t += dt/1000;
    if (ent.followPath.t > ent.followPath.speed) {
      const normalName = 'finish-curve-' + ent.followPath.curCurve;
      const flipName = 'forward-finish-curve-' + ent.followPath.curCurve;
      this.addComponent(ent, this.findSlots(ent, ent.followPath, [normalName, flipName]));

      ent.followPath.curCurve++;
      ent.followPath.t = 0;
      if (ent.followPath.curCurve >= ent.followPath.path.edges.length) {
        this.addComponent(ent, this.findSlots(ent, ent.followPath, 'finish'));
        if (!ent.followPath.flip) {
          this.removeComponent(ent, this.Components.FollowPath);
        } else {
          ent.followPath.direction = 'backward';
          ent.followPath.t = ent.followPath.speed;
          ent.followPath.started = false;
          ent.followPath.curCurve = ent.followPath.path.edges.length-1;
        }
      }
    }

  }
  if (ent.followPath && ent.followPath.direction === 'backward') {
    ent.followPath.t -= dt/1000;
    if (ent.followPath.t < 0) {
      const normalName = 'finish-curve-' + ent.followPath.curCurve;
      const flipName = 'backward-finish-curve-' + ent.followPath.curCurve;
      this.addComponent(ent, this.findSlots(ent, ent.followPath, [normalName, flipName]));
      //return l.name === 'finish-curve-' + ent.followPath.curCurve 
      //|| l.name === 'forward-finish-curve-' + ent.followPath.curCurve
      //}));

      ent.followPath.curCurve--
      ent.followPath.t = 1;
      if (ent.followPath.curCurve < 0) {
        this.addComponent(ent, this.findSlots(ent, ent.followPath, 'finish'));
        if (!ent.followPath.flip) {
          this.removeComponent(ent, this.Components.FollowPath);
        } else {
          ent.followPath.direction = 'forward';
          ent.followPath.t = 0;
          ent.followPath.started = false;
          ent.followPath.curCurve = 0;
        }
      }
    }
  }

  this.conditionallySetDirty(ent);
}

CreateSystems.prototype.updateLimitProperties = function (dt, ent) {
  const root = this.findRoot();
  const totalLength = ent.limitProperties.multi.length;

  let limits = []
  for (let j = 0; j < totalLength; j++) {
    const o = ent.limitProperties.multi[j];
    const c = o.c;
    const component = o.component;
    limits = limits.concat(c.properties);
    this.addComponent(ent, this.findSlots(ent, component));
    this.multiRemoveComponent(ent, this.Components.LimitProperties, c);
  }

  if (this.luaVm) {
    this.prepareGlobalAndLocalVariables(ent);
    const properties = this.getProperties(ent);
    for (let j = 0; j < limits.length; j++) {
      let {limitMaximum, limitMinimum, wrapMaximum, wrapMinimum, maximum, minimum, name} = limits[j];
      minimum = parseFloat(this.getScalar(ent, minimum));
      maximum = parseFloat(this.getScalar(ent, maximum));
      if (limitMinimum) {
        if (parseFloat(properties[name]) < minimum) {
          if (wrapMinimum) {
            properties[name] = maximum;
          } else {
            properties[name] = minimum;
          }
        }
      }
      if (limitMaximum) {
        if (parseFloat(properties[name]) > maximum) {
          if (wrapMaximum) {
            properties[name] = minimum;
          } else {
            properties[name] = maximum;
          }
        }
      }
    }

    this.updateGlobalAndLocalVariables(ent, properties);


  }

}

CreateSystems.prototype.publishProperties = function (dt) {
  const ents = this.gameobjects.entities.queryComponents([this.Components.Properties]);
  const length = ents.length;
  for (let i = 0; i < length; i++) {
    const ent = ents[i];
  }

}

CreateSystems.prototype.checkGoal = function (dt, ent) {
  const win = ent.goal.win;
  const lose = ent.goal.lose;

  const root = this.findRoot();
  const props = this.getProperties(ent);
  if (root && props) {
    const winPropertyValue = props[win.property];
    const losePropertyValue = props[lose.property];
    if (parseFloat(winPropertyValue) >= parseFloat(win.target)) {
        this.gameobjects.setGameState('win');
        this.emitEvent(ent, 'win');
        this.removeComponent(ent, this.Components.Goal);
    }  else if (parseFloat(losePropertyValue) <= parseFloat(lose.target)) {
        this.emitEvent(ent, 'lose');
        this.gameobjects.setGameState('lose');
        this.removeComponent(ent, this.Components.Goal);
    }
  }
}

CreateSystems.prototype.updateCreateEntities = function (dt) {
return;
  const ents = this.gameobjects.entities.queryComponents([this.Components.CreateEntity, this.Components.Transform]);
  const length = ents.length;
//  this.debug.startSystem('updateCreateEntities', length);
  for (let i = 0; i < length; i++) {
  }
//  this.debug.stopSystem('updateCreateEntities');

}
CreateSystems.prototype.getToySlots = function (ent, component, lst) {
  //if (!ent.hasTag('toyChild') && !ent.hasTag('toyParent')) {
    //return [];
  //}
  const cid = component.id;
  const key = ent.uuid.uuid + '-' + cid;

  const wtf = this.toySlotsData[key] || [];
  for (let j = 0; j < wtf.length; j++) {
    lst.push(wtf[j]);
  }

  if (this.hasParent(ent)) {
    this.getToySlots(this.getEntityById(ent.uuid.parentTransform), component, lst);
  }

}
CreateSystems.prototype.addSlotsToToy = function (ent, newEnt, component) {
  const mySlots = this.findSlots(ent, component, undefined,undefined,true);

  for (var q = 0; q < mySlots.length; q++) {
    const {link,component} = mySlots[q];

    if (!link.meta || !link.meta.cid) {
      // slot is not overriden i guess??
      continue;
    }

    const myLinks = [link];
    const myComponents = [component];

    const key = newEnt.uuid.uuid + '-' + link.meta.cid;
    if (!this.toySlotsData[key]) {
      this.toySlotsData[key] = [];
    }
    this.toySlotsData[key].push(component);
  }
}
CreateSystems.prototype.getParent = function (ent) {
  if (this.hasParent(ent)) {
    return this.getEntityById(ent.uuid.parentTransform);
  }
}
CreateSystems.prototype.setVariableOverrides = function (ent, overrides) {
  //newEnt.__overrideVariables = cloneDeep(component.overrideVariables);
  const parent = this.getParent(ent);
  ent.uuid.__overrideVariables = Object.assign({}, parent ? parent.uuid.__overrideVariables : {}, overrides);
}
CreateSystems.prototype.setTransformOverrides = function (ent, overrides) {
  const parent = this.getParent(ent);
  ent.uuid.__overrideTransforms = Object.assign({}, parent ? parent.uuid.__overrideTransforms : {}, overrides);
}
CreateSystems.prototype.updateCreateToys = function (dt, ent) {
  if (!this.crappyCounter) {
    this.crappyCounter = 0;
  }
  this.crappyCounter += 1;
  const totalLength = ent.createToy.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.createToy.multi[j];
    const c = o.c;
    const component = o.component;

    let toy;
    for (let k = 0; k < this.gameobjects.toybox.length; k++) {
      const t = this.gameobjects.toybox[k];
      if (t.id === component.tid) {
        toy = t;
      }
    }

    if (!toy) {
      //console.error('cannot find toy', component.tid);
      return;
    }

    let parentEnt = ent;
    this.clearPropertiesCache(ent);
    if (c.unparent) {
      //console.warn('fix this, should not be used anymore. rather try set transform.unparent to true?');
      //throw new Error('not sure what this should do anymore');
      parentEnt = this.gameobjects.entities.createEntity();
      this.createUuid(parentEnt);
      this.addComponent(parentEnt, this.findSlots(ent, component, 'links'))
    }
    //parentEnt.addTag(toy.name);

    const t = this.identityTransform({transform:ent.transform});
    if (c.unparent) {
      this.createSceneGraph(parentEnt, t, ent, c.unparent);
    }
    //this.updateTransformProps(ent, this.nameSpaceVariables(ent, toy.variables));
    this.setVariableOverrides(ent, component.overrideVariables);
    this.setTransformProps(ent, toy.variables || [], this.getParent(ent));
    if (toy.transforms.length > 1) {
      if (!c.unparent) {
        this.createSceneGraphChildren(parentEnt, ent.transform, false);
      }
      for (var k = 0; k < toy.transforms.length; k++) {
        const transform = toy.transforms[k];

        const newEnt = this.gameobjects.entities.createEntity();
        this.createUuid(newEnt);

        // TODO: here
        ent.uuid.__overrideLayer = ent.transform.layer;
        this.setTransformOverrides(newEnt, component.overrides);
        this.createSceneGraph(newEnt, transform, ent);

        //this.addComponent(ent, this.findSlots(ent, component, 'link'))
        if (c.unparent) {
          this.addComponent(newEnt, this.findSlots(ent, component, 'link'))
        } else {
          this.addComponent(ent, this.findSlots(ent, component, 'link'))
        }

        this.addSlotsToToy(ent, newEnt, component);

      }
    } else {
        const transform = toy.transforms[0];
        let variables = [];
        const newEnt = ent;

        // TODO: here
        ent.uuid.__overrideLayer = ent.transform.layer;
        this.setTransformOverrides(newEnt, component.overrides);

        const children = this.createSceneGraphChildren(newEnt, {children:toy.transforms}, false);
        //this.setTransformOverrides(children[0], component.overrides);
 
        this.createSceneGraphChildren(children[0], ent.transform, false);
        //this.createSceneGraphChildren(children[0], ent.transform, false);
        // apply my transform to newEnt as its the only child
        newEnt.transform.alpha = ent.transform.alpha;
        ent.transform.alpha = 1;
        this.addComponent(children[0], this.findSlots(ent, component, 'link'))

        this.addSlotsToToy(ent, newEnt, component);
    }

    //const newEnt = this.gameobjects.entities.createEntity();
    //this.Components.Uuid.create(newEnt);
    //this.Components.TransformGraphCreate.create(newEnt, toy);

    this.multiRemoveComponent(ent, this.Components.CreateToy, c);

  }
//  this.debug.stopSystem('updateCreateToys');

}
CreateSystems.prototype.updateCreateFeatures = function (dt, ent) {
  const totalLength = ent.createFeature.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.createFeature.multi[j];
    const createFeature = o.c;
    const component = o.component;
    // add the standard features
    this.addComponent(ent, this.findSlots(ent, component, 'link'))

    let links,components,root,feature,variables;
    if (createFeature.builtin) {
      links = createFeature.builtin.links;
      components = createFeature.builtin.components;
      root = createFeature.builtin.root;
      feature = createFeature.builtin;
      variables = createFeature.variables;
    } else {
      for (let k = 0; k < this.gameobjects.features.length; k++) {
        const f = this.gameobjects.features[k];
        if (f.id === createFeature.fid) {
          links = f.links;
          components = f.components;
          root = f.root;
          feature = f;
          variables = f.variables;
        }
      }
    }
    if (!feature) {
      //console.warn(`could not find feature ${createFeature.fid}`);
      this.multiRemoveComponent(ent, this.Components.CreateFeature, createFeature);
      continue;
    }
    this.gameobjects.debugLog({
      ent,
      component:{},
      type:'debug',
      line:`Add feature ${feature.name}`
    })

    this.addFeatureSlots(ent, components, links, root);
    const rootSlots = this.findSlots(ent, root);
    this.addComponent(ent, this.findSlots(ent, root));

    const mySlots = this.findSlots(ent, component, undefined,undefined,true);

    for (var k = 0; k < mySlots.length; k++) {
      const {link,component} = mySlots[k];

      const myLinks = [link];
      const myComponents = [component];

      const key = ent.uuid.uuid + '-' + link.meta.cid;
      if (!this.featureSlotData[key]) {
        this.featureSlotData[key] = [];
      }
      this.featureSlotData[key].push(component);

    }

    this.updateTransformProps(ent, this.nameSpaceVariables(ent, variables || []));
    this.updateTransformProps(ent, createFeature.component.variableValues);

    this.multiRemoveComponent(ent, this.Components.CreateFeature, createFeature);

  }

}


CreateSystems.prototype.updateSlots = function (dt, ent) {
  const uuid = ent.uuid.uuid;
  const totalLength = ent.slot.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.slot.multi[j];
    const cid = o.component.id;
    const key = uuid + '-' + cid;

    this.addComponent(ent, this.featureSlotData[key] || []);
    const toySlots = [];
    this.getToySlots(ent, o.component, toySlots);
    this.addComponent(ent, toySlots);
    this.multiRemoveComponent(ent, this.Components.Slot, o.c);
  }

}

CreateSystems.prototype.updateRemoveComponent = function (dt, ent) {
  const totalLength = ent.removeComponentFromToy.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.removeComponentFromToy.multi[j];
    const c = o.c;
    const component = o.component;
    //const entity = this.Util.createEntityFromComponent(gameobjects, component);

    //removeComponent(ent, {__name:c.component});
    if (c.component && c.component !== ''){
      this.removeComponent(ent, this.Components[c.component]);
    }
    const slots = this.findSlots(ent, component, 'remove');
    const slotsTotal = slots.length;
    for (let j = 0; j < slotsTotal; j++) {
      const slot = slots[j];
      this.gameobjects.addDebug(ent, 'remove slot')
      let found = null;
      for (let compKey in ent) {
        const comp = ent[compKey];
        if (!comp.id && !comp.multi) {
          continue;
        }
        if (!comp) {
          this.gameobjects.debugLog({
            ent,
            component:{},
            type:'debug',
            line:`${compKey} has already been removed`
          })
          //console.warn(ent.uuid.uuid,'it was already removed');
          continue;
        }
        //this.debug.addDebugLine(ent, compKey + ': try to remove: ', slot.id, comp.id);
        if (comp.multi) {
          for (let k = 0; k < comp.multi.length; k++) {
            const multi = comp.multi[k];
            if (multi.component.id === slot.id) {
              found = multi.component;
              this.gameobjects.debugLog({
                ent,
                component:{},
                type:'debug',
                line:`${compKey} removing!`
              })
              this.gameobjects.addDebug(ent, compKey + ': removing', multi.c);
              this.multiRemoveComponent(ent, multi.componentType, multi.c);
            }
          }
          //this.multiRemoveComponent(ent, this.Components
        } else if (comp.id === slots[j].id) {
          found = comp;
          this.gameobjects.debugLog({
            ent,
            component:{},
            type:'debug',
            line:`found comp to remove`
          })
          this.removeComponent(ent, comp.__componentType)
        }
      }
      if (!found) {
        //this.gameobjects.debugLog({
          //ent,
          //component:{},
          //type:'debug',
          //line:`NOT removed`
        //})
      } else {
        this.gameobjects.debugLog({
          ent,
          component:{},
          type:'debug',
          line:`removed component ${found.type} - ${found.id}`
        })
      }
    }
    this.multiRemoveComponent(ent, this.Components.RemoveComponentFromToy, c);
  }
}


CreateSystems.prototype.beforeUpdatePath = function (dt) {
  this.pathHitKeys = [];
}
CreateSystems.prototype.afterUpdatePath = function (dt) {
  const hitKeys = this.pathHitKeys;
  if (this.__pathCacheLen !== hitKeys.length) {
    const toRemove = difference(keys(this.pathCache), hitKeys);
    const toRemoveLength = toRemove.length;
    for (let i = 0; i < toRemoveLength; i++) {
      delete this.pathCache[toRemove[i]];
      this.__pathCacheLen--;
    }
  }
}

CreateSystems.prototype.updatePath = function (dt, ent) {
  const uuid = ent.uuid.uuid;

  if (!ent.path.__addComponents) {
    const slots = this.findSlots(ent, ent.path);
    this.addComponent(ent, slots);
    ent.path.__addComponents = true;
  }

  if (!this.pathCache[uuid]) {
    const path = ent.path;
    const innerContainer = this.pixiContainers[uuid].inner;

    this.pathCache[uuid] = {
      path,
      innerContainer
    }
    this.__pathCacheLen++;
    path.created = true;

    this.createSceneGraphChildren(ent, ent.transform);
  }
  this.pathHitKeys.push(uuid);

}


CreateSystems.prototype.reparent = function (ent, newParentEnt) {
/*
      outer:container,
      parent:parentContainer,
      inner:innerContainer,
      */

  let {inner, outer, parent, unparent} = this.pixiContainers[ent.uuid.uuid];

  if (!newParentEnt.hasTag('root')) {
    this.conditionallySetDirty(newParentEnt);
  }

  if (unparent) {
    //this
    if (newParentEnt.hasTag('root')) {
      //donothing
    } else {
      // TODO: i dont know why this works :(
      parent.removeChild(outer);

      const newParentContainers = this.pixiContainers[newParentEnt.uuid.uuid];
      newParentContainers.outer.addChild(outer);

      this.pixiContainers[ent.uuid.uuid].parent = newParentContainers.outer;

      ent.uuid.parentTransform = newParentEnt.uuid.uuid;
      this.conditionallySetDirty(ent);
    }
    
  } else {
    if (newParentEnt.hasTag('root')) {
      // set worldpos
      const worldPos = this.getWorldPosition(ent)
      const worldScale = this.getWorldScale(ent);
      ent.transform.x = worldPos.x;
      ent.transform.y = worldPos.y;
      ent.transform.scale.x = worldScale.x / ent.transform.localScale.x;
      ent.transform.scale.y = worldScale.y / ent.transform.localScale.y;

      parent.removeChild(outer);
      this.cameraContainer.addChild(outer);
      this.pixiContainers[ent.uuid.uuid].parent = this.cameraContainer;
      ent.uuid.parentTransform = newParentEnt.uuid.uuid;

      this.conditionallySetDirty(ent);

    } else {
      parent.removeChild(outer);

      const newParentContainers = this.pixiContainers[newParentEnt.uuid.uuid];
      newParentContainers.outer.addChild(outer);

      this.pixiContainers[ent.uuid.uuid].parent = newParentContainers.outer;

      ent.uuid.parentTransform = newParentEnt.uuid.uuid;
      this.conditionallySetDirty(ent);
    }
  }


  // TODO: remove the child- tags

}



CreateSystems.prototype.updateFollowPath = function (dt, ent) {
  const knots = [
    0, 0, 0, 1, 2, 2, 2
  ];
  const degree = 2;

  const uuid = ent.uuid.uuid;
  const followPath = ent.followPath;
  if (!ent.followPath.started) {
    const thePathEnt = this.sceneGraphFind(ent, (type, c) => {
      return type === 'path' && c.componentId === followPath.pathId;
      //return c.type === 'path' && c.componentId = followPath.pathId;
    });

    const slots = this.findSlots(ent, ent.followPath, 'link');
    this.addComponent(ent, slots);

    if (thePathEnt) {

      this.reparent(ent,thePathEnt); 

      ent.followPath.path = thePathEnt.path;
      ent.followPath.started = true;
      this.addComponent(ent, this.findSlots(ent, ent.followPath, 'begin'));

      const normalName = 'start-curve-' + ent.followPath.curCurve;
      const flipName = ent.followPath.direction + '-start-curve-' + ent.followPath.curCurve;
      const slots = this.findSlots(ent, ent.followPath, [normalName, flipName]);
      this.addComponent(ent, slots);

    } else {
      //console.warn('didnt find path for', ent);
      return;
    }
  }




  if (Math.abs(ent.followPath.t) < 0.01 || Math.abs(ent.followPath.t - ent.followPath.speed) < 0.01) {
  }
  const path = ent.followPath.path;
  const edge = ent.followPath.path.edges[ent.followPath.curCurve];

  let point, nextPoint;
  let t = this.applyTween(ent.followPath.tween || 'linear', ent.followPath.t / ent.followPath.speed);
  const nextT = Math.min(1, t + 0.05);
  if (edge.type === 'bspline') {
    const points = [
      [edge.p1.x, edge.p1.y],
      [edge.cps[0].x, edge.cps[0].y], 
      [edge.cps[1].x, edge.cps[1].y],
      [edge.p2.x, edge.p2.y]
    ];
    point = bspline(t, degree, points, knots);
    nextPoint = bspline(nextT, degree, points, knots);
    //point[0] += edge.p1.x;
    //point[1] += edge.p1.y;
  } else {
    point = [
      edge.p1.x + t * (edge.p2.x - edge.p1.x),
      edge.p1.y + t * (edge.p2.y - edge.p1.y)
    ];
    nextPoint = [
      edge.p1.x + nextT * (edge.p2.x - edge.p1.x),
      edge.p1.y + nextT * (edge.p2.y - edge.p1.y)
    ];

  }


  const x = point[0];
  const y = point[1];

  ent.transform.x = x;
  ent.transform.y = y;

  if (ent.followPath.changeAngle) {
    const angle = Math.atan2(nextPoint[1] - point[1], nextPoint[0] - point[0]) + Math.PI/2 + ent.followPath.offsetAngle;
    ent.transform.rotation = angle;
  }

  //const angle = Math.atan2(point[1] - nextPoint[1], point[0] - nextPoint[0]);

  if (ent.followPath.direction === 'forward') {
    ent.followPath.t += dt/1000;
    if (ent.followPath.t > ent.followPath.speed) {
      const normalName = 'finish-curve-' + ent.followPath.curCurve;
      const flipName = 'forward-finish-curve-' + ent.followPath.curCurve;
      this.addComponent(ent, this.findSlots(ent, ent.followPath, [normalName, flipName]));

      ent.followPath.curCurve++;
      ent.followPath.t = 0;
      if (ent.followPath.curCurve >= ent.followPath.path.edges.length) {
        this.addComponent(ent, this.findSlots(ent, ent.followPath, 'finish'));
        if (!ent.followPath.flip) {
          this.removeComponent(ent, this.Components.FollowPath);
        } else {
          ent.followPath.direction = 'backward';
          ent.followPath.t = ent.followPath.speed;
          ent.followPath.started = false;
          ent.followPath.curCurve = ent.followPath.path.edges.length-1;
        }
      }
    }

  }
  if (ent.followPath && ent.followPath.direction === 'backward') {
    ent.followPath.t -= dt/1000;
    if (ent.followPath.t < 0) {
      const normalName = 'finish-curve-' + ent.followPath.curCurve;
      const flipName = 'backward-finish-curve-' + ent.followPath.curCurve;
      this.addComponent(ent, this.findSlots(ent, ent.followPath, [normalName, flipName]));
      //return l.name === 'finish-curve-' + ent.followPath.curCurve 
      //|| l.name === 'forward-finish-curve-' + ent.followPath.curCurve
      //}));

      ent.followPath.curCurve--
      ent.followPath.t = 1;
      if (ent.followPath.curCurve < 0) {
        this.addComponent(ent, this.findSlots(ent, ent.followPath, 'finish'));
        if (!ent.followPath.flip) {
          this.removeComponent(ent, this.Components.FollowPath);
        } else {
          ent.followPath.direction = 'forward';
          ent.followPath.t = 0;
          ent.followPath.started = false;
          ent.followPath.curCurve = 0;
        }
      }
    }
  }

  this.conditionallySetDirty(ent);
}




CreateSystems.prototype.applyTween = function (tweenName, t, finalValue) {
  const tweenFunc = Tweens[tweenName];

  // just scale it to [0,1] for 1 second - we are just using it for t;
  return tweenFunc(t, 0, 1, 1);

}

CreateSystems.prototype.hasTween = function (ent, props) {
  if (!ent.tween) {
    return false;
  }
  for (let i = 0; i < ent.tween.multi.length; i++) {
    const o = ent.tween.multi[i];
    const entTween = o.c;
    const tweensLength = entTween.tweens.length;
    for (let j = 0; j < tweensLength; j++) {
      const tween = entTween.tweens[j];
      const prop = tween.property;

      if (props.includes(prop)) {
        return true;
      }

    }
  }
  return false;
}
CreateSystems.prototype.setPhysicsBodyAwake = function (ent) {
  if (!ent.physicsbody2d) {
    return;
  }
  const uuid = ent.uuid.uuid;
  const physicsBoxes = this.physicsBoxes2D[uuid];
  for (let i = 0; i < physicsBoxes.length; i++) {
    const physicsBox = physicsBoxes[i];
    physicsBox.SetAwake(1);
    // lol
    this.endOfFrame.push( () => {
      physicsBox.SetAwake(1);
      // TODO: wtf :-(
      if (ent.transform) {
        ent.transform.__positionUpdated = false;
      }
    });
  }
  this.forceSetDirty(ent);
  this.markPhysicsBodyAsChanged(ent);
}

CreateSystems.prototype.markPhysicsBodyAsChanged = function (ent) {
  if (ent.physicsbody2d) {
    ent.transform.__positionUpdated = true;
  }
}
CreateSystems.prototype.updateTween = function (dt, ent) {

  const totalLength = ent.tween.multi.length;
  for (let z = 0; z < totalLength; z++) {
    const o = ent.tween.multi[z];
    const entTween = o.c;
    const component = o.component;

    const tweensLength = entTween.tweens.length;
    let t;

    if (entTween.startDelayTime >= entTween.startDelay) {
      if (!entTween.startedAfterDelay) {
        entTween.t = entTween.startDelayTime - entTween.startDelay;
        this.addComponent(ent, this.findSlots(ent, component, 'start'));
        entTween.startedAfterDelay = true;
      }

      if (entTween.direction === 'forward') {
        entTween.t += dt / 1000;
      } else if (entTween.direction === 'backward') {
        entTween.t -= dt / 1000;
      }
    }

    entTween.startDelayTime += dt/1000;

    if (entTween.direction === 'forward' && entTween.t < 0) {
      continue;
    } else if (entTween.direction === 'backward' && entTween.t > entTween.time) {
      continue;
    }

    for (let j = 0; j < tweensLength; j++) {
      const tween = entTween.tweens[j];

      const prop = tween.property;
      const fromValue = tween.from;
      const toValue = tween.to;
      const diffValue = toValue - fromValue;

      if (!entTween.started) {
        entTween.originalTransform = {
        }
        entTween.originalTransform.x = ent.transform.x;
        entTween.originalTransform.y = ent.transform.y;
        entTween.originalTransform.localScale = {
          x:ent.transform.localScale.x,
          y:ent.transform.localScale.y
        }
        entTween.originalTransform.scale = {
          x:ent.transform.scale.x,
          y:ent.transform.scale.y,
        }
        entTween.originalTransform.alpha = ent.transform.alpha;
        entTween.originalTransform.rotation = 0;
        entTween.originalTransform.localRotation = 0;
        entTween.started = true;
      }

      // This flag gets set when we are marked as finished
      // by the removeFunction... we need to reset the
      // appearance ?
      if (entTween.finished) {
        if (!entTween.flip) {
          entTween.t = entTween.time;
          entTween.direction = 'forward';
        } else {
          if (entTween.direction === 'forward') {
            entTween.direction = 'backward';
          }
          entTween.t = 0;
        }
      }
      if (entTween.direction === 'forward') {
        const x = entTween.t / entTween.time;
        t = this.applyTween(tween.tween || 'linear', Math.min(1,x));
      } else if (entTween.direction === 'backward') {
        const x = entTween.t / entTween.time;
        t = this.applyTween(tween.tween || 'linear', Math.max(0,x));
      }

      const newValue = fromValue + diffValue * t;
      if (prop === 'x') {
        if (typeof(entTween.startx) === 'undefined') {
          entTween.startx = ent.transform.x;
        }
        ent.transform.x = entTween.originalTransform.x + newValue;
        this.markPhysicsBodyAsChanged(ent);
      } else if (prop === 'y') {
        if (typeof(entTween.starty) === 'undefined') {
          entTween.starty = ent.transform.y;
        }
        ent.transform.y = entTween.originalTransform.y + newValue;
        this.markPhysicsBodyAsChanged(ent);

      } else if (prop === 'scaleboth') {
        ent.transform.localScale.x = newValue * entTween.originalTransform.localScale.x;
        ent.transform.localScale.y = newValue * entTween.originalTransform.localScale.y;
        //this.markPhysicsBodyAsChanged(ent);
      } else if (prop === 'scalex') {
        ent.transform.localScale.x = newValue * entTween.originalTransform.localScale.x;
        //this.markPhysicsBodyAsChanged(ent);
      } else if (prop === 'scaley') {
        ent.transform.localScale.y = newValue * entTween.originalTransform.localScale.y;
        //this.markPhysicsBodyAsChanged(ent);
      } else if (prop === 'scaleglobalx') {
        ent.transform.scale.x = newValue * entTween.originalTransform.scale.x;
      } else if (prop === 'scaleglobaly') {
        ent.transform.scale.y = newValue * entTween.originalTransform.scale.y;
      } else if (prop === 'scalebothglobal') {
        ent.transform.scale.x = newValue * entTween.originalTransform.scale.x;
        ent.transform.scale.y = newValue * entTween.originalTransform.scale.y;
        //this.markPhysicsBodyAsChanged(ent);
      } else if (prop === 'scalebothglobalabs') {
        ent.transform.scale.x = newValue
        ent.transform.scale.y = newValue
        //this.markPhysicsBodyAsChanged(ent);
      } else if (prop === 'scalebothabs') {
        ent.transform.localScale.x = newValue
        ent.transform.localScale.y = newValue
        //this.markPhysicsBodyAsChanged(ent);
      } else if (prop === 'scalexabs') {
        ent.transform.localScale.x = newValue
        //this.markPhysicsBodyAsChanged(ent);
      } else if (prop === 'scaleyabs') {
        ent.transform.localScale.y = newValue
        //this.markPhysicsBodyAsChanged(ent);
      } else if (prop === 'scalexglobalabs') {
        ent.transform.scale.x = newValue
        //this.markPhysicsBodyAsChanged(ent);
      } else if (prop === 'scaleyglobalabs') {
        ent.transform.scale.y = newValue
        //this.markPhysicsBodyAsChanged(ent);
      } else if (prop === 'alpha') {
        ent.transform.alpha = newValue;
      } else if (prop === 'circleStartAngle') {
        ent.circle.startAngle = newValue;
      } else if (prop === 'circleEndAngle') {
        ent.circle.endAngle = newValue;
      } else if (prop === 'rotation') {
        if (entTween.v2) {
          const rads = newValue*(Math.PI/180) + entTween.originalTransform[prop];
          ent.transform.rotation = rads;
        } else {
          const rads = newValue + entTween.originalTransform[prop];
          ent.transform.rotation = rads;
        }
        this.markPhysicsBodyAsChanged(ent);
        //ent.transform.__positionUpdated2 = true;
      } else if (prop === 'text') {
        ent.gameText.text = '' + Math.floor(newValue);
        ent.gameText.templateFunc = template(''+Math.floor(newValue), extend({},{
          interpolate:/{{([\s\S]+?)}}/g
        }));
      } else if (prop === 'zindex') {
        ent.transform.zIndex = parseInt(Math.floor(newValue + 0.5))
        this.setZindex(ent, ent.transform.zIndex);
      } else {
        ent.transform[prop] = newValue + entTween.originalTransform[prop];
      }

    }

    if (entTween.direction === 'forward') {
      if (entTween.t >= entTween.time) {
        this.setPhysicsBodyAwake(ent);
        if (entTween.flip) {
          entTween.t = entTween.time + entTween.flipDelay;
          entTween.direction = 'backward';
          if (entTween.loop) {
            this.addComponent(ent, this.findSlots(ent, component, 'finish'));
          }
        } else if (entTween.loop) {
          entTween.t = 0 - entTween.loopDelay;
          entTween.direction = 'forward';
          this.addComponent(ent, this.findSlots(ent, component, 'start'));
          this.addComponent(ent, this.findSlots(ent, component, 'finish'));
        } else {
          this.setPhysicsBodyAwake(ent);
          this.addComponent(ent, this.findSlots(ent, component, 'finish'));
          entTween.finished = true;
          this.multiRemoveComponent(ent, this.Components.Tween, entTween);
        }

      }

    } else if (entTween.direction === 'backward') {


      if (entTween.t <= 0) {
        if (!entTween.loop) {
          this.setPhysicsBodyAwake(ent);
          this.addComponent(ent, this.findSlots(ent, component, 'finish'));
          entTween.finished = true;
          this.multiRemoveComponent(ent, this.Components.Tween, entTween);
        } else {
          if (entTween.flip) {
            if (!entTween.loop) {
              this.addComponent(ent, this.findSlots(ent, component, 'finish'));
            }
            this.addComponent(ent, this.findSlots(ent, component, 'start'));
            entTween.t = 0 - entTween.loopDelay;
            entTween.direction = 'forward';
          } else {
            this.addComponent(ent, this.findSlots(ent, component, 'finish'));
            entTween.t = entTween.time + entTween.loopDelay;
            entTween.direction = 'backward';
          }
        }
      }
    }

  }

  this.forceSetDirty(ent);
}

CreateSystems.prototype.updateMoveTo = function (dt, ent) {
  if (!this.isCameraReady(ent)) {
    return;
  }
  const uuid = ent.uuid.uuid;
  const moveTo = ent.moveTo;
  if (!ent.moveTo.started) {
    const thePointEnt = this.sceneGraphFind(ent, (type, c) => {
      return type === 'point' && c.componentId === moveTo.pointId;
    });
    
    if (this.isDirty(thePointEnt)) {
      return;
    }

    const slots = this.findSlots(ent, moveTo, 'link');
    this.addComponent(ent, slots);

    if (thePointEnt) {

      //this.reparent(ent,thePointEnt); 

      moveTo.path = thePointEnt.path;
      moveTo.started = true;
      this.addComponent(ent, this.findSlots(ent, ent.moveTo, 'begin'));

      const globalStartPos = this.getWorldPosition(ent);
      const globalEndPos = this.getWorldPosition(thePointEnt);
      ent.moveTo.startGlobal = clone(globalStartPos);
      ent.moveTo.startLocal = {
        x:ent.transform.x,
        y:ent.transform.y
      }
      ent.moveTo.endGlobal = clone(globalEndPos);
      ent.moveTo.diffGlobal = {
        x:ent.moveTo.endGlobal.x - ent.moveTo.startGlobal.x,
        y:ent.moveTo.endGlobal.y - ent.moveTo.startGlobal.y,
      }
      ent.moveTo.thePointEnt = thePointEnt;
    } else {
      //console.warn('didnt find path for', ent);
      return;
    }
  }

  if (ent.moveTo.t === 0) {
    this.addComponent(ent, this.findSlots(ent, ent.moveTo, 'start'));
  }
  let t = this.applyTween(ent.moveTo.tween || 'linear', ent.moveTo.t / ent.moveTo.speed);

  if (ent.moveTo.follow && this.isDirty(ent.moveTo.thePointEnt)) {
    const globalEndPos = this.getWorldPosition(ent.moveTo.thePointEnt);
    ent.moveTo.endGlobal = clone(globalEndPos);
    ent.moveTo.diffGlobal = {
      x:ent.moveTo.endGlobal.x - ent.moveTo.startGlobal.x,
      y:ent.moveTo.endGlobal.y - ent.moveTo.startGlobal.y,
    }
  }
  const newWorldX = ent.moveTo.startGlobal.x + ent.moveTo.diffGlobal.x * t
  const newWorldY = ent.moveTo.startGlobal.y + ent.moveTo.diffGlobal.y * t
  const newLocal = this.getLocalPosition(ent, {
    x:newWorldX,
    y:newWorldY
  })
  ent.transform.x = newLocal.x;
  ent.transform.y = newLocal.y;
  this.conditionallySetDirty(ent);

  ent.moveTo.t += dt / 1000;

  if (ent.moveTo.t > ent.moveTo.speed) {
      this.removeComponent(ent, this.Components.MoveTo);
      const lefinish = this.findSlots(ent, ent.moveTo, 'finish');
      this.addComponent(ent, lefinish);
  }

}

CreateSystems.prototype.updateMove = function (dt, ent) {
  const totalLength = ent.move.multi.length;
  if (ent.physicsbody2d) {
    ent.transform.__positionUpdated = true;
  }
  for (let j = 0; j < totalLength; j++) {
    const o = ent.move.multi[j];
    const move = o.c;
    const component = o.component;

    if (move.t === 0) {
      this.addComponent(ent, this.findSlots(ent, component, 'start'));
    }
    if (move.dx !== 0) {
        let t = this.applyTween(move.tween || 'linear', move.t / move.speed);
        move.newx = move.dx * t;
        ent.transform.x += move.newx - move.prevx;
        move.prevx = move.newx;
        //ent.transform.x = move.startx + move.dx * t;
    }
    if (move.dy !== 0) {
        let t = this.applyTween(move.tween || 'linear', move.t / move.speed);
        move.newy = move.dy * t;
        ent.transform.y += move.newy - move.prevy;
        move.prevy = move.newy;
        //ent.transform.y = move.starty + move.dy * t;
    }

    if (move.dscale !== 0) {
        ent.transform.scalex = move.startscalex + move.dscale * (move.t/move.speed);
        ent.transform.scaley = move.startscaley + move.dscale * (move.t/move.speed);
    }

    move.t += dt / 1000;

    if (move.t > move.speed) {
      let t = this.applyTween(move.tween || 'linear', 1.0);
      if (move.dx !== 0) {
          move.newx = move.dx * t;
          ent.transform.x += move.newx - move.prevx;
      }
      if (move.dy !== 0) {
          move.newy = move.dy * t;
          ent.transform.y += move.newy - move.prevy;
      }

      const slots = this.findSlots(ent, component, 'finish');
      this.multiRemoveComponent(ent, this.Components.Move, move);

      this.endOfFrame.push( () => {
          this.addComponent(ent, slots);
      });
    }

  }

  this.conditionallySetDirty(ent);

//  this.debug.stopSystem('updateMove');


}


CreateSystems.prototype.pointerDown = function () {
  //this.gameobjects.addDebug('clear 2');
  this.currentPressing = {};
}
CreateSystems.prototype.pointerUp = function () {
  this.endOfFrame.push( () => {
    //this.gameobjects.addDebug('clear 3');
    this.currentPressing = {};
    delete this.gameobjects.interaction.press;
    delete this.gameobjects.interaction.tap;
  });
}
CreateSystems.prototype.pointerUpOutside = function () {
  this.endOfFrame.push( () => {
  this.endOfFrame.push( () => {
  this.endOfFrame.push( () => {
  this.endOfFrame.push( () => {
    //this.gameobjects.addDebug('clear OUTSIDE 3');
    this.currentPressing = {};
    delete this.gameobjects.interaction.press;
    delete this.gameobjects.interaction.tap;
  });
  });
  });
  });
}

CreateSystems.prototype.beforeRunTapController = function (dt) {
  if (!this.lastTaps) {
    this.lastTaps = {}
  }

  //if (!this.gameobjects.interaction.tap && !(this.gameobjects.interaction.press||{}).type) {
  if (this.gameobjects.interaction.tap) {
    //this.gameobjects.addDebug('beforeTap: ' + keys(this.currentPressing).length);
    if (keys(this.currentPressing).length > 0) {
    //this.gameobjects.addDebug('currentPressing');
      values(this.currentPressing).forEach( (x) => {
        const ent = x[0];
        const tapController = x[2];
        if (ent.uuid) {
          const now = new Date().getTime();
          const key = tapController.cooldownKey ? tapController.cooldownKey : ent.uuid.uuid;
          let cooldownValid = (now - (this.lastTaps[key] || 0)) > (tapController.cooldown||0) * 1000;
          if (cooldownValid) {
    //this.gameobjects.addDebug('cooldownValid');
            //const slots = this.findSlots(ent, component, 'link');
            //this.addComponent(ent, slots)
            this.lastTaps[key] = new Date().getTime();
            if (tapController.cooldownEvent) {
              this.lastTaps[key] = 9999999999999;
              this.events.once(tapController.cooldownEvent, () => {
                this.lastTaps[key] = now;
              })
            }
            this.addComponent(x[0], this.findSlots(x[0], x[1], 'link'));
            this.addComponent(x[0], this.findSlots(x[0], x[1], 'finish'));

            if (tapController.addedBusy.length) {
              for (let i = 0; i < tapController.addedBusy.length; i++) {
                const addedBusy = tapController.addedBusy[i];
                this.removeComponentManually(ent, addedBusy);
              }
              tapController.addedBusy = [];
            }
          } else {
          }
        } else {
    //this.gameobjects.addDebug('cooldownInvalid');
          //console.warn('lost', ent);
        }
      });
      //this.gameobjects.addDebug(`tap bye`);
      this.currentPressing = {};
    }
    return false;
  } else {
    values(this.currentPressing).forEach( (x) => {
      const ent = x[0];
      const tapController = x[2];
      if (ent.uuid && !tapController.addedBusy.length) {
        const slots = this.findSlots(x[0], x[1], 'busy')
        const addedBusy = [];
        for (let i = 0; i < slots.length; i++) {
          const slot = slots[i];
          const c = this.addComponent(x[0], slot, true);
          addedBusy.push(c);
        };
        tapController.addedBusy = addedBusy;
      }
    });
  }

  const tap = this.gameobjects.interaction.tap;
  const press = this.gameobjects.interaction.press;
  const interaction = tap || press;
  if (!interaction) {
    return false;
  }

  this.hitContainer = this.gameobjects.app.renderer.plugins.interaction.hitTest(interaction.pos);
}

CreateSystems.prototype.runTapController = function (dt, ent) {
  const crash = this.collisionBoxSystem.crash;

  const tap = this.gameobjects.interaction.tap;
  const press = this.gameobjects.interaction.press;
  const interaction = tap || press;
  const transform = ent.transform;
  const {outer,inner} = this.pixiContainers[ent.uuid.uuid]
  let wasNonInteractive = false;
  if (!outer.interactive) {
    wasNonInteractive = true;
  }
  let lastTapController;
  if (wasNonInteractive || this.isDirty(ent, 'scale')) {
    const totalLength = ent.tapController.multi.length;
    let isInteractive = false;
    for (let j = 0; j < totalLength; j++) {
      const o = ent.tapController.multi[j];
      const tapController = o.c;
      isInteractive = isInteractive || !tapController.tapAnywhere;
      if (wasNonInteractive && isInteractive) {
        outer.interactive = true;
      }

      lastTapController = tapController;

    }

    if (isInteractive || this.isDirty(ent)) {
      const bounds = this.getWorldBoundingBox(ent);
      const scale = {
        x:bounds.x2 - bounds.x1,
        y:bounds.y2 - bounds.y1
      }
      let scalex = 0; let scaley = 0;
      scalex = Math.max(scalex,scale.x * lastTapController.scalex);
      scaley = Math.max(scaley,scale.y * lastTapController.scaley);

      /*
      * TODO: this doesnt work for certain situations.
      * for example, on the Karen game
      outer.hitArea = new PIXI.Rectangle(
        -scalex/2,
        -scaley/2,
        scalex,
        scaley)
        */

    } else {
      outer.interactive = false;
      /*
      outer.hitArea = new PIXI.Rectangle(
        0,
        0,
        0,
        0)
        */
    }

    if (Math.abs(outer.worldAlpha) < 0.05) {
      if (outer.interactive) {
        outer.interactive = false;
        this.hitContainer = this.gameobjects.app.renderer.plugins.interaction.hitTest(interaction.pos);
      }
    } else if (isInteractive) {
      if (!outer.interactive) {
        outer.interactive = true;
      }
    }


  }

  if (!this.hitContainer) {
    return true;
  }

  if (!interaction) {
    return true;
  }

  const totalLength = ent.tapController.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.tapController.multi[j];
    const tapController = o.c;
    const component = o.component;

    const cooldown = tapController.cooldown;

    const width = transform.scalex;
    const height = transform.scaley;


    const transformWorldBounds = this.getWorldBoundingBox(ent);
    const transformWidth = Math.abs(transformWorldBounds.x2 - transformWorldBounds.x1);
    const transformHeight = Math.abs(transformWorldBounds.y2 - transformWorldBounds.y1);
    const transformWorldPosition = this.getWorldPosition(ent);
    const objectCollider = this.collisionBoxSystem.getCollisionBox(
      transformWorldPosition.x - transformWidth*ent.transform.anchorx,
      transformWorldPosition.y - transformHeight*ent.transform.anchory,
      transformWidth,
      transformHeight
    );

    let cooldownValid = true;

    if (tapController.tapAnywhere || outer === this.hitContainer) {
    /*if (outer === sigh || crash.test(tapCollider, objectCollider, res)) {*/
      if (!this.currentPressing[component.id]) {
        //this.gameobjects.addDebug('press: ' + ent.uuid.uuid)
        this.addComponent(ent, this.findSlots(ent, component, 'start'));
        this.currentPressing[component.id] = [ent,component,tapController];
        this.gameobjects.notifyTap && this.gameobjects.notifyTap({
          ent,
          component
        });
      } else {
        //this.gameobjects.addDebug('already');
        //this.gameobjects.addDebug(`currentPressing`);
      }

    }
  }

}
  const isRight = (gameobjects, ref, component, pos) => {
      return pos.x - ref[0] > gameobjects.screenWidth*(component.horizontalMargin||0);
  }
  const isLeft = (gameobjects, ref, component, pos) => {
      return pos.x - ref[0] < -gameobjects.screenWidth*(component.horizontalMargin||0);
  }
  const isTop = (gameobjects, ref, component, pos) => {
      return pos.y - ref[1] < -gameobjects.screenHeight*(component.verticalMargin||0);
  }
  const isBottom = (gameobjects, ref, component, pos) => {
      return pos.y - ref[1] > gameobjects.screenHeight*(component.verticalMargin||0);
  }


CreateSystems.prototype.runPressController = function (dt, ent) {
  if (!this.gameobjects.interaction.press || !this.gameobjects.interaction.pos) {
    return;
  }

  const press = this.gameobjects.interaction.press;
  const tap = this.gameobjects.interaction.tap;
  let interaction = press;
  if (ent.pressController.useTap) {
    interaction = tap;
  }
  if (!interaction) {
    return;
  }

  const ref = [this.gameobjects.screenWidth/2, this.gameobjects.screenHeight/2];
  if (isRight(this.gameobjects, ref, ent.pressController, interaction.pos)) {
    //addComponent(ent, this.findSlots(gameobjects, ent.swipeController, 'left'));
    this.addComponent(ent, this.findSlots(ent, ent.pressController, 'right'));
  } else if (isLeft(this.gameobjects, ref, ent.pressController, interaction.pos)) {
    this.addComponent(ent, this.findSlots(ent, ent.pressController, 'left'));
  } else if (isTop(this.gameobjects, ref, ent.pressController, interaction.pos)) {
    this.addComponent(ent, this.findSlots(ent, ent.pressController, 'top'));
  } else if (isBottom(this.gameobjects, ref, ent.pressController, interaction.pos)) {
    this.addComponent(ent, this.findSlots(ent, ent.pressController, 'bottom'));
  }


}

CreateSystems.prototype.beforeRunPanController = function (dt) {
}
CreateSystems.prototype.afterRunPanController = function (dt) {
  if (this.gameobjects.interaction.panStart) {
    delete this.gameobjects.interaction.panStart;
  }
  if (this.gameobjects.interaction.panEnd) {
    delete this.gameobjects.interaction.panEnd;
    delete this.gameobjects.interaction.pan;
  }
}
function storePanVariable(pan, panController, properties, name, frac) {
  if (panController[name] && panController[name].name) {
    properties[panController[name].id] = pan[name] * frac;
  }
}

CreateSystems.prototype.runPanController = function (dt, ent) {
  const pan = this.gameobjects.interaction.pan;
  const panStart = this.gameobjects.interaction.panStart;
  const panEnd = this.gameobjects.interaction.panEnd;
  const interaction = pan;
  const ref = [this.gameobjects.screenWidth/2, this.gameobjects.screenHeight/2];
  const frac = dt/16;

  let properties;
  if (panStart || panEnd) {
    this.prepareGlobalAndLocalVariables(ent);
    properties = this.getProperties(ent);
  }


  if (panStart) {
    //screenPos.x -= this.cameraContainer.pivot.x;
    //screenPos.y -= this.cameraContainer.pivot.y;

    const p = this.cameraContainer.toLocal({
      x:panStart.startX,
      y:panStart.startY
    });
    //const p = this.getScreenPos(ent, {
      //x:panStart.startX,
      //y:panStart.startY,
    //});
    const o = {
      startX: p.x + this.cameraContainer.pivot.x,
      startY: p.y + this.cameraContainer.pivot.y
    }
    storePanVariable(o, ent.panController, properties, 'startX', frac)
    storePanVariable(o, ent.panController, properties, 'startY', frac)
    this.addComponent(ent, this.findSlots(ent, ent.panController, 'anyStart'));
  }
  if (panEnd) {
    const p = this.cameraContainer.toLocal({
      x:panEnd.endX,
      y:panEnd.endY
    });
    //const p = this.getScreenPos(ent, {
      //x:panStart.startX,
      //y:panStart.startY,
    //});
    const o = {
      endX:p.x + this.cameraContainer.pivot.x,
      endY:p.y + this.cameraContainer.pivot.y
    }
    storePanVariable(o, ent.panController, properties, 'endX', frac)
    storePanVariable(o, ent.panController, properties, 'endY', frac)
    this.addComponent(ent, this.findSlots(ent, ent.panController, 'anyEnd'));
  }

  if (panStart || panEnd) {
    this.updateGlobalAndLocalVariables(ent, properties);
  }

  if (pan) {
    const p = this.cameraContainer.toLocal({
      x:pan.x,
      y:pan.y
    });

    const o = {
      x:p.x,
      y:p.y,
      length:pan.length / this.cameraContainer.scale.x
    }

    this.prepareGlobalAndLocalVariables(ent);
    properties = this.getProperties(ent);
    storePanVariable(o, ent.panController, properties, 'length', frac)
    storePanVariable(o, ent.panController, properties, 'x', frac)
    storePanVariable(o, ent.panController, properties, 'y', frac)
    storePanVariable(pan, ent.panController, properties, 'prevRotation', frac)
    if (ent.panController.lerpx && ent.panController.lerpx.name) {
      properties[ent.panController.lerpx.name] = pan.velocityX * frac;
    }
    if (ent.panController.lerpy && ent.panController.lerpy.name) {
      properties[ent.panController.lerpy.name] = pan.velocityY * frac;
    }
    if (ent.panController.velocity && ent.panController.velocity.name) {
      properties[ent.panController.velocity.name] = pan.velocity * frac;
    }
    if (ent.panController.rotation && ent.panController.rotation.name) {
      //const before = properties[ent.panController.rotation.name] || 0
      const before = ent.transform.rotation
      const to = pan.rotation;
      properties[ent.panController.rotation.name] = pan.rotation;
    }
    this.updateGlobalAndLocalVariables(ent, properties);
    if (pan.direction === 'panright') {
      //addComponent(ent, this.findSlots(gameobjects, ent.swipeController, 'left'));
      this.addComponent(ent, this.findSlots(ent, ent.panController, 'horizontal'));
      this.addComponent(ent, this.findSlots(ent, ent.panController, 'right'));
    } else if (pan.direction === 'panleft') {
      this.addComponent(ent, this.findSlots(ent, ent.panController, 'horizontal'));
      this.addComponent(ent, this.findSlots(ent, ent.panController, 'left'));
    } else if (pan.direction === 'panup') {
      this.addComponent(ent, this.findSlots(ent, ent.panController, 'vertical'));
      this.addComponent(ent, this.findSlots(ent, ent.panController, 'top'));
    } else if (pan.direction === 'pandown') {
      this.addComponent(ent, this.findSlots(ent, ent.panController, 'vertical'));
      this.addComponent(ent, this.findSlots(ent, ent.panController, 'bottom'));
    }

    // reset this because hammerjs doesnt reset it if using a mouse :-(
    pan.velocityX = 0;
    pan.velocityY = 0;
    pan.velocity = 0;
    this.addComponent(ent, this.findSlots(ent, ent.panController, 'any'));

  }

}

CreateSystems.prototype.runSwipeController = function (dt, ent) {
    if (!this.gameobjects.interaction.swipe) {
        return;
    }

    const swipe = this.gameobjects.interaction.swipe;
    const transform = ent.transform;

    this.prepareGlobalAndLocalVariables(ent);
    const properties = this.getProperties(ent);
    if (ent.swipeController.lerpx.name) {
      properties[ent.swipeController.lerpx.name] = swipe.velocityX * frac;
    }
    if (ent.swipeController.lerpy.name) {
      properties[ent.swipeController.lerpy.name] = swipe.velocityY * frac;
    }
    if (ent.swipeController.velocity.name) {
      properties[ent.swipeController.velocity.name] = swipe.velocity * frac;
    }
    this.updateGlobalAndLocalVariables(ent, properties);

    if (swipe.direction === 'left') {
      this.addComponent(ent, this.findSlots(ent, ent.swipeController, 'left'));
      this.addComponent(ent, this.findSlots(ent, ent.swipeController, 'horizontal'));
    } else if (swipe.direction === 'right') {
      this.addComponent(ent, this.findSlots(ent, ent.swipeController, 'right'));
      this.addComponent(ent, this.findSlots(ent, ent.swipeController, 'horizontal'));
    } else if (swipe.direction === 'up') {
      this.addComponent(ent, this.findSlots(ent, ent.swipeController, 'up'));
      this.addComponent(ent, this.findSlots(ent, ent.swipeController, 'vertical'));
    } else if (swipe.direction === 'down') {
      this.addComponent(ent, this.findSlots(ent, ent.swipeController, 'down'));
      this.addComponent(ent, this.findSlots(ent, ent.swipeController, 'vertical'));
    }
    this.addComponent(ent, this.findSlots(ent, ent.swipeController, 'any'));


}
CreateSystems.prototype.runKeyController = function (dt, ent) {

  if (!this.gameobjects.interaction.keysPressed && !this.gameobjects.interaction.keysDown && !this.gameobjects.interaction.keysUp) {
    return;
  }
//  this.debug.startSystem('runKeyController', length);
  if (!ent.keyController.slots) {
    ent.keyController.slots = this.findSlots(ent, ent.keyController, undefined, undefined, true).map( (x) => {
      return x.link.name;
    });
  }
  //const keymap = ent.keyController.keymap;
  //const keymapLength = keymap.length;
  const slots = ent.keyController.slots;
  const slotLength = slots.length;
  for (let j = 0; j < slotLength; j++) {
    const slotName = slots[j];

    if (slotName.indexOf(':') === -1) {
      if (this.gameobjects.interaction.keysPressed[slotName]) {
        this.addComponent(ent, this.findSlots(ent, ent.keyController, slotName));
      }
    } else {
      const keyName = slotName.split(':')[0];
      if (this.gameobjects.interaction.keysDown && this.gameobjects.interaction.keysDown[keyName]) {
        this.addComponent(ent, this.findSlots(ent, ent.keyController, keyName + ':start'));
      }
      if (this.gameobjects.interaction.keysUp && this.gameobjects.interaction.keysUp[keyName]) {
        this.addComponent(ent, this.findSlots(ent, ent.keyController, keyName + ':finish'));
      }
    }
  }

}



CreateSystems.prototype.updateRandomChoose = function (dt, ent) {
    const totalLength = ent.randomChoose.multi.length;
    for (let j = 0; j < totalLength; j++) {
      const o = ent.randomChoose.multi[j];
      const randomChoose = o.c;
      const component = o.component;

      const components = this.findSlots(ent, component);
      const shuffledComponents = shuffle(components);
      if (shuffledComponents.length > 0) {
          const chosenComponent = shuffledComponents[0];
          this.addComponent(ent, chosenComponent);
      }
      this.multiRemoveComponent(ent, this.Components.RandomChoose, randomChoose);

    }

}


CreateSystems.prototype.restart = function () {
  const ent = this.findRoot();
  this.Components.GotoScene.create(ent, {
    mode: 'same'
  });
}

CreateSystems.prototype.updateSetGameState = function (dt, ent) {

  if (ent.setGameState.state === "restart") {
    this.Components.GotoScene.create(ent, {
      mode: 'same'
    });
  } else {
    this.gameobjects.setGameState(ent.setGameState.state, ent.setGameState.message);
  }

  this.removeComponent(ent, this.Components.SetGameState);

}


CreateSystems.prototype.dontDelete = function (entity) {
  return entity.tiledSprite || entity.keyController || entity.tapController || entity.swipeController;
}

CreateSystems.prototype.createSceneGraphChild = function (ent, childTransform, unparent=false) {
  if (childTransform.disabled) {
    return;
  }
  const newEnt = this.gameobjects.entities.createEntity();
  this.createUuid(newEnt);
  this.createSceneGraph(newEnt, childTransform, ent, unparent);
  return newEnt;
}
CreateSystems.prototype.createSceneGraphChildren = function (ent, transform, unparent=false, pred) {
  const childrenLength = transform.children.length;
  const createdChildren = [];
  for (var i = 0; i < childrenLength; i++) {
    const childTransform = transform.children[i];
    if (childTransform.disabled) {
      continue;
    }
    if (pred && !pred(childTransform)) {
      continue;
    }
    const newEnt = this.gameobjects.entities.createEntity();
    createdChildren.push(newEnt);
    this.createUuid(newEnt);
    this.createSceneGraph(newEnt, childTransform, ent, unparent);

  }

  return createdChildren;
}

CreateSystems.prototype.identityTransform = function (transform) {
  const t = cloneDeep(transform||{
    transform:{}
  });
  t.transform = {
      pos:{
        x:0,
        y:0
      },
      scale:{
        x:(transform && transform.transform) ? transform.transform.scale.x : 1,
        y:(transform && transform.transform) ? transform.transform.scale.y : 1
      },
      localScale:{
        x:(transform && transform.transform) ? transform.transform.localScale.x : 1,
        y:(transform && transform.transform) ? transform.transform.localScale.y : 1,
      },
      alpha:(transform && transform.transform) ? transform.transform.alpha : 1,
      localRotation:(transform && transform.transform) ? transform.transform.localRotation : 0,
      rotation:(transform && transform.transform) ? transform.transform.rotation : 0,
      zIndex:transform.transform.zIndex,
      layer:transform.transform.layer,
      sendToOrigin:transform.transform.sendToOrigin
    } 
  return t;
}
CreateSystems.prototype.toGlobal = function (parent, transform) {
  if (!parent) {
    return transform;
  }
  const t = cloneDeep(transform);
  const parentContainer = this.pixiContainers[parent.uuid.uuid].outer;
  let globalPos;
  if (!transform.transform.sendToOrigin) {
    globalPos = parentContainer.toGlobal(transform.transform.pos);
  } else {
    globalPos = parentContainer.toGlobal({x:0,y:0});
  }
  const worldPos = this.cameraContainer.toLocal(globalPos);
  t.transform.pos.x = worldPos.x;
  t.transform.pos.y = worldPos.y;
  return t;

}

CreateSystems.prototype.nameSpaceVariables = function (ent, variables) {
  const namespaced = {};
  (variables||[]).forEach( ({name,id,initial}) => {
    namespaced[id] = initial;
  });
  return namespaced;
}

CreateSystems.prototype.clearTransformProp = function (ent, prop) {
  if (!ent.uuid || !ent.uuid.uuid) {
    return;
  }
  ent.uuid.__variableView = ent.uuid.__variableView.filter( (k) => {
    return k.name !== prop;
  });
  const key = `${ent.uuid.uuid}-${prop}`;
  delete this.luaHeap[key];
}

CreateSystems.prototype.updateTransformProps = function (ent, props) {
  if (!ent.uuid || !ent.uuid.uuid) {
    return;
  }
  const pairs = toPairs(props);
  const length = pairs.length;
  let variableView = ent.uuid.__variableView;
  for (let i = 0; i < length; i++) {
    const key = pairs[i][0];
    const value = pairs[i][1];
    variableView.push({
      uuid:ent.uuid.uuid,
      name:key,
      key:`${ent.uuid.uuid}-${key}`
    })
    this.luaHeap[`${ent.uuid.uuid}-${key}`] = value;
  }
}

CreateSystems.prototype.setTransformProps = function (ent, inVariables, parent) {
  const props = {}
  let variables = cloneDeep(inVariables);
  let overrideVariables = {};
  //if (!ent.uuid.__overrideVariables) {
  this.setVariableOverrides(ent, ent.uuid.__overrideVariables);
  //}
  if (ent.uuid.__overrideVariables) {
    overrideVariables = ent.uuid.__overrideVariables;
    overrideVariables = fromPairs(toPairs(overrideVariables).filter( ([k,v]) => {
      return v && v !== '';
    }));
  }
  toPairs(overrideVariables).forEach( ([key,value]) => {
    const existingVariable = variables.filter( (v) => {
      return v.name === key;
    })[0]
    if (existingVariable) {
      //existingVariable.initial = value;
      if (!isObject(value)) {
        existingVariable.initial = value;
      } else {
        existingVariable.initial = clone(value);
        existingVariable.initial.type = 'pointer'
      }
    }
  });

  let variableView = ent.uuid.__variableView || [];
  if (this.hasParent(ent)) {
    currentVars = this.getEntityById(ent.uuid.parentTransform).uuid.__variableView || [];
    currentEnt = this.getEntityById(ent.uuid.parentTransform);
    for (let i = 0; i < currentVars.length; i++) {
      let variable = currentVars[i];
      variableView.push(variable);
    }
  }



  let currentVars = variables;
  let currentEnt = ent;
  //while (currentEnt != null) {
    for (let i = 0; i < currentVars.length; i++) {
      let variable = currentVars[i];
      if ((variable.initial||{}).type === 'pointer') {
        const ptr = variable.initial;
        const __variableView = ent.uuid.__variableView;
        const length = __variableView.length;
        const props = {};

        let ptrTarget;
        for (let i = 0; i < length; i++) {
          const vv = __variableView[i];
          const {key,name} = vv;
          if (name === ptr.name) {
            ptrTarget = vv;
            break;
          }
        }

        if (!ptrTarget) {
          //console.warn(ent.uuid.uuid, 'could not find pointer target for', ptr.name);
          const p = this.getParent(ent);
          variableView.push({
            uuid:ent.uuid.uuid,
            name:variable.name,
            key:`${ent.uuid.uuid}-${variable.name}`
          })
          //variableView.push({
            //uuid:ent.uuid.uuid,
            //name:variable.name,
            //key:`${ent.uuid.uuid}-${variable.name}`
          //})
        } else {
          const o = {
            uuid:ent.uuid.uuid,
            name:variable.name,
            key:`${ent.uuid.uuid}-${variable.name}`,
            type:'pointer',
            ptr:ptrTarget.key
          };
          variableView.push(o);
        }

      } else {
        variableView.push({
          uuid:ent.uuid.uuid,
          name:variable.name,
          key:`${ent.uuid.uuid}-${variable.name}`
        })
      }
    }


  //}
  ent.uuid.__variableView = variableView;

  variables.forEach( (v) => {
    if (!v.system) {
      let initial = v.initial;

      if (this.shouldStoreVariable(ent, v.name)) {
        initial = this.getVariable(ent, v.name) || initial;
      }


      if ((initial||{}).type === 'pointer') {
      } else if ((initial||{}).type === 'variable') {
        props[v.name] = this.getScalar(ent, initial);
      } else {
        //if (!isNaN(parseFloat(scalar))) {
        if (typeof(initial) === 'number') {
          props[v.name] = parseFloat(initial);
        }
        if (!this.numberRegex.test(initial)) {
          props[v.name] = initial;
        } else {
          props[v.name] = parseFloat(initial);
        }

      }


      /*
      if (!isNaN(parseFloat(initial))) {
        props[v.name] = parseFloat(initial);
      } else {
        if ((initial||{}).type === 'variable') {
          props[v.name] = this.getScalar(ent, initial);
        } else {
          props[v.name] = initial;
        }
      }
      */
    } else {
      props[v.name] = 0;
      //this.Components.LuaScript.create(rootEnt, {script:v.script});
      this.Util.addComponent(ent, {
        id:v.id,
        type:'script',
        keep:true,
        timer:1000,
        script:v.script
      })
    }
  });


  this.setProperties(ent, props);
  this.clearPropertiesCache(ent);
}

CreateSystems.prototype.getTransformOrOverride = function (ent, transform, visited={}) {
  if (visited[ent.uuid.uuid]) {
    throw new Error('already visited: ' + ent.uuid.parentTransform);
    return transform;
  }
  visited[ent.uuid.uuid] = true;

  if (ent.uuid.__overrideTransforms && ent.uuid.__overrideTransforms[transform.id]) {
    const t = clone(ent.uuid.__overrideTransforms[transform.id]);
    Object.assign(t.transform.pos, transform.transform.pos);
    t.sendToOrigin = transform.transform.sendToOrigin || transform.sendToOrigin;
    t.zIndex = transform.transform.zIndex;
    t.id = transform.id;
    t.layer = transform.transform.layer;
    return t;
  }
  return transform;
}

CreateSystems.prototype.addSlotsFromComponentToComponent = function (ent, toComponent, fromComponent) {
  const slots = this.findSlots(ent, fromComponent, undefined, undefined, true);
  if (!ent.uuid.__extendedSlots) {
    ent.uuid.__extendedSlots = {};
  }
  if (!ent.uuid.__extendedSlots[toComponent.id]) {
    ent.uuid.__extendedSlots[toComponent.id] = [];
  }
  for (let i = 0; i < slots.length; i++) {
    const slot = slots[i];
    ent.uuid.__extendedSlots[toComponent.id].push(slot);
  }
}

CreateSystems.prototype.clearLayers = function () {
  //console.log('[LAYER] clearLayer');
  toPairs(this.layers).forEach( x => {
    const zIndex = x[0];
    const {layer, layerGroup, count} = x[1];
    this.gameobjects.app.stage.removeChild(layer);
  });

  this.layers = {};
}
          //this.returnLayer(parseInt(zIndex), layer, group)
CreateSystems.prototype.returnLayer = function (z, _layer, _group) {
  //console.log('[LAYER] return layer', z);
  const {layer, layerGroup} = this.layers[z];
  this.layers[z].count--;
  if (this.layers[z].count <= 0) {
    layer.destroy({texture:true,baseTexture:true});
    this.gameobjects.app.stage.removeChild(layer);
  }
}

CreateSystems.prototype.setZIndex2 = function (ent, container, layerId, zindex) {
  const layer = this.layerDefinitions[layerId];
  const pl = this.getLayer(layer);
  container.parentLayer = pl;
  container.sortableChildren = true;
  container.zOrder = zindex;

  this.addAutoLayerComponents(ent, layerId);
}

CreateSystems.prototype.addAutoLayerComponents = function (ent, layerId) {
  if (this.layerAutoComponents[layerId]) {
    this.addComponent(ent, this.layerAutoComponents[layerId]);
  }
}

CreateSystems.prototype.getLayer = function (in_layer='default') {

  //console.log('[LAYER] look for layer', in_layer.zindex);

  if (!this.layers[in_layer.zindex]) {
    //console.log('[LAYER] create layer', in_layer.default, in_layer.zindex);
    const layerGroup = new PIXI.display.Group(in_layer.zindex);
    layerGroup.enableSort = true;

    const layer = new PIXI.display.Layer(layerGroup);
    layerGroup.sortableChildren = true;

    this.layers[in_layer.zindex] = {
      layerGroup,
      layer,
      count:0
    }

    this.gameobjects.app.stage.addChild(layer);
  }
  this.layers[in_layer.zindex].count++;
  return this.layers[in_layer.zindex].layer;

  //return new PIXI.display.Group(n);
}


CreateSystems.prototype.hasParent = function (ent) {
  if (!ent.uuid || !ent.uuid.uuid) {
    return false;
  }
  return typeof(ent.uuid.parentTransform) !== 'undefined' && this.entitiesByUuid[ent.uuid.parentTransform];
}
CreateSystems.prototype.getEntityById = function (uuid) {
  return this.entitiesByUuid[uuid];
}
CreateSystems.prototype.createSceneGraph = function (ent, transform, parent = null, unparent=false) {
  unparent = unparent || (transform.transform.unparent && parent && parent !== this.cameraContainer);

  ent.uuid.parentTransform = (parent ? parent : this.findRoot()).uuid.uuid;
  if (!ent.uuid.parentTransform) {
    //console.error('parentTransform is null!!!!!!!');
  } else {
  }
  const createTransform = this.getTransformOrOverride(ent, transform, {});

  this.Components.Transform.create(
    ent,
    !unparent ? createTransform : this.identityTransform(createTransform),
    parent ? parent.uuid.uuid: null,
    unparent,
    Object.assign({},transform.vars,createTransform.vars));

  ent.transform.layer = transform.transform.layer;
  if (parent && parent.uuid.__overrideLayer) {
    ent.transform.layer = parent.uuid.__overrideLayer;
    ent.uuid.__overrideLayer = parent.uuid.__overrideLayer;
  }

  ent.addTag(createTransform.id);
  ent.addTag(transform.id);
  ent.uuid.__transformId = transform.id;
  this.setTransformProps(ent, values(transform.variables || {}), parent);
  if (parent && !unparent) {
    parent.transform.__children.push(ent.uuid.uuid);
    ent.addTag('child-'+parent.uuid.uuid);
  } else {
    const root = this.findRoot();
    ent.uuid.parentTransform = root.uuid.uuid;
    ent.addTag('child-' + root.uuid.uuid);
    //ent.addTag('normal');
  }

  // if we created the original transform
  if (createTransform === transform) {
    const component = this.gameobjects.componentIdCache[transform.cid];
    if (component) {
      this.addComponent(ent, component);
    }
  } else {
    const component = this.gameobjects.componentIdCache[createTransform.cid];
    const originalComponent = this.gameobjects.componentIdCache[transform.cid]
    this.addSlotsFromComponentToComponent(ent, component, originalComponent);
    this.addComponent(ent, component);
    
  }

  const uuid = ent.uuid.uuid;
  let parentContainer = this.cameraContainer;
  if (parent && !unparent) {
    parentContainer = this.pixiContainers[parent.uuid.uuid].outer;
  }

  if (!this.pixiContainers[uuid]) {
    const container = new PIXI.Container();
    if (unparent || !parent) {
      //innerContainer.cacheAsBitmap = true;
    }
    //this.cameraContainer.addChild(layerLayer);

    this.pixiContainers[uuid] = {
      outer:container,
      parent:parentContainer,
      //inner:innerContainer,
    }
    this.__pixiContainersLen++;
    container.visible = ent.transform.visible;

    if (parent && this.pixiContainers[parent.uuid.uuid].mask) {
      const mask = this.pixiContainers[parent.uuid.uuid].mask;
      container.mask = mask;
      this.pixiContainers[uuid].mask = mask;
    }
    //container.addChild(innerContainer);

    if (unparent) {

    /*
    const parentRelativeContainer = new PIXI.Container();

    const wt = this.pixiContainers[parent.uuid.uuid].outer.worldTransform;

      wt.copy(parentRelativeContainer.localTransform);

      let scale = {
        x:1/this.cameraContainer.scale.x,
        y:1/this.cameraContainer.scale.y
      }

      const containers = this.pixiContainers[parent.uuid.uuid];
      let pc = containers.outer;
      if (containers.unparent) {
        pc = containers.unparent;
      }
      const screenPos = pc.worldTransform.apply({x:0,y:0});
      const worldPos = this.cameraContainer.worldTransform.applyInverse(screenPos);
      //parentRelativeContainer.position.set(worldPos.x, worldPos.y);


      parentRelativeContainer.localTransform.scale(scale.x,scale.y);
      const angle = Math.atan2(-wt.b, wt.a);
      parentRelativeContainer.localTransform.rotate(angle);
      const pos = this.toGlobal(parent, transform).transform.pos;
      parentRelativeContainer.localTransform.tx = pos.x
      parentRelativeContainer.localTransform.ty = pos.y;


      this.cameraContainer.addChild(parentRelativeContainer);
      parentRelativeContainer.addChild(container);
      this.pixiContainers[uuid].unparent = parentRelativeContainer;
      this.pixiContainers[uuid].parent = this.cameraContainer;
      */

      this.updatePixiTransform(this.getParent(ent));

      const wt = this.pixiContainers[parent.uuid.uuid].outer.worldTransform;
      const worldPos = this.getWorldPosition(parent);
      const parentRelativeContainer = new PIXI.Container();

      container.position.set(ent.transform.x,
        ent.transform.y)
      container.scale.x = ent.transform.scale.x;
      container.scale.y = ent.transform.scale.y;
      container.rotation = ent.transform.rotation;
      if (!transform.transform.dontInheritAngle) {
        const angle = Math.atan2(-wt.b, wt.a);
        container.rotation = -angle;
      }
      //innerContainer.scale.x = ent.transform.localScale.x;
      //innerContainer.scale.y = ent.transform.localScale.y;
      //innerContainer.rotation = ent.transform.localRotation;

      parentRelativeContainer.addChild(container);
      const pos = this.toGlobal(parent, transform).transform.pos;
      parentRelativeContainer.position.set(pos.x, pos.y);

      const calcScale = (container, s={x:1,y:1}) => {
        if (container.parent && container.parent !== this.cameraContainer) {
          s.x *= container.parent.scale.x;
          s.y *= container.parent.scale.y;
          return calcScale(container.parent, s);
        }
        return s;
      }
      parentRelativeContainer.scale.x = container.scale.x;
      parentRelativeContainer.scale.y = container.scale.y;
      const calcedScale = calcScale(this.pixiContainers[parent.uuid.uuid].outer);
      parentRelativeContainer.scale.x = calcedScale.x;
      parentRelativeContainer.scale.y = calcedScale.y;
      parentRelativeContainer.rotation = container.rotation;

      this.pixiContainers[ent.uuid.uuid].unparent = parentRelativeContainer;

      //const pos = this.toGlobal(parent, transform).transform.pos;
      //parentRelativeContainer.localTransform.tx = pos.x
      //parentRelativeContainer.localTransform.ty = pos.y;


      this.cameraContainer.addChild(parentRelativeContainer);
    } else {
      const transform = ent.transform;
      parentContainer.addChild(container);
      container.position.set(transform.x,
        transform.y);
      container.scale.x = transform.scale.x;
      container.scale.y = transform.scale.y;
      container.rotation = transform.rotation;
      //innerContainer.scale.x = transform.localScale.x;
      //innerContainer.scale.y = transform.localScale.y;
      //innerContainer.rotation = transform.localRotation;

    }

    let zIndex = ent.transform.zIndex;
    if (!isNaN(parseInt(zIndex))) {
      const layerNumber = parseInt(zIndex);
      this.setZIndex2(ent, container, ent.transform.layer || 'default', layerNumber);
      this.pixiContainers[uuid].layerNumber = layerNumber;
    } else {
      console.warn('am no zindex');
    }

  }

}
CreateSystems.prototype.setZindex = function (ent, zIndex) {
  const uuid = ent.uuid.uuid;
  const {outer,layerNumber} = this.pixiContainers[uuid]
  if (layerNumber !== zIndex) {
    this.setZIndex2(ent, outer, ent.transform.layer, zIndex);
    this.pixiContainers[uuid].layerNumber = zIndex;
  }

}
CreateSystems.prototype.updateSetTransformProperties = function (dt) {
  const uuid = ent.uuid.uuid;
  const {outer} = this.pixiContainers[uuid]
  outer.visible = ent.setTransformProperties.visible;
  this.addComponent(ent, this.findSlots(ent, ent.setTransformProperties, 'link'));
  this.removeComponent(ent, this.Components.SetTransformProperties);
}

CreateSystems.prototype.forceSetDirty = function (ent, frameCount = 2) {
  if (!ent || !ent.transform) {
    return;
  }
  if (ent.transform.__worldPosition) {
    delete ent.transform.__worldPosition;
  }
  ent.transform.isDirty = frameCount;
}
CreateSystems.prototype.conditionallySetDirty = function (ent, frameCount = 2) {
  const lastX = ent.transform.__lastX;
  const lastY = ent.transform.__lastY;
  const epsilon = 0.0001;
  if (Math.abs(ent.transform.x - lastX) > epsilon
      || Math.abs(ent.transform.y - lastY) > epsilon
      || Math.abs(ent.transform.rotation - ent.transform.__lastRotation) > epsilon
      || Math.abs(ent.transform.scale.x - ent.transform.__lastScaleX) > epsilon
      || Math.abs(ent.transform.scale.y - ent.transform.__lastScaleY) > epsilon
      || Math.abs(ent.transform.localScale.y - ent.transform.__lastLocalScaleY) > epsilon
      || Math.abs(ent.transform.localScale.x - ent.transform.__lastLocalScaleX) > epsilon
      || Math.abs(ent.transform.alpha - ent.transform.__lastAlpha) > epsilon
    ) {
    ent.transform.isDirty = frameCount;
    ent.transform.__lastX = ent.transform.x;
    ent.transform.__lastY = ent.transform.y;
    ent.transform.__lastRotation = ent.transform.rotation;
    ent.transform.__lastScaleX = ent.transform.scale.x;
    ent.transform.__lastScaleY = ent.transform.scale.y;
    ent.transform.__lastLocalScaleX = ent.transform.localScale.x;
    ent.transform.__lastLocalScaleY = ent.transform.localScale.y;
    ent.transform.__lastAlpha = ent.transform.alpha;
    delete ent.transform.__worldPosition;
  }
}
CreateSystems.prototype.isDirty = function (ent) {
  if (!this.isCameraReady()) {
    return true;
  }
  if (ent && ent.transform) {
    return ent.transform.isDirty > -1 || ent.transform.__positionUpdated || this.isDirty(this.getParent(ent)) || !this.isCameraReady();
  }
  return false;
}

//CreateSystems.prototype.updateSceneGraph = function (dt) {
CreateSystems.prototype.updateSceneGraph = function (dt, ent) {
  const transform = ent.transformGraphCreate.transform;
  if (transform.disabled) {
    this.removeComponent(ent, this.Components.TransformGraphCreate);
    return;
  }
  this.createSceneGraph(ent, transform);
  this.removeComponent(ent, this.Components.TransformGraphCreate);
    //ent.remove();
  //this.debug.stopSystem('sceneGraph - create');
}

CreateSystems.prototype.beforeUpdateTransform = function (dt) {
  this.pixiContainersHitKeys = [];
}
CreateSystems.prototype.afterUpdateTransform = function (dt) {
  const hitKeys = this.pixiContainersHitKeys;
  if (this.__pixiContainersLen !== hitKeys.length) {
    const toRemove = difference(keys(this.pixiContainers), hitKeys);
    const toRemoveLength = toRemove.length;
    //__overrideLayer
    //__overrideVariables
    //__overrideTransforms
    //__internalVariables
    //toySlotsData
    //componentsInTreeCache
    for (let i = 0; i < toRemoveLength; i++) {
        const uuid = toRemove[i];
        //console.log(uuid, 'remove transform');
        const {highlightGraphics,outer,inner,unparent,parent,layer,group} = this.pixiContainers[uuid];
        if (inner) {
          inner.destroy({texture:true,baseTexture:true});
          outer.removeChild(inner);
        }

        if (unparent) {
          outer.destroy({texture:true,baseTexture:true});
          unparent.removeChild(outer)
          unparent.destroy({texture:true,baseTexture:true});
          parent.removeChild(unparent);
        } else {
          outer.destroy({texture:true,baseTexture:true});
          parent.removeChild(outer);
        }

        if (layer) {
          //let zIndex = ent.transform.zIndex;
          //this.returnLayer(parseInt(zIndex), layer, group)
          outer.parentGroup = null;

        }

        delete this.pixiContainers[uuid];
        this.__pixiContainersLen--;

        if (highlightGraphics) {
          //console.log('remove highlightGraphics');
          highlightGraphics.destroy({texture:true,baseTexture:true});
          this.graphics.removeChild(highlightGraphics);
        }


    }
  }

}

CreateSystems.prototype.drawHighlight = function (ent) {
  return (this.highlightTransforms[ent.uuid.__transformId] || this.gameobjects.DEBUG_DRAW);
  //return (this.highlightTransforms[ent.uuid.__transformId] || this.highlightTransforms[ent.uuid.parentTransform] || this.gameobjects.DEBUG_DRAW);
}

CreateSystems.prototype.updateTransform = function (dt, ent) {
  let removed = 0;
//  this.debug.startSystem('removeOutsideEntities', entsLength);
  this.pixiContainersHitKeys.push(ent.uuid.uuid);
  if (!this.isDirty(ent)) {
    if (this.delayFirstRender) {
      delete ent.transform.__worldPosition;
    }
    return;
  }

  const uuid = ent.uuid.uuid;
  if (this.drawHighlight(ent)) {
    if (!this.pixiContainers[uuid].highlightGraphics) {
      this.highlightTransforms[ent.uuid.uuid] = true;
      const graphics = new PIXI.Graphics();
      this.graphics.addChild(graphics);
      this.pixiContainers[uuid].highlightGraphics = graphics;
    }

    const transformWorldPosition = this.getWorldPosition(ent);
    const graphics = this.pixiContainers[uuid].highlightGraphics;
    const bounds = this.getWorldBoundingBox(ent);
    const width = bounds.x2 - bounds.x1;
    const height = bounds.y2 - bounds.y1;
    graphics.clear();
    graphics.lineStyle(0.08, this.highlightColor);
    graphics.drawRect(transformWorldPosition.x - width/2,
                      transformWorldPosition.y - height/2,
                      width,
                      height);
  } else {
    if (this.pixiContainers[uuid] && this.pixiContainers[uuid].highlightGraphics) {
      const graphics = this.pixiContainers[uuid].highlightGraphics;
      this.graphics.removeChild(graphics);
      graphics.destroy({texture:true, baseTexture:true});
      delete this.pixiContainers[uuid].highlightGraphics;
    }
  }


  ent.transform.isDirty--;
  delete ent.transform.__worldPosition;
  const transform = ent.transform;
  let container = this.pixiContainers[uuid].outer;
  let innerContainer = this.pixiContainers[uuid].inner;

  container.position.set(transform.x,
    transform.y);
  container.scale.x = transform.scale.x;
  container.scale.y = transform.scale.y;
  container.rotation = transform.rotation;
  container.alpha = transform.alpha;
  if (innerContainer) {
    innerContainer.scale.x = transform.localScale.x;
    innerContainer.scale.y = transform.localScale.y;
    innerContainer.rotation = transform.localRotation;
  }

}

CreateSystems.prototype.isOutside = function (ent) {
return false;
  const globalPos = this.getWorldPosition(ent);
  const transform = globalPos;
  const x = transform.x;
  const y = transform.y;
  const x1 = -40
  const x2 = 40
  const y1 = -40
  const y2 = 40
  return (x < x1 || x > x2 || y < y1 || y > y2);

}

CreateSystems.prototype.beforeRemoveOutsideEntities = function (dt) {
  this.lastRemoveOutsideEntitiesRun += dt;
}
CreateSystems.prototype.removeOutsideEntities = function (dt, ent) {
  if (this.lastRemoveOutsideEntitiesRun < 500) {
      return;
  }
  this.lastRemoveOutsideEntitiesRun = 0;

  if (ent.transform && this.isOutside(ent)) {
      if (this.dontDelete(ent)) {
          return;
      }
      ent.addComponent(this.Components.Destroy);
      removed++;
  }


}

CreateSystems.prototype.beforeUpdateCooldown = function (dt) {
  this.cooldownGametime += dt/1000;
}
CreateSystems.prototype.updateCooldown = function (dt, ent) {
  const uuid = ent.uuid.uuid;

  const totalLength = ent.cooldown.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.cooldown.multi[j];
    const cooldown = o.c;
    const component = o.component;
    const key = cooldown.cooldownKey ? cooldown.cooldownKey : uuid;

    const cooldownTime = parseFloat(cooldown.cooldown) || 0;
    if (typeof(this.cooldownLast[key]) === "undefined" || this.cooldownLast[key] + cooldownTime <= this.cooldownGametime) {
      this.cooldownLast[key] = this.cooldownGametime;
      //this.addComponent(ent, this.findSlots(ent, cooldown));
      this.addComponent(ent, this.findSlots(ent, component));

      if (cooldown.cooldownEvent) {
        this.cooldownLast[key] = 9999999999999;
        const wasTime = this.cooldownGametime;

        this.events.once(cooldown.cooldownEvent, () => {
          //delete this.cooldownLast[key];
        this.gameobjects.debugLog({
            ent,
            component:{},
            type:'debug',
            line:`Cooldown cleared: ${JSON.stringify(cooldown)}`
          })
            this.cooldownLast[key] = wasTime;
        })
        /*
        const gameEvent = this.gameobjects.events.concat(this.gameobjects.localEvents[uuid] || []).filter( (x) => {
          return x.eventName === ent.cooldown.cooldownEvent;
        } );
        if (gameEvent.length) {
          this.cooldownLast[key] = wasTime;
        }
        */

      }
    } else {
    /*
      this.gameobjects.debugLog({
        ent,
        component:{},
        type:'debug',
        line:`Cooldown blocked: ${JSON.stringify(cooldown)}`
      })
      */
    }

    this.multiRemoveComponent(ent, this.Components.Cooldown, cooldown);
  }

}

CreateSystems.prototype.multi = function (multi, cb) {
  const totalLength = multi.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = multi.multi[j];
    cb(o.c, o.component);
  }
}
CreateSystems.prototype.updateDelayTransform = function (dt, ent) {
  const delayTransform = ent.delayTransform;
  const transform = ent.transform;

  delayTransform.curtime += dt/1000;

  if (!delayTransform.__addComponents) {
    const slots = this.findSlots(ent, delayTransform);
    this.addComponent(ent, slots);
    delayTransform.__addComponents = true;
  }


  let alreadySpawned = 0;
  for (let j = 0; j < transform.children.length; j++) {
    const child = transform.children[j];
    if (includes(delayTransform.spawned, child.id)) {
      alreadySpawned++;
    } else {
      const childDelay = this.getScalar(ent, (child.vars||{}).delay, delayTransform);
      //const childDelay = 1;
      if (delayTransform.curtime >= childDelay) {
        this.createSceneGraphChild(ent, child, false);
        delayTransform.spawned.push(child.id);
      }
    }
  }

  if (alreadySpawned >= transform.children.length) {
    this.removeComponent(ent, this.Components.DelayTransform);
  }

}
CreateSystems.prototype.beforeParallaxTransform = function (dt) {
  this.parallaxHitKeys = [];
}
CreateSystems.prototype.updateParallaxTransform = function (dt, ent) {
  const uuid = ent.uuid.uuid;
  if (!this.parallaxCache[uuid]) {

    const children = this.createSceneGraphChildren(ent, ent.transform)

    const parallaxParent = new PIXI.Container();
    this.cameraContainer.addChild(parallaxParent);
    //this.pixiContainers[uuid].outer.addChild(parallaxParent);
    //parent.removeChild(outer)
    //parent.addChild(parallaxParent);
      //parallaxParent.addChild(outer)

    children.forEach( (child) => {
      const {outer,parent,inner} = this.pixiContainers[child.uuid.uuid]
      parent.removeChild(outer)
      parallaxParent.addChild(outer);
      
    });


    this.parallaxCache[uuid] = {
      children,
      parallaxParent
    };
      //outer:container,
      //parent:parentContainer,
      //inner:innerContainer,


    //this.parallaxCache[uuid].forEach( (child) => {
      //const parallaxContainer = new PIXI.Container();
      //parallaxContainer
    //});

    //ent.transform.scale.x = ent.transform.localScale.x;
    //ent.transform.scale.y = ent.transform.localScale.y;

  }

  const {parallaxParent} = this.parallaxCache[uuid];
  const worldPos = this.getWorldPosition(ent,{
    x:0,
    y:0
  });

  const px = !isNaN(ent.parallaxTransform.px) ? ent.parallaxTransform.px : 1;
  const py = !isNaN(ent.parallaxTransform.py) ? ent.parallaxTransform.py : 1;
  parallaxParent.position.set(
    worldPos.x/px,
    worldPos.y/py
  )

  return;

  let children = this.parallaxCache[uuid];
  let length = children.length;
  for (let i = 0; i < length; i++) {
    const child = children[i];

    child.transform.scale.x = 1/ent.transform.scale.x;
    child.transform.scale.y = 1/ent.transform.scale.y;
    this.conditionallySetDirty(child)
  }
}
CreateSystems.prototype.afterParallaxTransform = function (dt) {
  const hitKeys = this.parallaxHitKeys;
  let removedSprite = false;
  if (this.__parallaxCacheLen !== hitKeys.length) {
    const toRemove = difference(keys(this.parallaxCache), hitKeys);
    const toRemoveLength = toRemove.length;
    for (let i = 0; i < toRemoveLength; i++) {
        const uuid = toRemove[i];
        delete this.parallaxCache[uuid];
        this.__parallaxCacheLen--;
    }
  }

}

CreateSystems.prototype.updateOnEventTransform = function (dt, ent) {
  const onEventTransform = ent.onEventTransform;
  const transform = ent.transform;
  const uuid = ent.uuid.uuid;

  if (!onEventTransform.__addComponents) {
    const slots = this.findSlots(ent, onEventTransform, 'link');
    this.addComponent(ent, slots);
    onEventTransform.__addComponents = true;
  }

  const events = new Set(this.gameobjects.events.concat(this.gameobjects.localEvents[uuid] || []).map( ({eventName}) => {
    return eventName;
  }));
  
  for (let j = 0; j < transform.children.length; j++) {
    const child = transform.children[j];

    //console.log('eventName', child.vars.eventName);
    // TODO: performance improvement, dont split every frame
    const eventNames = child.vars.eventName.split(",");
    //console.log('check events', eventNames);

    let hasEvent = false;
    for (let k = 0; k < eventNames.length; k++) {
      const eventName = eventNames[k];
      if (events.has(eventName)) {
        hasEvent = true;
        break;
      }
    }

    if (hasEvent) {
      const newEnt = this.gameobjects.entities.createEntity();
      this.createUuid(newEnt);
      this.createSceneGraph(newEnt, child, ent, false);

      const slots = this.findSlots(ent, onEventTransform, 'create');
      this.addComponent(ent, slots);
    }
    
  }

}

CreateSystems.prototype.updateRandomTransform = function (dt, ent) {
  const randomTransform = ent.randomTransform;
  const transform = ent.transform;

  const canditates = [];

  if (!randomTransform.__addComponents) {
    const slots = this.findSlots(ent, randomTransform);
    this.addComponent(ent, slots);
    randomTransform.__addComponents = true;
  }

  for (let j = 0; j < transform.children.length; j++) {
    const child = transform.children[j];
    const vars = child.vars || {};
    let weight = 1;
    if (typeof(vars.weight) !== "undefined") {
      weight = vars.weight;
    }

    weight = this.getScalar(ent, weight, randomTransform);
    for (var k = 0; k < weight; k++) {
      canditates.push(child);
    }
  }

  const canditate = shuffle(canditates);
  if (canditate.length) {
    const newEnt = this.gameobjects.entities.createEntity();
    this.createUuid(newEnt);
    this.createSceneGraph(newEnt, canditate[0], ent, false);

    //this.createSceneGraphChild(ent, canditate[0], true);

  }

  this.removeComponent(ent, this.Components.RandomTransform);
  //ent.addComponent(this.Components.Destroy);

}

CreateSystems.prototype.updateDelay = function (dt, ent) {
  const totalLength = ent.delay.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.delay.multi[j];
    const delay = o.c;
    const component = o.component;
    let removeDelays = [];

    const delayTime = parseFloat(this.getScalar(ent, delay.delay, delay));
    delay.curtime += dt/1000;
    if (delay.curtime >= delayTime) {
      this.addComponent(ent, this.findSlots(ent, component));
      this.multiRemoveComponent(ent, this.Components.Delay, delay);
    }
  }
}

CreateSystems.prototype.reparentUnparented = function (dt) {
  const ents = this.gameobjects.entities.queryTag('unparented');

  const length = ents.length;
//  this.debug.startSystem('updateCamera', length);
  for (let i = 0; i < length; i++) {
    const ent = ents[i];

    this.scaleUnparent(ent, ent.__unparentParent, ent.__unparentContainer);

  }
}

CreateSystems.prototype.setOverrideAspectRatio = function (aspect) {
  this.overrideAspect = aspect;
}

CreateSystems.prototype.updatePlaySounds = function (dt, ent) {
  const sound = this.gameobjects.sounds[ent.playSound.sound];
  if (sound) {
    if (ent.playSound.loop) {
      sound.loop(true);
    } else {
      sound.loop(false);
    }
    sound.play();
  }

  this.addComponent(ent, this.findSlots(ent, ent.playSound, 'link'));
  this.removeComponent(ent, this.Components.PlaySound);

}


CreateSystems.prototype.updateMultiple = function (dt, ent) {
  const totalLength = ent.multiple.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.multiple.multi[j];
    const m = o.c;
    if (m.keep && m.done) {
      continue;
    }
    const component = o.component;
    //if (!translate.__addComponents) {
      //const slots = this.findSlots(ent, component, 'link');
    //}
    const multiple = this.findSlots(ent, component);
    const length = multiple.length;
    for (let j = 0; j < length; j++) {
      const c = this.addComponent(ent, multiple[j], true);
      if (c && m.keep) {
        m.added.push(c);
      }
    }
    if (m.keep) {
      m.done = true;
    }
    if (!m.keep) {
      this.multiRemoveComponent(ent, this.Components.Multiple, m);
    }

  }



  //const mainExtensions = this.findComponentExtensions(gameobjects, ent, ent.multiple, 'does_nothing')
  //this.addComponent(ent, mainExtensions);


  //this.removeComponent(ent, this.Components.Multiple);

//  this.debug.stopSystem('updateMultiple');
}

CreateSystems.prototype.updateTranslate = function (dt, ent) {


  const totalLength = ent.translate.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.translate.multi[j];
    const translate = o.c;
    const component = o.component;
    if (!translate.__addComponents) {
      const slots = this.findSlots(ent, component, 'link');
      this.addComponent(ent, slots);
      translate.__addComponents = true;
    }


    let {x,y,rotation} = ent.transform;
    let scalex = ent.transform.scale.x;
    let scaley = ent.transform.scale.y;
    if (translate.translateType === 'add') {
      if (translate.dx !== '') {
        x += parseFloat(this.getScalar(ent, translate.dx, component));
      }
      if (translate.dy !== '') {
        y += parseFloat(this.getScalar(ent, translate.dy, component));
      }
      if (translate.dr !== '') {
        rotation += parseFloat(this.getScalar(ent, translate.dr, component));
      }
      if (translate.dsx !== '') {
        ent.transform.scale.x += parseFloat(this.getScalar(ent, translate.dsx, component));
      }
      if (translate.dsy !== '') {
        ent.transform.scale.y += parseFloat(this.getScalar(ent, translate.dsy, component));
      }
    } else if (translate.translateType === 'set') {
      if (translate.dx !== '') {
        x = parseFloat(this.getScalar(ent, translate.dx, component));
      }
      if (translate.dy !== '') {
        y = parseFloat(this.getScalar(ent, translate.dy, component));
      }
      if (translate.dr !== '') {
        rotation = parseFloat(this.getScalar(ent, translate.dr, component));
      }
      if (translate.dsx !== '') {
        ent.transform.scale.x = parseFloat(this.getScalar(ent, translate.dsx, component));
      }
      if (translate.dsy !== '') {
        ent.transform.scale.y = parseFloat(this.getScalar(ent, translate.dsy, component));
      }
    } else if (translate.translateType === 'lerp' || translate.translateType === 'smooth') {
      const lerp = (v0, v1) => {
        const lerpt = parseFloat(this.getScalar(ent, translate.lerpt))
        const t = dt/1000 * lerpt;
        return v0*(1-t)+v1*t
      }
      
      if (translate.dx !== '') {
        const dx = this.getScalar(ent, translate.dx, component);
        x = lerp(ent.transform.x, dx);
      }
      if (translate.dy !== '') {
        const dy = this.getScalar(ent, translate.dy, component);
        y = lerp(ent.transform.y, dy);
      }
      if (translate.dr !== '') {
        rotation = lerp(ent.transform.rotation, parseFloat(this.getScalar(ent, translate.dr, component)));
      }
      if (translate.dsx !== '') {
        ent.transform.scale.x = lerp(ent.transform.dsx, parseFloat(this.getScalar(ent, translate.dsx, component)));
      }
      if (translate.dsy !== '') {
        ent.transform.scale.y = lerp(ent.transform.dsy, parseFloat(this.getScalar(ent, translate.dsy, component)));
      }
    }

    if (!ent.physicsbody) {
      ent.transform.x = x;
      ent.transform.y = y;
      ent.transform.rotation = rotation;
    } else {
      ent.transform.x = x;
      ent.transform.y = y;
      ent.transform.rotation = rotation;
      ent.transform.__positionUpdated = true;
    }

    if (!translate.keep) {
      this.multiRemoveComponent(ent, this.Components.Translate, translate);
    }


  }

  this.conditionallySetDirty(ent);
}

CreateSystems.prototype.emitEvent = function (ent, event, global=true) {
  if (global) {
    this.gameobjects.emitEvent({eventName:event,localEvent:false});
    this.events.emit(event);
  } else {
    this.gameobjects.debugLog({
      ent,
      component:{},
      type:'debug',
      line:`Local event ${event}`
    })

    this.gameobjects.emitLocalEvent(ent, {eventName:event,localEvent:true});
    this.events.emit(ent.uuid.uuid + "-" + event);
    // and all parents
    const parentEnt = this.getParent(ent);
    if (parentEnt && parentEnt !== this.findRoot()) {
      this.emitEvent(parentEnt, event, false);
    }
  }
}

CreateSystems.prototype.updateEmitEvent = function (dt, ent) {
  const totalLength = ent.emitEvent.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.emitEvent.multi[j];
    const event = o.c;
    const component = o.component;

    this.addComponent(ent, this.findSlots(ent, component, 'link'));
    if (!component.localEvent) {
      this.emitEvent(ent, event.eventName);
    } else {
      this.emitEvent(ent, event.eventName, false);
    }
    this.multiRemoveComponent(ent, this.Components.EmitEvent, event);
  }
}

CreateSystems.prototype.updateMoveHere = function (dt, ent) {
  const targetEnts = this.gameobjects.entities.queryTag(ent.moveHere.tag);
  const targetEntsLength = targetEnts.length;
  for (let j = 0; j < targetEntsLength; j++) {
    const targetEnt = targetEnts[j];

    const moveToComponent = {
      type:'moveto',
      target:[ent.transform.x, ent.transform.y],
      speed:ent.moveHere.speed,
      tween:ent.moveHere.tween
    }

    this.addComponent(targetEnt, [moveToComponent]);



  }
  this.removeComponent(ent, this.Components.MoveHere);

}

CreateSystems.prototype.updateOnEvent = function (dt, ent) {
  const uuid = ent.uuid.uuid;
  
  const totalLength = ent.onEvent.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.onEvent.multi[j];
    const event = o.c;
    const component = o.component;

    let gameEvent;
    if (event.eventName.indexOf(',') !== -1) {
      const events = event.eventName.split(",").map( (x) => {
        return x.trim();
      });
      gameEvent = this.gameobjects.events.concat(this.gameobjects.localEvents[uuid] || []).filter( (x) => {
        return includes(events, x.eventName);
      } );
    } else {
      gameEvent = this.gameobjects.events.concat(this.gameobjects.localEvents[uuid] || []).filter( (x) => {
        return x.eventName === event.eventName;
      } );
    }
    if (gameEvent.length) {
      
      this.addComponent(ent, this.findSlots(ent, component));

      if (event.onceOnly) {
        this.multiRemoveComponent(ent, this.Components.onEvent, event);
      }
    }


  }
}

CreateSystems.prototype.updateRestrictPosition = function (dt, ent) {

  let any = false;
  if (ent.transform.__positionUpdated) {
    return;
  }
  if (ent.transform.x < ent.restrictPosition.minX) {
    this.addComponent(ent, this.findSlots(ent, ent.restrictPosition, 'left'));
    ent.transform.x = ent.restrictPosition.minX;
    ent.transform.__positionUpdated = true;
    ent.transform.__positionUpdated2 = true;
    any = true;
  }
  if (ent.transform.x > ent.restrictPosition.maxX) {
    this.addComponent(ent, this.findSlots(ent, ent.restrictPosition, 'right'));
    ent.transform.x = ent.restrictPosition.maxX;
    ent.transform.__positionUpdated = true;
    ent.transform.__positionUpdated2 = true;
    any = true;
  }
  if (ent.transform.y < ent.restrictPosition.minY) {
    this.addComponent(ent, this.findSlots(ent, ent.restrictPosition, 'top'));
    ent.transform.y = ent.restrictPosition.minY;
    ent.transform.__positionUpdated = true;
    ent.transform.__positionUpdated2 = true;
    any = true;
  }
  if (ent.transform.y > ent.restrictPosition.maxY) {
    this.addComponent(ent, this.findSlots(ent, ent.restrictPosition, 'bottom'));
    ent.transform.y = ent.restrictPosition.maxY;
    ent.transform.__positionUpdated = true;
    ent.transform.__positionUpdated2 = true;
    any = true;
  }

  if (any) {
    //this.updateStopMovement(dt, ent);
    //ent.addComponent(this.Components.StopMovement);
    this.addComponent(ent, this.findSlots(ent, ent.restrictPosition, 'any'));
  }

  this.conditionallySetDirty(ent);

}

CreateSystems.prototype.beforeUserInput = function (dt) {
  if (!this.showingInput) {
    this.showingInput = {};
  }
}
CreateSystems.prototype.afterUserInput = function (dt) {
}
CreateSystems.prototype.updateUserInput = function (dt, ent) {

  const uuid = ent.uuid.uuid;
  if (this.showingInput[uuid]) {
    return;
  }
  //const root = this.findRoot();
  this.prepareGlobalAndLocalVariables(ent);
  const properties = this.getProperties(ent);
  //const properties = root.properties.properties;
  const fields = ent.askInput.properties.map( (prop) => {
    return {
      type:'input',
      label:prop.label,
      model:prop.name,
      //validator:VueFormGenerator.validators.regexp,
      validator:'',
      pattern:'.*',
      required:true
    }
  })
  const schema = {
    fields
  }

  const formatters = {
  }

  this.gameobjects.askUserInput(schema, properties, {
    close:() => {
      this.removeComponent(ent, this.Components.AskInput);
      delete this.showingInput[uuid];
    },
    onValidated:(isValid, inputData) => {
      if (isValid) {
        this.prepareGlobalAndLocalVariables(ent);
        const properties = this.getProperties(ent);
        toPairs(inputData).forEach( (x) => {
          const key = x[0];
          const value = x[1];
          properties[key] = value;
        });
        this.updateGlobalAndLocalVariables(ent, properties);
      }
      this.addComponent(ent, this.findSlots(ent, ent.askInput, isValid ? 'isValid' : 'notValid'));
    },
  }, formatters);
  this.showingInput[uuid] = true;

}


CreateSystems.prototype.resize = function (width, height) {
    //this.debug.addDebugLine(entA, 'collide with: ' + entB._tags.join(','));
  //this.gameobjects.addDebug(`resize: ${width}x${height}`, {
    //duration:1200
  //});
/*
  keys(this.spriteCache).forEach( (name) => {
    const {sprite,parent} = this.spriteCache[name];
    parent.removeChild(sprite);
    delete this.spriteCache[name];
  });
  keys(this.shapeCache).forEach( (name) => {
    const sprite = this.shapeCache[name].shape;
    this.gameobjects.app.stage.removeChild(sprite);
    delete this.shapeCache[name];
  });
  keys(this.animatedSpriteCache).forEach( (name) => {
    const sprite = this.animatedSpriteCache[name].sprite;
    this.gameobjects.app.stage.removeChild(sprite);
    delete this.animatedSpriteCache[name];
  });
  keys(this.tiledSpriteCache).forEach( (name) => {
    const sprite = this.tiledSpriteCache[name];
    this.gameobjects.app.stage.removeChild(sprite);
    delete this.tiledSpriteCache[name];
  });
  */

  this.endOfFrame.push( () => {
    this.delayFirstRenderCounter = this.delayCameraForFrames;
    this.delayFirstRender = true;
    this.gameobjects.cameraDt = 0;
    this.gameobjects.foundCamera = false;

    //this.gameobjects.app.stage.removeChild(this.overlay);
    //this.overlay = new PIXI.Container();
    //this.gameobjects.app.stage.addChild(this.overlay);

    for (let i = 0; i < this.gameobjects.entities._entities.length; i++) {
      const ent = this.gameobjects.entities._entities[i];
      if (ent.transform) {
        this.conditionallySetDirty(ent);
        ent.transform.isDirty = Math.abs(this.delayCameraForFrames)
      }
    }

    this.endOfFrame.push( () => {
      // does this fix the resizing issue in triviaforge-shell?
      const hitContainer = this.gameobjects.app.renderer.plugins.interaction.hitTest({x:0,y:0});
    });

  });
  /*
  this.spriteCache = {};
  this.collisionBoxCache = {};
  this.shapeCache = {};
  this.animatedSpriteCache = {};
  this.tiledSpriteCache = {};
  */
  this.gameobjects.screenWidth = width;
  this.gameobjects.screenHeight = height;

  this.gameobjects.addDebug(`size is: ${width}x${height}`);



  this.overlay.removeChild(this.letterBox);
  this.letterBox = null;
  //this.gameobjects.app.stage.addChild(this.letterboxLayer);
}


CreateSystems.prototype.addCollisionForTile = function (layerNum, tile, parentTransform) {
//return;
  const ent = this.gameobjects.entities.createEntity();
  ent.addComponent(this.Components.Transform);
  this.createUuid(ent);
  ent.addComponent(this.Components.CollisionBox);

  const tag = 'layer' + layerNum;
  const scalex = 1;
  const scaley = 1;
  const x = this.gameobjects.coords.dimToWorldX(tile.mapx) + parentTransform.x*0;
  const y = this.gameobjects.coords.dimToWorldY(tile.mapy) + parentTransform.y*0;
  //this.Components.Transform.create(ent, x*parentTransform.scalex, y*parentTransform.scaley, scalex, scaley, 0.0, 0.0);
  this.Components.Transform.create(ent, 
    x*parentTransform.scalex + parentTransform.x, 
    y*parentTransform.scaley + parentTransform.y, 
    scalex, 
    scaley, 
    0.0, 
    0.0);
  this.Components.Uuid.create(ent);
  this.Components.CollisionBox.create(ent, tag, 1, 1);
  /*
  this.Components.PhysicsBody2D.create(ent, {
    bodyType:'static'
  });
  */
  const x1 = ent.transform.x;
  const x2 = ent.transform.x + ent.transform.scalex;
  const y1 = ent.transform.y;
  const y2 = ent.transform.y + ent.transform.scaley;

  const bd_tile = new this.gameobjects.Box2D.b2BodyDef();
  const bod_tile = this.gameobjects.box2d_world.CreateBody(bd_tile);
  bod_tile.userData = ent;
  let edge1 = new this.gameobjects.Box2D.b2EdgeShape();
  edge1.Set( 
    this.createBox2d_b2Vec2(x1,y1),
    this.createBox2d_b2Vec2_b(x2,y1) 
  );
  edge1.set_m_vertex0( this.createBox2d_b2Vec2(x1-0.1, y1));
  edge1.set_m_vertex3( this.createBox2d_b2Vec2_b(x2+0.1, y1));
  edge1.set_m_hasVertex0(true);
  edge1.set_m_hasVertex3(true);

  let edge2 = new this.gameobjects.Box2D.b2EdgeShape();
  edge2.Set( 
    this.createBox2d_b2Vec2(x2,y1),
    this.createBox2d_b2Vec2_b(x2,y2) 
  );
  edge2.set_m_vertex0( this.createBox2d_b2Vec2(x2, y1-0.1));
  edge2.set_m_vertex3( this.createBox2d_b2Vec2_b(x2, y2+0.1));
  edge2.set_m_hasVertex0(true);
  edge2.set_m_hasVertex3(true);

  let edge3 = new this.gameobjects.Box2D.b2EdgeShape();
  edge3.Set( 
    this.createBox2d_b2Vec2(x2,y2),
    this.createBox2d_b2Vec2_b(x1,y2) 
  );
  edge3.set_m_vertex0( this.createBox2d_b2Vec2(x2+0.1, y2));
  edge3.set_m_vertex3( this.createBox2d_b2Vec2_b(x1-0.1, y2));
  edge3.set_m_hasVertex0(true);
  edge3.set_m_hasVertex3(true);

  let edge4 = new this.gameobjects.Box2D.b2EdgeShape();
  edge4.Set( 
    this.createBox2d_b2Vec2(x1,y2),
    this.createBox2d_b2Vec2_b(x1,y1) 
  );
  edge4.set_m_vertex0( this.createBox2d_b2Vec2(x1, y2+0.1));
  edge4.set_m_vertex3( this.createBox2d_b2Vec2_b(x1, y1-0.1));
  edge4.set_m_hasVertex0(true);
  edge4.set_m_hasVertex3(true);

  bd_tile.set_type(this.gameobjects.Box2D.b2_staticBody);
  bod_tile.CreateFixture(edge1, 0.0);
  bod_tile.CreateFixture(edge2, 0.0);
  bod_tile.CreateFixture(edge3, 0.0);
  bod_tile.CreateFixture(edge4, 0.0);

  /*
  let shape = new this.gameobjects.Box2D.b2PolygonShape();
  shape.SetAsBox(ent.transform.scalex/2, ent.transform.scaley/2);

  let bd = new this.gameobjects.Box2D.b2BodyDef();
  if (physicsBodyComponent.bodyType === 'static') {
    bd.set_type(this.gameobjects.Box2D.b2_staticBody);
  } else if (physicsBodyComponent.bodyType === 'dynamic') {
    bd.set_type(gameobjects.Box2D.b2_dynamicBody);
  } else if (physicsBodyComponent.bodyType === 'kinematic') {
    bd.set_type(gameobjects.Box2D.b2_kinematicBody);
  } else {
    bd.set_type(gameobjects.Box2D.b2_staticBody);
  }
  bd.set_position(new gameobjects.Box2D.b2Vec2(
    ent.transform.x + (0.5 - ent.transform.anchorx),
    ent.transform.y + (0.5 - ent.transform.anchory)));
    */

}


CreateSystems.prototype.updateTileMap = function (dt) {
  const ents = this.gameobjects.entities.queryComponents([this.Components.TileMap, this.Components.Transform, this.Components.Uuid]);
  const total = ents.length;
//  this.debug.startSystem('updateTileMap', length);
  for (let i = 0; i < total; i++) {
    const ent = ents[i];
    const tileMap = ent.tileMap;
    const uuid = ent.uuid.uuid;
    if (!this.tilemapCache[uuid]) {
      this.tilemapCache[uuid] = true;
      /*
      const container = this.pixiContainers[ent.uuid.uuid].outer;
      const mapContainer = new PIXI.Container();
      container.addChild(mapContainer);

      const pixelRatio = this.gameobjects.app.renderer.resolution;
      const gameWidth = tileMap.tiled.width * 40;
      const gameHeight = tileMap.tiled.height * 40;
      const game = {
        width:gameWidth/40,
        height:gameHeight/40,
        scale: 1/40*pixelRatio,
        viewX: 0,
        viewY: 0,

        tiledMap: null,
        tileLayers: null,

        tilemap: null,
        timer: {
          now: 0,
          last: 0,
          timeStep: 0,
        }
      }
      game.tiledMap = new Tiled.Map({
          viewWidth: gameWidth,
          viewHeight: gameHeight,
          data: tileMap.tiled
      });

      mapContainer.scale.x = 1
      mapContainer.scale.y = 1

      const tileTextures = game.tiledMap.createTileTextures( (name, image) => {
        return this.gameobjects.resources[name].textures;
      }, (tilesetName, origIndex) => {
        const tileset = tileMap.tiled.tilesets.filter( (t) => {
          return t.name === tilesetName;
        })[0];
        let startIndex = tileset.firstgid - 1;
        let index = origIndex - startIndex;
        const allFrames = keys(this.gameobjects.resources[tilesetName].textures);
        allFrames.sort();
        return this.gameobjects.resources[tilesetName].textures[allFrames[index]];
      });

      game.tiledMap.tileLayers.forEach((tileLayer,i) => {
        tileLayer.minViewX = -20000;
        tileLayer.minViewY = -20000;
        tileLayer.maxViewX = 20000;
        tileLayer.maxViewY = 20000;
        tileLayer.minScale = 0;
        tileLayer.maxScale = Infinity;
        tileLayer.init();
      });

      game.tiledMap.tileLayers.forEach(function(tileLayer) {
      });
      game.tiledMap.tileLayers.forEach((tileLayer,i) => {
          tileLayer.setScale(game.scale);

          const tileMap = game.tiledMap.createTilemap(tileTextures);
          tileMap.id="ttt" + i;
          mapContainer.addChild(tileMap);

          tileLayer.scrollViewTo(- game.tiledMap.cols * 60 / pixelRatio, 0);
          tileLayer.updateTilemap(tileMap);
      });

      this.tilemapCache[uuid] = {
        container,
        game
      }
      */
      const childrenEnts = this.createSceneGraphChildren(ent, ent.transform);
      const childrenEntsLength = childrenEnts.length;
      const rows = 40;
      const cols = 40;

      for (let k = 0; k < childrenEntsLength; k++) {
        const childEnt = childrenEnts[k];
        const {x,y} = childEnt.transform;
        const zIndex = y * cols + x;
        childEnt.transform.zIndex = zIndex;

      }
    }

  }

//  this.debug.stopSystem('updateTileMap');
}




function setProps(gameobjects, physicsBodyComponent, body, bd) {
  let fixture = body.GetFixtureList();
  let fixturePointer = gameobjects.Box2D.getPointer(fixture);
  while (fixturePointer) {

    fixture.SetDensity(physicsBodyComponent.density);
    fixture.SetRestitution(physicsBodyComponent.restitution);
    fixture.SetFriction(physicsBodyComponent.friction);
    fixture.SetSensor(physicsBodyComponent.isSensor);
    const filterdata = fixture.GetFilterData();
    if (physicsBodyComponent.maskBits) {
      filterdata.set_maskBits(parseInt(physicsBodyComponent.maskBits));
    }
    if (physicsBodyComponent.categoryBits) {
      filterdata.set_categoryBits(parseInt(physicsBodyComponent.categoryBits));
    }
    if (physicsBodyComponent.groupIndex) {
      filterdata.set_groupIndex(parseInt(physicsBodyComponent.groupIndex));
    }
    fixture.SetFilterData(filterdata);


    fixture = fixture.GetNext();
    fixturePointer = gameobjects.Box2D.getPointer(fixture);
  }

  bd.set_angularDamping(physicsBodyComponent.angularDamping);
  bd.set_linearDamping(physicsBodyComponent.linearDamping);

  body.SetGravityScale(physicsBodyComponent.gravityScale);

}

function setProps2(gameobjects, physicsBodyComponent, body, bd, fixture) {
    fixture.set_density(physicsBodyComponent.density);
    fixture.set_restitution(physicsBodyComponent.restitution);
    fixture.set_friction(physicsBodyComponent.friction);
    fixture.set_isSensor(physicsBodyComponent.isSensor);
    let filter = new gameobjects.Box2D.b2Filter;
    if (physicsBodyComponent.maskBits) {
      filter.set_maskBits(parseInt(physicsBodyComponent.maskBits));
    }
    if (physicsBodyComponent.categoryBits) {
      filter.set_categoryBits(parseInt(physicsBodyComponent.categoryBits));
    }
    if (physicsBodyComponent.groupIndex) {
      filter.set_groupIndex(parseInt(physicsBodyComponent.groupIndex));
    }
    fixture.set_filter(filter);


  bd.set_angularDamping(physicsBodyComponent.angularDamping);
  bd.set_linearDamping(physicsBodyComponent.linearDamping);

  body.SetGravityScale(physicsBodyComponent.gravityScale);

}


CreateSystems.prototype.isCameraReady = function (ent) {
  return this.noCamera || (this.gameobjects.foundCamera && this.delayFirstRenderCounter <= -3);
}
CreateSystems.prototype.shouldUpdateTransform = function (ent, force=false) {
  return force || (this.delayFirstRenderCounter >= -3 || !this.gameobjects.foundCamera);
}
CreateSystems.prototype.getLocalPosition = function (ent, pos) {
  // pos is in camera coordinates
  // take it to screen coordinates
  const screenPos = this.cameraContainer.worldTransform.apply(pos);
  // now take screenPos into the parent of ent
  if (this.hasParent(ent)) {
    const parentUuid = this.getParent(ent).uuid.uuid;
    if (this.pixiContainers[ent.uuid.uuid].unparent) {
      let parent = this.pixiContainers[ent.uuid.uuid].unparent;
      this.updatePixiTransform(ent);
      return parent.worldTransform.applyInverse(screenPos)
    } else if (parentUuid && this.pixiContainers[parentUuid]) {
      let parent = this.pixiContainers[parentUuid].outer;
      if (parent.parent) {
        this.updatePixiTransform(ent);
      }
      return parent.worldTransform.applyInverse(screenPos)
    } else {
      return pos;
    }
  } else {
    return pos;
  }
}
CreateSystems.prototype.getWorldScale = function (ent) {
  if (!this.hasParent(ent)) {
    return {
      x:ent.transform.localScale.x*ent.transform.scale.x,
      y:ent.transform.localScale.y*ent.transform.scale.y
    }
  }
  const parent = this.pixiContainers[ent.uuid.uuid];
  const outer = parent.outer;
  const inner = parent.inner;

  this.updatePixiTransform(ent);

  const wt = inner.worldTransform;
  //const bounds = this.getWorldBoundingBox(ent);
  //console.log('my bounds', bounds);

  //const scalex = wt.a / this.cameraContainer.scale.x;
  //const scaley = wt.d / this.cameraContainer.scale.y;

  const sx = Math.sqrt(wt.a*wt.a + wt.b*wt.b);
  const sy = Math.sqrt(wt.c*wt.c + wt.d*wt.d);
  const scalex = sx / this.cameraContainer.scale.x;
  const scaley = sy / this.cameraContainer.scale.y;

  return {
    x: scalex,
    y: scaley
  }

}
CreateSystems.prototype.getWorldVector = function (ent, sv) {
  if (!this.hasParent(ent)) {
    return {
      x:sv.x,
      y:sv.y
    }
  }

  const containers = this.pixiContainers[ent.uuid.uuid];
  let container = containers.inner;
  let p = {x:sv.x,y:sv.y}
  if (containers.unparent) {
    container = containers.unparent;
  }

  this.updatePixiTransform(ent);

  const screenPos = container.worldTransform.apply(p);
  const tp = this.cameraContainer.worldTransform.applyInverse(screenPos);

  p = {
    x:0,
    y:0
  }

  const tp2 = this.cameraContainer.worldTransform.applyInverse(container.worldTransform.apply(p))
  return {
    x:tp.x - tp2.x,
    y:tp.y - tp2.y
  }

}

CreateSystems.prototype.convertWidthAndHeightToWorld = function (ent, width, height) {

  const unit = this.cameraContainer.toLocal({
    x:0,
    y:0
  });

  const converted = this.cameraContainer.toLocal({
    x:width,
    y:height
  });
  return {
    width:converted.x - unit.x,
    height:converted.y - unit.y
  }
}
CreateSystems.prototype.getWorldBoundingBox = function (ent) {
  const e = this.pixiContainers[ent.uuid.uuid];
  const outer = e.outer;

  const transformWorldPosition = this.getWorldPosition(ent);
  const bounds = outer.getBounds();
  //const worldPos = this.cameraContainer.toLocal(interaction.pos);
  const topLeft = this.cameraContainer.toLocal({
    x:0*transformWorldPosition.x + bounds.x - bounds.width/2,
    y:0*transformWorldPosition.y + bounds.y - bounds.height/2
  })
  const bottomRight = this.cameraContainer.toLocal({
    x:0*transformWorldPosition.x + bounds.x + bounds.width/2,
    y:0*transformWorldPosition.y + bounds.y + bounds.height/2,
  })
  return {
    x1:topLeft.x,
    x2:bottomRight.x,
    y1:topLeft.y,
    y2:bottomRight.y
  }
}

CreateSystems.prototype.getScreenPos = function (ent, p = {x:0,y:0}) {
  if (!ent.transform) {
    return {
      x:0,
      y:0
    }
  }

  const containers = this.pixiContainers[ent.uuid.uuid];
  let container = containers.outer;
  //let p = {x:ent.transform.x,y:ent.transform.y};
  if (containers.unparent) {
    //container = containers.unparent;
  }

  this.updatePixiTransform(ent);

  const screenPos = container.worldTransform.apply(p);
  return {
    x:screenPos.x - this.gameobjects.app.stage.position.x,
    y:screenPos.y - this.gameobjects.app.stage.position.y
  }
}

CreateSystems.prototype.cacheWorldPosition = function (ent, worldPosition) {
  if (this.isCameraReady(ent)) {
    ent.transform.__worldPosition = worldPosition;
  }
}

CreateSystems.prototype.isAnyParentDirty = function (ent) {
  return this.isDirty(ent);
  //const parent = this.getParent(ent);
  //return parent ? (this.isDirty(parent) || this.isAnyParentDirty(parent)) : false;

}

CreateSystems.prototype.getWorldPosition = function (ent, p = {x:0,y:0}) {
  if (!ent.transform) {
    return {
      x:0,
      y:0
    }
  }

  if (ent.transform.__worldPosition) {
    if (this.isDirty(ent)) {
      delete ent.transform.__worldPosition;
    }
  }
  if (ent.transform.__worldPosition) {
    return ent.transform.__worldPosition;
  }
  if (!this.hasParent(ent)) {
    const worldPos = {
      x:ent.transform.x + p.x,
      y:ent.transform.y + p.y
    }
    this.cacheWorldPosition(ent, worldPos);
    return worldPos;
  }

  const containers = this.pixiContainers[ent.uuid.uuid];
  let container = containers.outer;
  ///let p = {x:ent.transform.x,y:ent.transform.y};
  if (containers.unparent) {
    //container = containers.unparent;
  }
  this.updatePixiTransform(ent);

  const screenPos = container.worldTransform.apply(p);
  const pp = this.cameraContainer.worldTransform.applyInverse(screenPos)
  this.cacheWorldPosition(ent, pp);
  return pp;
}

CreateSystems.prototype.getPhysicsLinearVelocity = function (ent) {
  const uuid = ent.uuid.uuid;
  const physicsBoxes = this.physicsBoxes2D[uuid];
  const physicsBox = physicsBoxes[0];
  const velocity = physicsBox.GetLinearVelocity();
  const o = {
    x:velocity.get_x(),
    y:velocity.get_y(),
  }
  return o;
}

CreateSystems.prototype.getPhysicsPosition = function (ent) {
  const uuid = ent.uuid.uuid;
  const physicsBoxes = this.physicsBoxes2D[uuid];
  const physicsBox = physicsBoxes[0];
  let bpos = physicsBox.GetPosition();
  const inPos = {
    x:bpos.get_x(),
    y:bpos.get_y()
  }
  return inPos;
}

CreateSystems.prototype.addPhysicsBodyJoints = function (ent, bodyA) {
  if (this.hasParent(ent)) {
    const p = this.getParent(ent);
    if (p.physicsbody) {
      // add the joints

      let jointDef = new this.gameobjects.Box2D.b2WeldJointDef;
      //let jointDef = new this.gameobjects.Box2D.b2DistanceJointDef;

      jointDef.set_bodyA(bodyA);
      const parentBodies = this.physicsBoxes2D[p.uuid.uuid];
      const parentBody = parentBodies[0];
      jointDef.set_bodyB(parentBodies[0]);
      const positionA = bodyA.GetPosition();
      const positionB = parentBody.GetPosition();
      const whatever = {
        x:positionA.get_x() - positionB.get_x(),
        y:positionA.get_y() - positionB.get_y()
      }
      jointDef.set_localAnchorA(this.createBox2d_b2Vec2(0, 0));
      //jointDef.set_localAnchorA(positionA);
      jointDef.set_localAnchorB(this.createBox2d_b2Vec2(whatever.x, whatever.y));
      jointDef.set_collideConnected(false);
      //jointDef.set_length(0.2);
      //jointDef.set_dampingRatio(j.dampingRatio);
      //jointDef.set_frequencyHz(j.frequencyHZ);
      this.gameobjects.box2d_world.CreateJoint(jointDef)

    }
  }

}

CreateSystems.prototype.updatePhysicsBody2D = function (dt, ent) {
  const physicsBodyComponent = ent.physicsbody2d;
  const uuid = ent.uuid.uuid;

  ent.addTag(ent.physicsbody2d.componentId);

  if (!this.isCameraReady(ent)) {
    return
  }

  let scale = physicsBodyComponent.scale;
  let scalex = physicsBodyComponent.scalex || 1;
  let scaley = physicsBodyComponent.scaley || 1;
  if (physicsBodyComponent.bodyType === 'static') {
    if (physicsBodyComponent.shapeType !== 'circle') {

      if (false && physicsBodyComponent.edges) {
        const bd_tile = new this.gameobjects.Box2D.b2BodyDef();
        const worldScale = this.getWorldScale(ent);
        //const x1 = 0*ent.transform.x - ent.transform.localScale.x/2;
        //const x2 = 0*ent.transform.x + ent.transform.localScale.x/2;
        //const y1 = 0*ent.transform.y - ent.transform.localScale.y/2;
        //const y2 = 0*ent.transform.y + ent.transform.localScale.y/2;
        const x1 = -1 * Math.max(worldScale.x,0.05)/2 * scale;
        const x2 = Math.max(worldScale.x,0.05)/2 * scale;
        const y1 = -1 * Math.max(worldScale.y,0.05)/2 * scale;
        const y2 = Math.max(worldScale.y,0.05)/2 * scale;

        let edge1 = new this.gameobjects.Box2D.b2EdgeShape();
        edge1.Set(
          this.createBox2d_b2Vec2(x1,y1),
          this.createBox2d_b2Vec2_b(x2,y1)
        );
        edge1.set_m_vertex0( this.createBox2d_b2Vec2(x1-0.1, y1));
        edge1.set_m_vertex3( this.createBox2d_b2Vec2_b(x2+0.1, y1));
        edge1.set_m_hasVertex0(true);
        edge1.set_m_hasVertex3(true);

        let edge2 = new this.gameobjects.Box2D.b2EdgeShape();
        edge2.Set(
          this.createBox2d_b2Vec2(x2,y1),
          this.createBox2d_b2Vec2_b(x2,y2)
        );
        edge2.set_m_vertex0( this.createBox2d_b2Vec2(x2, y1-0.1));
        edge2.set_m_vertex3( this.createBox2d_b2Vec2_b(x2, y2+0.1));
        edge2.set_m_hasVertex0(true);
        edge2.set_m_hasVertex3(true);

        let edge3 = new this.gameobjects.Box2D.b2EdgeShape();
        edge3.Set(
          this.createBox2d_b2Vec2(x2,y2),
          this.createBox2d_b2Vec2_b(x1,y2)
        );
        edge3.set_m_vertex0( this.createBox2d_b2Vec2(x2+0.1, y2));
        edge3.set_m_vertex3( this.createBox2d_b2Vec2_b(x1-0.1, y2));
        edge3.set_m_hasVertex0(true);
        edge3.set_m_hasVertex3(true);

        let edge4 = new this.gameobjects.Box2D.b2EdgeShape();
        edge4.Set(
          this.createBox2d_b2Vec2(x1,y2),
          this.createBox2d_b2Vec2_b(x1,y1)
        );
        edge4.set_m_vertex0( this.createBox2d_b2Vec2(x1, y2+0.1));
        edge4.set_m_vertex3( this.createBox2d_b2Vec2_b(x1, y1-0.1));
        edge4.set_m_hasVertex0(true);
        edge4.set_m_hasVertex3(true);

        bd_tile.set_type(this.gameobjects.Box2D.b2_staticBody);

        const worldPos = this.getWorldPosition(ent);
        const localPos = this.getLocalPosition(ent, {x:0,y:0});
        bd_tile.set_position(
          this.createBox2d_b2Vec2(
            worldPos.x,
            worldPos.y
          )
        )
        const bod_tile = this.gameobjects.box2d_world.CreateBody(bd_tile);
        bod_tile.CreateFixture(edge1, 0.0);
        bod_tile.CreateFixture(edge2, 0.0);
        bod_tile.CreateFixture(edge3, 0.0);
        bod_tile.CreateFixture(edge4, 0.0);
        bod_tile.userData = ent;
        setProps(this.gameobjects, physicsBodyComponent, bod_tile, bd_tile);
        if (!this.physicsBoxes2D[uuid]) {
          this.physicsBoxes2D[uuid] = [];
          this.__physicBoxes2DLen++;
        }
        this.physicsBoxes2D[uuid].push(bod_tile);

        bod_tile.SetTransform( bod_tile.GetPosition(), ent.transform.rotation + ent.transform.localRotation);
        //bod_tile.SetAngle(2);
        ent.addComponent(this.Components.PhysicsBody);

        this.addPhysicsBodyJoints(ent, bod_tile);
        this.gameobjects.Box2D.destroy(bd);
        this.gameobjects.Box2D.destroy(edge1);
        this.gameobjects.Box2D.destroy(edge2);
        this.gameobjects.Box2D.destroy(edge3);
        this.gameobjects.Box2D.destroy(edge4);

      } else {

        const worldScale = this.getWorldScale(ent);

        const myScale = {
          x:Math.max(0.05,worldScale.x),
          y:Math.max(0.05,worldScale.y),
        }
        const shape = new this.gameobjects.Box2D.b2PolygonShape();
        shape.SetAsBox(myScale.x/2 * scale, myScale.y/2 * scale)

        //let shape = new this.gameobjects.Box2D.b2PolygonShape();
        //shape.SetAsBox(Math.abs(ent.transform.scalex)/2, Math.abs(ent.transform.scaley)/2);

        let bd = new this.gameobjects.Box2D.b2BodyDef();
        bd.set_type(this.gameobjects.Box2D.b2_staticBody);

        const worldPos = this.getWorldPosition(ent);
        bd.set_position(this.createBox2d_b2Vec2(
          worldPos.x,
          worldPos.y
        ));

        let body = this.gameobjects.box2d_world.CreateBody(bd);
        body.CreateFixture(shape, 1);
        setProps(this.gameobjects, physicsBodyComponent, body, bd);
        body.userData = ent;

        if (!this.physicsBoxes2D[uuid]) {
          this.physicsBoxes2D[uuid] = [];
          this.__physicBoxes2DLen++;
        }
        this.physicsBoxes2D[uuid].push(body);
        body.SetTransform( body.GetPosition(), ent.transform.rotation + ent.transform.localRotation);
        ent.addComponent(this.Components.PhysicsBody);

        this.addPhysicsBodyJoints(ent, body);
        body.SetAwake(0);
        this.gameobjects.Box2D.destroy(bd);
        this.gameobjects.Box2D.destroy(shape);

      }

    } else {
      const shape = new this.gameobjects.Box2D.b2CircleShape();
      shape.set_m_radius(ent.transform.scale.x * scale);

      //let shape = new this.gameobjects.Box2D.b2PolygonShape();
      //shape.SetAsBox(Math.abs(ent.transform.scalex)/2, Math.abs(ent.transform.scaley)/2);

      let bd = new this.gameobjects.Box2D.b2BodyDef();
      bd.set_type(this.gameobjects.Box2D.b2_staticBody);

      const worldPos = this.getWorldPosition(ent);
      bd.set_position(this.createBox2d_b2Vec2(
        worldPos.x,
        worldPos.y
      ));

      let body = this.gameobjects.box2d_world.CreateBody(bd);
      body.CreateFixture(shape, 1);
      setProps(this.gameobjects, physicsBodyComponent, body, bd);
      body.userData = ent;
      body.SetAwake(0);

      if (!this.physicsBoxes2D[uuid]) {
        this.physicsBoxes2D[uuid] = [];
        this.__physicBoxes2DLen++;
      }
      this.physicsBoxes2D[uuid].push(body);
      body.SetTransform( body.GetPosition(), ent.transform.rotation + ent.transform.localRotation);
      ent.addComponent(this.Components.PhysicsBody);

      this.addPhysicsBodyJoints(ent, body);
      this.gameobjects.Box2D.destroy(bd);

    }

  } else if (physicsBodyComponent.bodyType === 'dynamic') {
    const worldScale = this.getWorldScale(ent);

    const myScale = {
      x:Math.max(0.05,worldScale.x),
      y:Math.max(0.05,worldScale.y),
    }
    let shape;
    let fixture = new this.gameobjects.Box2D.b2FixtureDef;
    if (physicsBodyComponent.shapeType === 'circle') {
      shape = new this.gameobjects.Box2D.b2CircleShape();
      shape.set_m_radius(myScale.x/2 * scale);
      //shape.set_m_p(this.createBox2d_b2Vec2(0, 0));

    } else {
      shape = new this.gameobjects.Box2D.b2PolygonShape();
      shape.SetAsBox(myScale.x/2 * scale * scalex, myScale.y/2 * scale * scaley)
    }

    let bd = new this.gameobjects.Box2D.b2BodyDef();
    bd.set_type(this.gameobjects.Box2D.b2_dynamicBody);
    bd.set_fixedRotation(physicsBodyComponent.fixedRotation);

    const worldPos = this.getWorldPosition(ent);
    bd.set_position(this.createBox2d_b2Vec2(
      worldPos.x,
      worldPos.y
    ));

    let body = this.gameobjects.box2d_world.CreateBody(bd);
    setProps2(this.gameobjects, physicsBodyComponent, body, bd, fixture);
    fixture.set_shape(shape);
    body.CreateFixture(fixture);
    body.userData = ent;

    if (!this.physicsBoxes2D[uuid]) {
      this.physicsBoxes2D[uuid] = [];
      this.__physicBoxes2DLen++;
    }
    this.physicsBoxes2D[uuid].push(body);
    body.SetTransform( body.GetPosition(), ent.transform.rotation + ent.transform.localRotation);

    ent.addComponent(this.Components.PhysicsBody);

    this.addPhysicsBodyJoints(ent, body);

    this.gameobjects.Box2D.destroy(bd);
    this.gameobjects.Box2D.destroy(shape);
    this.gameobjects.Box2D.destroy(fixture);

  } else if (physicsBodyComponent.bodyType === 'kinematic') {
    const worldScale = this.getWorldScale(ent);

    const myScale = {
      x:Math.max(0.05,worldScale.x),
      y:Math.max(0.05,worldScale.y),
    }
    let shape;
    let fixture = new this.gameobjects.Box2D.b2FixtureDef;
    if (physicsBodyComponent.shapeType === 'circle') {
      shape = new this.gameobjects.Box2D.b2CircleShape();
      shape.set_m_radius(myScale.x/2 * scale);
      //shape.set_m_p(this.createBox2d_b2Vec2(0, 0));

    } else {
      shape = new this.gameobjects.Box2D.b2PolygonShape();
      shape.SetAsBox(myScale.x/2 * scale, myScale.y/2 * scale)
    }

    let bd = new this.gameobjects.Box2D.b2BodyDef();
    bd.set_type(this.gameobjects.Box2D.b2_kinematicBody);
    bd.set_fixedRotation(physicsBodyComponent.fixedRotation);

    const worldPos = this.getWorldPosition(ent);
    bd.set_position(this.createBox2d_b2Vec2(
      worldPos.x,
      worldPos.y
    ));

    let body = this.gameobjects.box2d_world.CreateBody(bd);
    setProps2(this.gameobjects, physicsBodyComponent, body, bd, fixture);
    fixture.set_shape(shape);
    body.CreateFixture(fixture);
    body.userData = ent;

    if (!this.physicsBoxes2D[uuid]) {
      this.physicsBoxes2D[uuid] = [];
      this.__physicBoxes2DLen++;
    }
    this.physicsBoxes2D[uuid].push(body);
    body.SetAwake(0);
    body.SetTransform( body.GetPosition(), ent.transform.rotation + ent.transform.localRotation);

    ent.addComponent(this.Components.PhysicsBody);

    this.addPhysicsBodyJoints(ent, body);
    this.gameobjects.Box2D.destroy(bd);
    this.gameobjects.Box2D.destroy(shape);
    this.gameobjects.Box2D.destroy(fixture);
    
    /*
    let shape = new this.gameobjects.Box2D.b2PolygonShape();
    shape.SetAsBox(ent.transform.scalex/2 * scale, ent.transform.scaley/2 * scale);

    let bd = new this.gameobjects.Box2D.b2BodyDef();
    bd.set_type(this.gameobjects.Box2D.b2_kinematicBody);

    const worldPos = this.getWorldPosition(ent);
    bd.set_position(this.createBox2d_b2Vec2(
      worldPos.x,
      worldPos.y
    ));

    let body = this.gameobjects.box2d_world.CreateBody(bd);
    body.CreateFixture(shape, 1);
    setProps(this.gameobjects, physicsBodyComponent, body, bd);
    body.userData = ent;

    this.physicsBoxes2D[uuid] = body;
    ent.addComponent(this.Components.PhysicsBody);
    */

    this.conditionallySetDirty(ent);

  } else if (physicsBodyComponent.bodyType === 'advanced') {
    const WorldLoader = MakeWorldLoader.MakeWorldLoader(this.gameobjects.Box2D);

    const data = JSON.parse(physicsBodyComponent.sceneData);
    WorldLoader.loadJsonScene(
      data,
      this.gameobjects.box2d_world,
      ent.transform
    );

    const sceneData = JSON.parse(physicsBodyComponent.sceneData);
    let i = 0;
    sceneData.bodies.forEach( (bodyData) => {
      i++;
      const body = WorldLoader.loadedBodies[i-1];
      const bodyPos = body.GetPosition();
      const bodyPos_x = bodyPos.get_x();
      const bodyPos_y = bodyPos.get_y();

      const link = bodyData.name ? bodyData.name : ('body-' + i);
      const slots = this.findSlots(ent, physicsBodyComponent, link);
      if (slots.length === 0) {
        return;
      }

      const entity = this.gameobjects.entities.createEntity();
      this.createUuid(entity);
      const firstShape = bodyData.fixtures[0].shapes[0];
      const TransformComponent = {
        type:"transform",
        data:{
          pos:{
            x:bodyPos_x,
            y:bodyPos_y,
          },
          dx:0, dy:0,
          scale:{
            x:(firstShape.radius ? (2*firstShape.radius) : (4*firstShape.width)) / toWorldRatio ,
            y:(firstShape.radius ? (2*firstShape.radius) : (4*firstShape.height)) / toWorldRatio
          }
        },
      }
      
      entity.addComponent(this.Components.PhysicsBody);
      entity.physicsbody.ignoreRotation = ent.physicsbody2d.ignoreRotation;
      this.addComponent(entity, [TransformComponent]);
      this.addComponent(entity, slots);
      body.userData = entity;
      if (!this.physicsBoxes2D[uuid]) {
        this.physicsBoxes2D[uuid] = [];
        this.__physicBoxes2DLen++;
      }
      this.physicsBoxes2D[entity.uuid.uuid].push(body);
      
      this.conditionallySetDirty(ent);
    });

    
  }

  ent.physicsbody.componentId = physicsBodyComponent.componentId;
  ent.physicsbody.tags = physicsBodyComponent.tags;
  if (ent.physicsbody.tags.length) {
    ent.physicsbody.tags.split(",").forEach( (tag) => {
      ent.addTag(tag);
    });
  }


  this.addComponent(ent, this.findSlots(ent, physicsBodyComponent, 'link'));

  //this.removeComponent(ent, this.Components.PhysicsBody2D);
  if (this.addCollisionBoxesToPhysicsBodies) {
    this.forceSetDirty(ent);
  }
}

CreateSystems.prototype.beforeUpdatePhysicsBody = function (dt) {
  //console.log('before update physics body');
  this.gameobjects.b2d_collisionsBegin = [];
  this.gameobjects.b2d_collisionsEnd = [];

  this.hasPhysicsBodies = false;
  this.ranBox2D = false;
  if (!this.gameobjects.Box2D) {
    return;
  }
  
  const physicsEnts = this.gameobjects.entities.querySystem(this.Components.PhysicsBody2D);
  this.physicsHitKeys = [];

  //while (this.physicsAccumulator >= this.physicsIdealFps) {
  //while (this.physicsAccumulator > 0) {
  while (!this.ranBox2D) {

    this.ranBox2D = true;

    for (let i = 0; i < physicsEnts.length; i++) {
      const ent = physicsEnts[i];
      this.updatePhysicsBody(dt, ent);
    }

    this.gameobjects.box2d_world.Step(dt/1000, 6, 2);

  }

}

CreateSystems.prototype.afterUpdatePhysicsBody = function (dt) {

  if (this.hasPhysicsBodies && this.gameobjects.DEBUG_DRAW) {
    //this.debug.startSystem('updatePhysics', 1, 'debugdraw');
    this.debug.box2dDebug(this.gameobjects,dt);
    //this.debug.stopSystem('updatePhysics', 'debugdraw');
  }

  if (!this.ranBox2D) {
    return;
  }
  const physicsEnts = this.gameobjects.entities.querySystem(this.Components.PhysicsBody2D);
  for (let i = 0; i < physicsEnts.length; i++) {
    const ent = physicsEnts[i];

    const uuid = ent.uuid.uuid;
    const physicsBoxes = this.physicsBoxes2D[uuid] || [];
    for (let j = 0; j < physicsBoxes.length; j++) {

      ent.transform.__positionUpdated = false;
      ent.transform.__positionUpdated2 = false;
      //if (!ent.transform.__positionUpdated2 && (!physicsBoxes[0].IsAwake() || ent.transform.__positionUpdated)) {
        //ent.transform.__positionUpdated = false;
        //continue;
      //}

      const physicsBox = physicsBoxes[j];
      let bpos = physicsBox.GetPosition();
      const inPos = {
        x:bpos.get_x(),
        y:bpos.get_y()
      }

      const localPos = this.getLocalPosition(ent, inPos);
      ent.transform.x = localPos.x;
      ent.transform.y = localPos.y;
      this.conditionallySetDirty(ent);

      if (!ent.physicsbody.ignoreRotation) {
        ent.transform.rotation = physicsBox.GetAngle();
      }
      ent.transform.__positionUpdated = false;
      ent.transform.__positionUpdated2 = false;

    }

  }


  /*
  let b2Body = this.gameobjects.box2d_world.GetBodyList();
  let items = 0;
  while(this.gameobjects.Box2D.getPointer(b2Body)){
    b2Body = b2Body.GetNext();
    items++;
  }
  */

  const hitKeys = this.physicsHitKeys;
  if (this.__physicBoxes2DLen !== hitKeys.length) {
    const toRemove = difference(keys(this.physicsBoxes2D), hitKeys);
    //const toRemove = hitKeys;
    const toRemoveLength = toRemove.length;
    for (let i = 0; i < toRemoveLength; i++) {
      const uuid = toRemove[i];
      const physicsBoxes = this.physicsBoxes2D[uuid];
      for (let j = 0; j < physicsBoxes.length; j++) {
        const physicsBox = physicsBoxes[j];
        this.gameobjects.box2d_world.DestroyBody(physicsBox);
        if (this.__bodyDef) {
          this.gameobjects.Box2D.destroy(this.__bodyDef);
        }
        this.__bodyDef = null;
      }
      delete this.physicsBoxes2D[uuid];
      this.__physicBoxes2DLen--;
      //const text = this.textCache[uuid].text;
      //this.gameobjects.app.stage.removeChild(text);
      //delete this.textCache[uuid];

    }
  }
  if (!this.gameobjects.Box2D) {
    return;
  }
  //this.gameobjects.box2d_world.Step(dt/1000, 6, 2);

}

CreateSystems.prototype.updatePhysicsBody = function (dt, ent) {
  this.hasPhysicsBodies = true;
  const uuid = ent.uuid.uuid;
  this.physicsHitKeys.push(uuid);
  if (!ent.physicsbody) {
    this.updatePhysicsBody2D(dt, ent);
  } else {
    if (!this.ranBox2D) {
      return;
    }
  }

  const physicsBoxes = this.physicsBoxes2D[uuid] || [];
  if (!this.isDirty(ent) && !physicsBoxes[0].IsAwake()) {
    return;
  }
  for (let j = 0; j < physicsBoxes.length; j++) {

    const physicsBox = physicsBoxes[j];
    let bpos = physicsBox.GetPosition();
    const inPos = {
      x:bpos.get_x(),
      y:bpos.get_y()
    }

    if (this.addCollisionBoxesToPhysicsBodies && !ent.collisionBox) {
      const id = ent.physicsbody.componentId;
      const scalex = 1;
      const scaley = 1;
      const tag = ent.physicsbody.tag;
      const component = {
        id,
        type:'collisionBox',
        scalex,
        scaley,
        tag
      }

      this.addComponent(ent, [component], true);

    }


    const bodyType = physicsBox.GetType();
    if (bodyType === this.gameobjects.Box2D.b2_staticBody) {
      let isCurrentColliding = false;
      const currentCollisions = this.gameobjects.b2d_collisionsCurrent[ent.uuid.uuid];
      //console.log('check static body for collisions');
      if (currentCollisions && currentCollisions.size) {
        //console.log('static body has active collisions', currentCollisions.size);
        for (let otherEntUuid of currentCollisions) {
          const otherEnt = this.getEntityById(otherEntUuid);
          if (otherEnt && otherEnt.physicsbody) {
            //console.log('other body is a physics body');
            let bodies = (this.physicsBoxes2D[otherEnt.uuid.uuid]||[])
            for (let i = 0; i < bodies.length; i++) {
              //console.log('mark', otherEnt.uuid.uuid, 'as awake');
              bodies[i].SetAwake(1);
            }
            isCurrentColliding = true;
          }
        };

        if (isCurrentColliding) {
          physicsBox.SetAwake(1);
        }
      }
      if (this.hasParent(ent)) {
        const worldPos = this.getWorldPosition(ent);
        const localPos = this.getLocalPosition(ent, {x:0,y:0});
        const parentEnt = this.getEntityById(ent.uuid.parentTransform);
        const parentWorldPos = this.getWorldPosition(parentEnt)
        physicsBox.SetTransform( this.createBox2d_b2Vec2(worldPos.x, worldPos.y), physicsBox.GetAngle());
      } else {
        const worldPos = this.getWorldPosition(ent);
        if (Math.abs(worldPos.x - inPos.x) > deltaDifference || Math.abs(worldPos.y - inPos.y) > deltaDifference) {
          physicsBox.SetTransform( this.createBox2d_b2Vec2(ent.transform.x, ent.transform.y), ent.transform.rotation);
        }
      }

    } else if (bodyType === this.gameobjects.Box2D.b2_kinematicBody) {
      if (ent.transform.__positionUpdated) {
        this.movePhysicsBody(dt, ent, physicsBox);
      }
    } else {
      if (ent.transform.__positionUpdated) {
        this.movePhysicsBody(dt, ent, physicsBox);
      } 
    }
  }

}

CreateSystems.prototype.updatePhysicsBodyType = function (dt, ent) {
  const changeBodyType = ent.changebodytype;
  let bodies = (this.physicsBoxes2D[ent.uuid.uuid]||[])
  for (let i = 0; i < (bodies||[]).length; i++) {
    let body = bodies[i];
    if (changeBodyType.bodyType === 'kinematic') {
      this.conditionallySetDirty(ent);
      body.SetType(this.gameobjects.Box2D.b2_kinematicBody);
      body.SetAwake(1)
    } else if (changeBodyType.bodyType === 'static') {
      this.conditionallySetDirty(ent);
      body.SetType(this.gameobjects.Box2D.b2_staticBody);
    } else if (changeBodyType.bodyType === 'dynamic') {
      this.conditionallySetDirty(ent);
      body.SetAwake(1)
      body.SetType(this.gameobjects.Box2D.b2_dynamicBody);
      let bpos = body.GetPosition();
      const inPos = {
        x:bpos.get_x(),
        y:bpos.get_y()
      }
      const localPos = this.getLocalPosition(ent, inPos);
      //ent.transform.x = inPos.x
      //ent.transform.y = inPos.y

      /*
      let bpos = body.GetPosition();
      const inPos = {
        x:bpos.get_x(),
        y:bpos.get_y()
      }
      const localPos = this.getLocalPosition(ent, inPos);
      const worldPos = this.getWorldPosition(ent);
      ent.transform.x = inPos.x
      ent.transform.y = inPos.y
        //ent.transform.__positionUpdated = true;
      this.cheese = true;
      */
    }
    this.gameobjects.debugLog({
      ent,
      component:{},
      type:'debug',
      line:`Change body type to ${changeBodyType.bodyType}`
    })

    //body.SetAwake(0)
/*
    if (changeBodyType.bodyType === 'kinematic') {
      //body.SetGravityScale(0);
      //body.SetType(this.gameobjects.Box2D.b2_kinematicBody);
      body.SetType(this.gameobjects.Box2D.b2_staticBody);
    } else if (changeBodyType.bodyType === 'static') {
      //body.SetGravityScale(0);
      //body.SetType(this.gameobjects.Box2D.b2_kinematicBody);
      body.SetType(this.gameobjects.Box2D.b2_staticBody);
    } else if (changeBodyType.bodyType === 'dynamic') {
      body.SetGravityScale(1);
      //body.SetType(this.gameobjects.Box2D.b2_dynamicBody);
    }
    body.SetAwake(1)
    */
  }

  this.addComponent(ent, this.findSlots(ent, changeBodyType, 'link'));
  this.removeComponent(ent, this.Components.ChangeBodyType);
}
CreateSystems.prototype.updatePhysicsMisc = function (dt, ent) {
  if (!this.gameobjects.Box2D) {
    return;
  }

  if (ent.physicsfixture) {
    const ent = ents[i];
    const physicsfixture = ent.physicsfixture;
    const uuid = ent.uuid.uuid;
    const physicsBox = this.physicsBoxes2D[physicsfixture.parent.uuid.uuid];
    let bpos = physicsBox.GetPosition();
    const localPos = physicsfixture.shape.get_m_p();
    ent.transform.x = bpos.get_x() + localPos.get_x();
    ent.transform.y = bpos.get_y() + localPos.get_y();
    this.conditionallySetDirty(ent);
  }

  //this.debug.stopSystem('updatePhysics', 'iterate');

  //this.debug.startSystem('addFixture', ents.length, 'changebodytype');
  if (ent.addfixture) {
    const uuid = ent.uuid.uuid;
    const body = this.physicsBoxes2D[uuid];

    let fixture = new this.gameobjects.Box2D.b2FixtureDef;
    fixture.set_isSensor(true);
    let shape = new this.gameobjects.Box2D.b2CircleShape();
    shape.set_m_radius(0.3);
    shape.set_m_p(this.createBox2d_b2Vec2(0, 0));
    fixture.set_shape(shape);
    body.CreateFixture(fixture);

    const entity = this.gameobjects.entities.createEntity();
    this.createUuid(entity);
    entity.addComponent(this.Components.PhysicsFixture);
    entity.physicsfixture.parent = ent;
    entity.physicsfixture.fixture = fixture;
    entity.physicsfixture.shape = shape;

    //const localPos = fixture.GetPosition();
    const localPos = shape.get_m_p();
    const TransformComponent = {
      type:"transform",
      data:{
        pos:{
          x:0,
          y:0,
        },
        dx:0, dy:0,
        scale:{
          x:1,
          y:1,
        }
      },
    }
    this.addComponent(entity, [TransformComponent]);
    this.addComponent(entity, this.findSlots(ent, ent.addfixture));

    this.removeComponent(ent, this.Components.PhysicsAddFixture);


  }
  //this.debug.stopSystem('updatePhysics', ents.length, 'changebodytype');

  if (ent.changebodytype) {
  }
  //this.debug.stopSystem('updatePhysics', 'changebodytype');

  //this.gameobjects.b2d_collisionsBegin = [];
  //this.gameobjects.b2d_collisionsEnd = [];


  //this.gameobjects.box2d_world.Step(dt/1000, 6, 2);
  /*
let fulldt = dt/1000;
let cap = 30/1000;
while (fulldt > cap) {
  this.gameobjects.box2d_world.Step(Math.min(fulldt,cap), 3, 3);
  fulldt -= cap;
}
*/

}

CreateSystems.prototype.findComponentInTree = function (ent, name) {
  if (!ent) {
    return null;
  }
  if (!ent.uuid) {
    return null;
  }
  const key = `${ent.uuid.uuid}-${name}`
  if (this.componentsInTreeCache[key]) {
    return this.componentsInTreeCache[key]
  }
  if (ent[name]) {
    return ent[name];
  }
  if (this.hasParent(ent)) {
    const parentEnt = this.getParent(ent);
    this.componentsInTreeCache[key] = this.findComponentInTree(parentEnt, name);
    return this.componentsInTreeCache[key];
  }
  return null;
}
CreateSystems.prototype.updateSetCollisionFilters = function (dt, ent) {
  const setcollisionfilter = ent.setcollisionfilter;
  let physicsBoxes = clone(this.physicsBoxes2D[ent.uuid.uuid]);
  this.gameobjects.debugLog({
    ent,
    component:{},
    type:'debug',
    line:`Set CollisionFilters ${setcollisionfilter.maskBits} / ${setcollisionfilter.categoryBits} / ${setcollisionfilter.groupIndex}`
  })
  for (let i = 0; i < physicsBoxes.length; i++) {
    const body = physicsBoxes[i];
    let fixture = body.GetFixtureList();
    let fixturePointer = this.gameobjects.Box2D.getPointer(fixture);
    //this.debug.addDebugLine(ent, 'activate setcollisionfilter');
    while (fixturePointer) {
      const filterdata = fixture.GetFilterData();
      if (typeof(setcollisionfilter.maskBits) !== 'undefined') {
        //this.debug.addDebugLine(ent, `set maskbits filter to ${setcollisionfilter.maskBits}`);
        filterdata.set_maskBits(parseInt(setcollisionfilter.maskBits));
      }
      if (typeof(setcollisionfilter.categoryBits) !== 'undefined') {
        //this.debug.addDebugLine(ent, `set category bits to ${setcollisionfilter.categoryBits}`);
        filterdata.set_categoryBits(parseInt(setcollisionfilter.categoryBits));
      }
      if (typeof(setcollisionfilter.groupIndex) !== 'undefined') {
        //this.debug.addDebugLine(ent, `set group index to ${setcollisionfilter.groupIndex}`);
        filterdata.set_groupIndex(parseInt(setcollisionfilter.groupIndex));
      }
      fixture.SetFilterData(filterdata);

      fixture = fixture.GetNext();
      fixturePointer = this.gameobjects.Box2D.getPointer(fixture);
    }
  }
  this.addComponent(ent, this.findSlots(ent, setcollisionfilter, 'link'))
  this.removeComponent(ent, this.Components.SetCollisionFilter);
}

CreateSystems.prototype.updateRemoveJoints = function (dt) {
  let ents = this.gameobjects.entities.queryComponents([this.Components.RemoveJoints, this.Components.PhysicsBody, this.Components.Uuid]);
  let length = ents.length;
//  this.debug.startSystem('updateRemoveJoints', length);
  for (let i = 0; i < length; i++) {
    const ent = ents[i];
    this.removeComponent(ent, this.Components.RemoveJoints);

    for (let k = 0; k < this.bla_joint.length; k++) {
      this.gameobjects.box2d_world.DestroyJoint(this.bla_joint[k]);
    }
    this.bla_joint = [];
    /*
    const ent = ents[i];
    const myBody = this.physicsBoxes2D[ent.uuid.uuid];

    const jointsToRemove = [];
    this.removeComponent(ent, this.Components.RemoveJoints);
    let jointPtr = myBody.GetJointList();
    let joint;
    while(joint = jointPtr ? this.gameobjects.Box2D.getPointer(jointPtr) : undefined){
      //this.gameobjects.box2d_world.DestroyJoint(joint);
      jointsToRemove.push(jointPtr);
      jointPtr = jointPtr.next;
    }
    for (let i = 0; i < jointsToRemove.length; i++) {
      const joint = jointsToRemove[i];
      this.gameobjects.box2d_world.DestroyJoint(joint);
    }
    */

  }
//  this.debug.stopSystem('updateRemoveJoints');
}
CreateSystems.prototype.updateApplyJoints = function (dt, ent) {
  if (!this.gameobjects.Box2D) {
    return;
  }

  //  this.debug.startSystem('updateApplyJoints', length);
  let data = ent.applyjoint.data;
  let jointDef = new this.gameobjects.Box2D.b2WeldJointDef;
  const myBody = this.physicsBoxes2D[ent.uuid.uuid];

  jointDef.set_bodyA(data.bodyA);
  jointDef.set_bodyB(data.bodyB);
  //jointDef.set_localAnchorA(new gameobjects.Box2D.b2Vec2(0, 0) );
  //jointDef.set_localAnchorB(new gameobjects.Box2D.b2Vec2(0, 0) );
  jointDef.set_collideConnected(false);
  //jointDef.set_length(0.2);
  //jointDef.set_dampingRatio(j.dampingRatio);
  //jointDef.set_frequencyHz(j.frequencyHZ);
  this.bla_joint.push(this.gameobjects.box2d_world.CreateJoint(jointDef));

  this.removeComponent(ent, this.Components.ApplyJoint);
  //  this.debug.stopSystem('updateApplyJoints');
}

CreateSystems.prototype.updateApplyImpulse2D = function (dt, ent) {
  let physicsBoxes = this.physicsBoxes2D[ent.uuid.uuid];
  if (!physicsBoxes) {
    //console.warn('waiting for physicsbox');
    if (ent.transform.__children.length) {
      const childEnt = this.getEntityById(ent.transform.__children[0])
      physicsBoxes = this.physicsBoxes2D[childEnt.uuid.uuid]
      if (!physicsBoxes) {
        //console.warn('double lol');
        return;
      }
    } else {
      return;
    }
  }

  if (!ent.applyimpulse2d.__addComponents) {
    this.addComponent(ent, this.findSlots(ent, ent.applyimpulse2d, 'link'))
    ent.applyimpulse2d.__addComponents = true;
  }
  for (let j = 0; j < physicsBoxes.length; j++) {
    const physicsBox = physicsBoxes[j];
    const worldCenter = physicsBox.GetWorldCenter();
    let x = worldCenter.get_x();
    let y = worldCenter.get_y();
    x = x + (ent.applyimpulse2d.offsetx || 0);
    y = y + (ent.applyimpulse2d.offsety || 0);

    let impulsex = parseFloat(ent.applyimpulse2d.impulsex);
    let impulsey = parseFloat(ent.applyimpulse2d.impulsey);
    if (false && this.gameobjects.interaction.pan) {
      //impulsex = this.gameobjects.interaction.pan.velocity.x;
      //impulsey = this.gameobjects.interaction.pan.velocity.y;
      //impulsex *= ent.applyimpulse2d.impulsex;
      //impulsey *= ent.applyimpulse2d.impulsey;
      const worldPos = this.cameraContainer.toLocal(this.gameobjects.interaction.pan.pos);
      let diffx = worldPos.x - ent.transform.x;
      let diffy = worldPos.x - ent.transform.y;
      diffx *= ent.applyimpulse2d.impulsex
      diffy *= ent.applyimpulse2d.impulsey

      impulsex = diffx;
      impulsey = diffy;

    }
    physicsBox.ApplyLinearImpulse(
      this.createBox2d_b2Vec2(impulsex, impulsey),
      this.createBox2d_b2Vec2_b(x, y)
    );
    physicsBox.SetAwake(1);
    if (!ent.applyimpulse2d.keep) {
      this.removeComponent(ent, this.Components.ApplyImpulse2D);
    }
  }
}

CreateSystems.prototype.updateApplyForce2D = function (dt, ent) {
  if (!ent.applyforce2d.multi) {
    return;
  }
  if (!ent.physicsbody) {
    // not yet created, next frame
    return;
  }
  const totalLength = ent.applyforce2d.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.applyforce2d.multi[j];
    const applyforce2d = o.c;
    const component = o.component;
    const physicsBoxes = this.physicsBoxes2D[ent.uuid.uuid];
    for (let k = 0; k < physicsBoxes.length; k++) {
      const physicsBox = physicsBoxes[k];
      const worldCenter = physicsBox.GetWorldCenter();
      let x = worldCenter.get_x();
      let y = worldCenter.get_y();
      x = x + (applyforce2d.offsetx || 0);
      y = y + (applyforce2d.offsety || 0);

      const force = {
        x:applyforce2d.forcex,
        y:applyforce2d.forcey
      }
      if (false && this.gameobjects.interaction.pan) {
        //impulsex = this.gameobjects.interaction.pan.velocity.x;
        //impulsey = this.gameobjects.interaction.pan.velocity.y;
        //impulsex *= ent.applyimpulse2d.impulsex;
        //impulsey *= ent.applyimpulse2d.impulsey;
        const worldPos = this.cameraContainer.toLocal(this.gameobjects.interaction.pan.pos);

        const timeClamp = (1000 / 60) / dt;
        let diffx = worldPos.x - ent.transform.x;
        let diffy = worldPos.x - ent.transform.y;
        diffx *= applyforce2d.forcex * timeClamp
        diffy *= applyforce2d.forcey * timeClamp

        force.x = diffx;
        force.y = diffy;

      }
      physicsBox.ApplyForce(
        this.createBox2d_b2Vec2(force.x, force.y),
        this.createBox2d_b2Vec2_b(x, y)
      );
      this.gameobjects.debugLog({
        ent,
        component:applyforce2d,
        type:'debug',
        line:`Apply Force ${force.x}/${force.y} ++ ${x}/${y}`
      })



      if (applyforce2d.maxVelocity) {
        const velocity = physicsBox.GetLinearVelocity();
        const speed = velocity.Length();
        if (speed > applyforce2d.maxVelocity) {
          const scaleFactor = applyforce2d.maxVelocity / speed;
          const newX = velocity.get_x() * scaleFactor;
          const newY = velocity.get_y() * scaleFactor;
          const scaled = this.createBox2d_b2Vec2(
            newX,
            newY
          )
          physicsBox.SetLinearVelocity(scaled)
          this.addComponent(ent, this.findSlots(ent, component, 'maxed'))
        }
      }
      physicsBox.SetAwake(1);
    }

    applyforce2d.t += dt / 1000;
    if (!applyforce2d.keep) {
      if (applyforce2d.t >= applyforce2d.time) {
        this.multiRemoveComponent(ent, this.Components.ApplyForce2D, applyforce2d);
        this.addComponent(ent, this.findSlots(ent, component, 'end'))
      } else {
        this.addComponent(ent, this.findSlots(ent, component, 'busy'))
      }
    } else {
      this.addComponent(ent, this.findSlots(ent, component, 'busy'))
    }
    if (!applyforce2d.__addComponents) {
      this.addComponent(ent, this.findSlots(ent, component, 'link'))
      applyforce2d.__addComponents = true;
    }
    //this.multiRemoveComponent(ent, this.Components.ApplyForce2D, applyforce2d);
  }
}

CreateSystems.prototype.updateSetLinearVelocity = function (dt, ent) {
  if (!ent.physicsbody) {
    // not yet created, next frame
    return;
  }
  const physicsBoxes = this.physicsBoxes2D[ent.uuid.uuid] || [];
  for (let j = 0; j < physicsBoxes.length; j++) {
    const physicsBox = physicsBoxes[j];
    const currentVector = physicsBox.GetLinearVelocity();
    const x = currentVector.get_x();
    const y = currentVector.get_y();
    const sv = ent.setlinearvelocity2d;

    if (!sv.__addComponents) {
      this.addComponent(ent, this.findSlots(ent, sv, 'link'))
      sv.__addComponents = true;
    }

    let worldVector = this.getWorldVector(ent, sv);

    const newVel = {
      x:sv.setx ? worldVector.x : x,
      y:sv.sety ? worldVector.y : y
    }
    this.gameobjects.debugLog({
      ent,
      component:sv,
      type:'debug',
      line:`Set LV ${newVel.x} / ${newVel.y}`
    })
    physicsBox.SetLinearVelocity(
      this.createBox2d_b2Vec2(
          newVel.x,
          newVel.y
      ),
      physicsBox.GetWorldCenter()
    );
    if (ent.setlinearvelocity2d.setangle) {
      physicsBox.SetAngularVelocity(ent.setlinearvelocity2d.angle);
    }
    if (!ent.setlinearvelocity2d.continous) {
      this.removeComponent(ent, this.Components.SetLinearVelocity2d);
    }
  }
}

CreateSystems.prototype.updateSetBodyProperties = function (dt, ent) {
  const bodies = this.physicsBoxes2D[ent.uuid.uuid] || [];

  for (let j = 0; j < bodies.length; j++) {
    const body = bodies[j];
    this.removeComponent(ent, this.Components.SetBodyProperties);
    //if (ent.setbodyproperties.setangle) {
      //body.SetTransform( body.GetPosition(), ent.setbodyproperties.angle)
    //}
    let fixture = body.GetFixtureList();
    let fixturePointer = this.gameobjects.Box2D.getPointer(fixture);
    while (fixturePointer) {
      if (!isNaN(ent.setbodyproperties.density)) {
        this.gameobjects.debugLog({
          ent, component:{}, type:'debug', line:`Set density ${ent.setbodyproperties.density}`
        })
        fixture.SetDensity(ent.setbodyproperties.density);
      }
      if (!isNaN(ent.setbodyproperties.restitution)) {
        this.gameobjects.debugLog({
          ent, component:{}, type:'debug', line:`Set restiution ${ent.setbodyproperties.restiution}`
        })
        fixture.SetRestitution(ent.setbodyproperties.restitution);
      }
      if (!isNaN(ent.setbodyproperties.friction)) {
        this.gameobjects.debugLog({
          ent, component:{}, type:'debug', line:`Set friction ${ent.setbodyproperties.friction}`
        })
        fixture.SetFriction(ent.setbodyproperties.friction);
      }
      //fixture.SetSensor(physicsBodyComponent.isSensor);
      fixture = fixture.GetNext();
      fixturePointer = this.gameobjects.Box2D.getPointer(fixture);
    }
    body.ResetMassData()
  }
}

CreateSystems.prototype.updateApplyForces2D = function (dt) {
  if (!this.gameobjects.Box2D) {
    return;
  }

  //return;
  let ents = this.gameobjects.entities.queryComponents([this.Components.ApplyImpulse2D, this.Components.PhysicsBody, this.Components.Uuid]);
  let length = ents.length;
//  this.debug.startSystem('updateApplyForces2D', length);

  for (let i = 0; i < length; i++) {
  }

  ents = this.gameobjects.entities.queryComponents([this.Components.ApplyForce2D, this.Components.PhysicsBody, this.Components.Uuid]);
  length = ents.length;

  for (let i = 0; i < length; i++) {
    const ent = ents[i];


    //this.removeComponent(ent, this.Components.ApplyForce2D);
  }

  ents = this.gameobjects.entities.queryComponents([this.Components.SetLinearVelocity2d, this.Components.PhysicsBody, this.Components.Uuid]);
  length = ents.length;

  for (let i = 0; i < length; i++) {
    const ent = ents[i];

  }


  ents = this.gameobjects.entities.queryComponents([this.Components.SetBodyProperties, this.Components.PhysicsBody, this.Components.Uuid]);
  length = ents.length;

  for (let i = 0; i < length; i++) {
    const ent = ents[i];

  }

//  this.debug.stopSystem('updateApplyForces2D');
}



CreateSystems.prototype.initUserSystems = function (dt) {
  this.gameobjects.systems.forEach( (system) => {
    if ((system.code||[]).length === 0) {
      return;
    }
    let s = new UserSystems.System(system.code);
    this.userSystems.push(s);
  });
}
CreateSystems.prototype.beforeUpdateUserSystems = function (dt) {
  this.ranScript = false;
}
CreateSystems.prototype.afterUpdateUserSystems = function (dt) {
}
CreateSystems.prototype.updateUserSystems = function (dt, ent) {
  const uuid = ent.uuid.uuid;
  const totalLength = ent.luaScript.multi.length;
  if (!ent.uuid || !ent.uuid.uuid) {
    return;
  }
  let didRun = false;
  for (let z = 0; z < totalLength; z++) {
    const o = ent.luaScript.multi[z];
    const luaScript = o.c;
    const component = o.component;

    const script = luaScript.script;
    const key = `${script.id}`;
    if (!luaScript.started) {
      const thisKey = `${uuid}-${key}`;
      if (luaScript.keep && this.luaVm.scriptsRunning[thisKey]) {
        this.luaVm.cleanupScript(ent, luaScript);
        //this.multiRemoveComponent(ent, this.Components.LuaScript, luaScript);
        //continue;
      }
      luaScript.started = true;
      const entProps = keys(this.getProperties(ent));
      luaScript.internalVariables = (luaScript.script.usedVariables||[]).filter( (v) => {
        return !includes(entProps, v);
      });
      this.addComponent(ent, this.findSlots(ent, component, 'link'))
      if (luaScript.timer) {
        luaScript.currentTime = luaScript.timer + 10;
      }
    }


    luaScript.currentTime += dt;
    if (!luaScript.timer || luaScript.currentTime > luaScript.timer) {
      didRun = true;
      if (!this.userScripts[key]) {
        this.userScripts[key] = this.luaVm.load(script);
      }
      this.prepareGlobalAndLocalVariables(ent);
      this.userScripts[key].run(luaScript.timer ? luaScript.currentTime : dt, ent, luaScript);
      this.ranScript = true;

      if ((luaScript.slotActivated||[]).length) {
        for (let p = 0; p < luaScript.slotActivated.length; p++) {
          const slotName = luaScript.slotActivated[p];
          const slotties = this.findSlots(ent, component, slotName);
          this.addComponent(ent, slotties);
        }
        luaScript.slotActivated = [];
      }

      if (!luaScript.keep || luaScript.__toDestroy) {
        this.luaVm.cleanupScript(ent, luaScript);
        this.multiRemoveComponent(ent, this.Components.LuaScript, luaScript);
      } else {
      }

      luaScript.currentTime = 0;

    }

  }

  if (didRun) {
  }
}

CreateSystems.prototype.setRootProps = function (variables) {
  const rootEnt = this.findRoot();
  if (!rootEnt) {
    console.warn('root lost');
    return;
  }
  this.setTransformProps(rootEnt, variables);
}
CreateSystems.prototype.initVariables = function (tiledata) {
  const rootEnt = this.gameobjects.entities.createEntity();
  this.createUuid(rootEnt);
  rootEnt.addTag('root');
  rootEnt.childrenTransforms = [];
  rootEnt.__name = 'Root';
  //this.Components.SetProperties.create(rootEnt, props);
  const variables = {};
  (tiledata.variables||[]).forEach( (variable) => {
    variables[variable.name] = variable;
  });
  this.gameobjects.variables = variables;

  this.setTransformProps(rootEnt, cloneDeep(values(this.gameobjects.variables)));

  this.luaVm = new LuaVm(this.luaStack, this);



  this.themes = tiledata.themes||[];
}

CreateSystems.prototype.reset = function () {
  this.cooldownLast = {};
  this.lastTaps = {}
  this.componentsInTreeCache = {};
  this.events.removeAllListeners();
  this.gameobjects.addDebug('clear 1');
  this.currentPressing = {};
  this.lastRemoveOutsideEntitiesRun = 0;
  this.gameobjects.interaction = {};
  this.gameobjects.events = [];
  this.gameobjects.localEvents = [];
  this.gameobjects.b2d_collisionsBegin = [];
  this.gameobjects.b2d_collisionsBusy = [];
  this.gameobjects.b2d_collisionsCurrent = {};
  this.gameobjects.b2d_collisionsEnd = [];
  this.toySlotsData = {};
  this.featureSlotData = {};
  this.timelineSystem.reset();


  values(this.gameobjects.sounds).forEach( (sound) => {
    sound.stop();
  });

  //this.cameraContainer.pivot.x = 0;
  //this.cameraContainer.pivot.y = 0;


  //this.cameraContainer.pivot.x = 0;
  //this.cameraContainer.pivot.y = 0;
  //this.cameraContainer.scale.x = 33;
  //this.cameraContainer.scale.y = 33;
  //this.cameraContainer.alpha = 1;

  //this.gameobjects.Box2D.destroy(this.gameobjects.box2d_world);
  //let box2d_gravity = this.createBox2d_b2Vec2(0.0, 10.0);
  //this.gameobjects.box2d_world = new this.gameobjects.Box2D.b2World(box2d_gravity);
}
CreateSystems.prototype.unsetCamera = function () {
  if (this.gameobjects.foundCamera) {
    //this.gameobjects.foundCamera.remove();
    this.gameobjects.foundCamera = false;
  }
}
CreateSystems.prototype.startScene = function (scene, gotoScene) {

  //const camera = this.gameobjects.entities.queryTag('camera');
  //if (camera.length) {
    //camera[0].remove();
  //}
  this.gameobjects.startScene(scene);

  const root = this.findRoot();
  const properties = cloneDeep(this.luaVm.props);

  //extend(this.gameobjects.variables, properties);

  //this.clearPool();
  //this.clearLayers();

  this.reset();

  //this.addComponentList = [];
  //this.multiRemoveComponentList = [];
  //this.componentRemoveList = [];

  //this.gameobjects.interaction = {};


  //this.gameobjects.app.stage.removeChild(this.cameraContainer);
  //this.cameraContainer = new PIXI.Container();
  //this.gameobjects.app.stage.addChild(this.cameraContainer);
  //this.gameobjects.cameraContainer = this.cameraContainer;

  //this.gameobjects.app.stage.removeChild(this.overlay);
  //this.overlay.removeChild(this.letterBox);
  //this.overlay = new PIXI.Container();
  //this.gameobjects.app.stage.addChild(this.overlay);

  //this.initVariables();

  /*
  const dt = 1000 / 20;
  this.updateGotoScene(dt);
  for (var i = 0; i < 2; i++) {
    this.addthis.Components(dt);
    this.updateSceneGraph(dt);
    this.updateCamera(dt);
    this.updateSprites(dt);
    //this.updateText(dt);
    this.updateCreateToys(dt);
    //this.updateCreateFeatures(dt);
    //this.updateTween(1);
    this.removethis.Components();
  }
  */

  this.endOfFrame.push( () => {
    const ent = this.gameobjects.entities.createEntity();
    //const ent = this.findRoot();
    this.createUuid(ent);
    this.Components.StartScene.create(ent, scene)
    this.unsetCamera();

  });


}
CreateSystems.prototype.removeAllEntities = function () {
  const ents = this.gameobjects.entities._entities;
  const oldEnts = [];
  const flength = ents.length;
  for (var i = flength-1; i >= 0; i--) {
    const ent = ents[i];
    oldEnts.push(ent);
  }

  const length = oldEnts.length;
  for (var j = length-1; j >= 0; j--) {
    const ent = oldEnts[j];
    ent.addComponent(this.Components.Destroy);
  }
  //this.__root = null;
}

CreateSystems.prototype.setupLayerComponents = function (layers) {
  Object.values(layers).forEach( (layer) => {

    if ((layer.components||[]).length) {
      this.layerAutoComponents[layer.id] = [layer.components[0]];
    }

    (layer.components||[]).forEach( (component) => {
      this.gameobjects.components.push(component);
    });
    (layer.links||[]).forEach( (link) => {
      this.gameobjects.links.push(link);
    });
  });

  const toCache = {
    components:this.gameobjects.components,
    links:this.gameobjects.links
  }

  const newCache = util.prePopulateCache(toCache);
  Object.assign(this.gameobjects.componentLinkCache, newCache);
  Object.assign(this.gameobjects.componentIdCache, util.prePopulateIdCache(toCache));
  /*
  this.gameobjects.components = util.prePopulateCache(toCache);
  this.gameobjects.links = util.prePopulateIdCache(toCache);
  */
}
CreateSystems.prototype.updateStartScene = function (dt, ent) {
  const rootEnt = this.findRoot();
  if (!rootEnt) {
    console.warn('root lost');
    return;
  }
  const scene = ent.startScene.scene;
  this.layerDefinitions = scene.layers;

  this.setupLayerComponents(scene.layers);

  scene.transforms.forEach( (transform) => {
    const ent = this.gameobjects.entities.createEntity();
    this.createUuid(ent);
    this.Components.TransformGraphCreate.create(ent, transform);
    /*
    this.Components.Transform.create(
      ent,
      topLevelComponent);
    this.addTreeOfthis.Components(this.gameobjects, ent, topLevelComponent.cid);
    */
  });
  this.removeComponent(ent, this.Components.StartScene);
  if (ent !== rootEnt) {
    ent.addComponent(this.Components.Destroy);
  }
  this.setTransformProps(rootEnt, scene.variables || []);

  //this.Components.SetProperties.create(rootEnt, props);


  this.cameraDt = 0;
  //this.gameobjects.foundCamera = false;
  this.crappyCounter = 0;

  this.endOfFrame.push( () => {
    //this.cameraDt = 0;
    //this.gameobjects.foundCamera = false;
    //this.crappyCounter = 0;

  });


}

CreateSystems.prototype.updateGotoScene = function (dt, ent) {
  const gotoScene = ent.gotoScene;
  let scene;
  if (ent.gotoScene.mode === 'specific') {
    this.prevActiveSceneNum = this.activeSceneNum;
    scene = this.gameobjects.scenes.filter( (x,i) => {
      if (x.id === ent.gotoScene.scene) {
        this.activeSceneNum = i;
        return true;
      }
      return false;
    })[0];
  } else if (ent.gotoScene.mode === 'next') {
    this.prevActiveSceneNum = this.activeSceneNum;
    scene = this.gameobjects.scenes[this.activeSceneNum + 1];
    this.activeSceneNum++;
  } else if (ent.gotoScene.mode === 'previous') {
    this.prevActiveSceneNum = this.activeSceneNum;
    scene = this.gameobjects.scenes[this.activeSceneNum - 1];
    this.activeSceneNum--;
  } else if (ent.gotoScene.mode === 'back') {
    scene = this.gameobjects.scenes[this.prevActiveSceneNum];
    this.activeSceneNum = this.prevActiveSceneNum;
  } else if (ent.gotoScene.mode === 'same') {
    this.prevActiveSceneNum = this.activeSceneNum;
    scene = this.gameobjects.scenes[this.activeSceneNum];
  } else  {
    this.prevActiveSceneNum = this.activeSceneNum;
    scene = ent.gotoScene.scene;
    this.gameobjects.scenes.forEach( (x,i) => {
      if (x.id === ent.gotoScene.scene) {
        this.activeSceneNum = i;
      }
    })
  }
  this.removeComponent(ent, this.Components.GotoScene);

  this.endOfFrame.push( () => {
    let ents = this.gameobjects.entities._entities;
    let oldEnts = [];
    let flength = ents.length;
    for (var i = flength-1; i >= 0; i--) {
      const ent = ents[i];
      //ent.remove();
      if (ent.hasTag('root')) {
        continue;
      }
      if (!includes(gotoScene.ignore, ent.uuid.__transformId)) {
        oldEnts.push(ent);
        //ent.remove();
      }
        //oldEnts.push(ent);
      //}
    }
    let length = oldEnts.length;
    for (var j = length-1; j >= 0; j--) {
      const ent = oldEnts[j];
      //this.addComponent(ent, this.Components.Destroy);
      //ent.destroy();
      ent.addComponent(this.Components.Destroy);
      ////ent.addComponent(this.Components.Destroy);
    }
  })
  this.endOfFrame.push( () => {
    this.startScene(scene, ent.gotoScene);
  });

  this.delayFirstRenderCounter = this.delayCameraForFrames + parseInt((ent.gotoScene.skipFrames || 1));
  this.delayFirstRender = true;

  //this.gameobjects.app.stage.removeChild(this.overlay);
  //this.overlay = new PIXI.Container();
  //this.gameobjects.app.stage.addChild(this.overlay);

  this.gameobjects.startScene();


}


CreateSystems.prototype.resetRoot = function (gamedata) {
  const rootEnt = this.findRoot();
  const variables = {};
  (gamedata.variables||[]).forEach( (variable) => {
    variables[variable.name] = variable;
  });
  this.gameobjects.variables = variables;

  this.luaStack = {};
  this.luaHeap = {};
  this.luaVm = new LuaVm(this.luaStack, this);

  this.setTransformProps(rootEnt, cloneDeep(values(this.gameobjects.variables)));

  /*
  const root = this.findRoot();
  root.remove();
  delete this.__root;
  this.initVariables(gamedata);
  */
  //this.reset();
}

CreateSystems.prototype.updateGotoGame = function (dt, ent) {
  const gotoGame = ent.gotoGame;
  this.removeComponent(ent, this.Components.GotoGame);
  this.endOfFrame.push( () => {
    this.gameobjects.gotoGame(gotoGame.gameId);
  });

}


CreateSystems.prototype.setupSequenceEvents = function (ent, component, key) {
  if (component.resetEvent) {
    const resetSequence = () => {
      delete this.SEQUENCES[key];
    }

    // setup the global event
    this.events.once(component.resetEvent, resetSequence);

    // setup the local event
    const localKey = ent.uuid.uuid + '-' + component.resetEvent;
    this.events.once(localKey, resetSequence);
  }
  if (component.advanceEvent) {
    const advanceSequence = () => {
      const advanced = this.advanceSequence(ent, component, key);

      if (advanced) {
        setupEvents();
      }

    }

    const setupEvents = () => {

      if (component.blocked) {
        return;
      }

      if (!ent || !ent.uuid) {
        return;
      }

      // setup the global event
      this.events.once(component.advanceEvent, advanceSequence);

      // setup the local event
      const localKey = ent.uuid.uuid + '-' + component.advanceEvent;
      this.events.once(localKey, advanceSequence);
    }

    setupEvents();
  }
};

CreateSystems.prototype.advanceSequence = function (ent, component, key) {
  const seq = this.SEQUENCES[key];
  if (!seq || seq.blocked) {
    return false;
  }
  const sequenceSteps = seq.byStepNumber[seq.current];
  if (sequenceSteps && sequenceSteps.length) {
    this.addComponent(ent, seq.byStepNumber[seq.current]);
  }
  if (seq.current >= 0) {
    this.addComponent(ent, this.findSlots(ent, component, 'change'));
  }
  if (seq.increasing) {
    seq.current++;
  } else {
    seq.current--;
  }
  if (seq.current < 0) {
    if (seq.reverse) {
      seq.current = 1;
      seq.increasing = true;
      if (!seq.loop) {
        seq.blocked = true;
        return false;
      }
    } else {
      seq.current = seq.maxStep;
    }
  }
  if (seq.current >= seq.maxStep) {
    if (seq.reverse) {
      seq.current = seq.maxStep - 1;
      seq.increasing = false;
    } else {
      if (!seq.loop) {
        seq.blocked = true;
        return false;
      }
      seq.current = 0;
    }
  }

  return true;

}

CreateSystems.prototype.updateSequence = function (dt, ent) {
  const totalLength = ent.sequence.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.sequence.multi[j];
    const sequence = o.c;
    const component = o.component;

    const key = ent.uuid.uuid + '-' + component.id;
    if (!this.SEQUENCES[key]) {
      const slots = this.findSlots(ent, component, undefined, undefined, true).filter( ({link: {name}}) => {
        return name !== 'change';
      });
      const list = sortBy(slots, ({link: {name}}) => {
        return parseInt(name);
      }).map( ({link: {name}, component}) => {
        const number = parseInt(name);
        return {component,number}
      });

      if (list.length === 0) {
        // steps has no... steps
        this.multiRemoveComponent(ent, this.Components.Sequence, sequence);
        break;
      }
      const minStep = list[0].number;
      const maxStep = list[list.length - 1].number;

      const byStepNumber = {};
      for (let i = 0; i <= maxStep; i++) {
        byStepNumber[i] = [];
      }
      list.forEach( ({number, component}) => {
        byStepNumber[number-1].push(component);
      });

      this.SEQUENCES[key] = {
        current:component.firstStep ? 0 : -1,
        loop:component.loop,
        increasing:true,
        reverse:component.reverse,
        byStepNumber,
        minStep,
        maxStep
      }

      // setup events
      this.setupSequenceEvents(ent, component, key);
    }
    this.advanceSequence(ent, component, key);

    this.multiRemoveComponent(ent, this.Components.Sequence, sequence);

    //cb(o.c, o.component);
  }
}

CreateSystems.prototype.setProperties = function (ent, props) {

  const pairs = toPairs(props);
  for (let i = 0; i < pairs.length; i++) {
    const key = pairs[i][0];
    const value = pairs[i][1];
    const propKey = `${ent.uuid.uuid}-${key}`;
    this.luaHeap[propKey] = value;
  }

}

CreateSystems.prototype.getProperties = function (ent) {
  if (!ent.uuid || !ent.uuid.uuid) {
    return {}
  }
  const uuid = ent.uuid.uuid;
  if (this.__propertiesCache[uuid]) {
    if (!this.__propertiesCache[uuid].__cleared && this.__propertiesCache[uuid].__rootPropertiesRevision === this.__rootPropertiesRevision) {
      return this.__propertiesCache[uuid];
    }
  }
  const __variableView = ent.uuid.__variableView;
  const length = __variableView.length;
  const props = {};
  for (let i = 0; i < length; i++) {
    const vv = __variableView[i];
    const {key,name,ptr} = vv;
    if (ptr) {
      props[name] = this.luaHeap[ptr];
    } else {
      props[name] = this.luaHeap[key];
    }
  }
  this.__propertiesCache[ent.uuid.uuid] = props;
  this.__propertiesCache[ent.uuid.uuid].__cleared = false;
  this.__propertiesCache[ent.uuid.uuid].__rootPropertiesRevision = this.__rootPropertiesRevision;
  return props;
}
CreateSystems.prototype.clearPropertiesCache = function (ent, print=true) {
  //this.__propertiesCache = {};
  //return
  // TODO be more clever about it ?
  if (!ent || !ent.uuid || !ent.uuid.uuid) {
    return;
  }
  //console.trace('clear', ent.uuid.uuid);
  if (ent == this.findRoot()) {
    this.__rootPropertiesRevision++;
    return -10000;
  }
  const uuid = ent.uuid.uuid;
  if (this.__propertiesCache[uuid]) {
    this.__propertiesCache[uuid].__cleared = true;
  }
  if (!ent.transform) {
    return 0;
  }
  let cleared = 0;
  if (typeof(this.__propertiesCache[uuid]) === 'undefined' || !this.__propertiesCache[uuid].__cleared) {
    const childrenEnts = ent.transform.__children;
    for (let i = 0; i < childrenEnts.length; i++) {
      const id = childrenEnts[i];
      const childEnt = this.entitiesByUuid[id];
      cleared += this.clearPropertiesCache(childEnt, false);
    }
  }

  //if (print) {
  //}
  return 1 + cleared;
  // TODO: make this more clerver
  // by taking children and parents into consideration
  delete this.__propertiesCache[ent.uuid.uuid];
  this.getProperties(ent);
  return;
  if (!ent.uuid || !ent.uuid.uuid) {
    return;
  }
  const parent = this.getParent(ent);
  if (parent) {
    this.clearPropertiesCache(parent);
  }
}

CreateSystems.prototype.updateStateManagers = function (dt, ent) {
  const uuid = ent.uuid.uuid;
  const stateManager = ent.stateManager;

  if (!ent.uuid || !ent.uuid.uuid) {
    return;
  }

  if (!stateManager.__addComponents) {
    const slots = this.findSlots(ent, stateManager, 'link');
    this.addComponent(ent, slots);
    stateManager.__addComponents = true;
  }

  stateManager.state = this.getScalar(ent, stateManager.stateVariable, stateManager);
  if (stateManager.state !== stateManager.prevState) {
    //this.addComponent(ent, this.findSlots(ent, ent.stateManager, stateManager.state));

    let prevChildren = ent.stateManager.prevChildren;
    let prevChildrenLength = prevChildren.length;
    for (let j = 0; j < prevChildrenLength; j++) {
      const childEnt = prevChildren[j];
      this.addComponent(childEnt, this.findSlots(ent, ent.stateManager, 'exit'))
    }

    const childrenEnts = this.createSceneGraphChildren(ent, ent.transform, false, (t) => {
      if (!t.vars.stateType || t.vars.stateType === 'variable') {
        return t.vars.state == stateManager.state || t.vars.state == (''+stateManager.state);
      } else {
        // run script and check return value
        const script = t.vars.stateScript;
        const ret = this.runScript(dt, ent, ent.stateManager, script);
        return ret;
      }
    });

    stateManager.prevChildren = [];
    let childrenEntsLength = childrenEnts.length;
    for (let j = 0; j < childrenEntsLength; j++) {
      const childEnt = childrenEnts[j];
      stateManager.prevChildren.push(childEnt);
      this.addComponent(childEnt, this.findSlots(ent, ent.stateManager, 'enter'))
    }

    stateManager.prevState = stateManager.state;
  }

}

CreateSystems.prototype.updateStateManagerFeatures = function (dt, ent) {
  const uuid = ent.uuid.uuid;
  const totalLength = ent.stateManagerFeature.multi.length;
  if (!ent.uuid || !ent.uuid.uuid) {
    return;
  }

  for (let j = 0; j < totalLength; j++) {
    const stateManagerFeature = ent.stateManagerFeature.multi[j].c;
    const stateManagerFeatureComponent = ent.stateManagerFeature.multi[j].component;

    if (!stateManagerFeature.__addComponents) {
      const slots = this.findSlots(ent, stateManagerFeatureComponent, 'link');
      this.addComponent(ent, slots);
      stateManagerFeature.__addComponents = true;
    }

    stateManagerFeature.state = this.getScalar(ent, stateManagerFeature.stateVariable, stateManagerFeature);
    if (stateManagerFeature.state !== stateManagerFeature.prevState) {
      //this.addComponent(ent, this.findSlots(ent, ent.stateManager, stateManager.state));
      const slots = this.findSlots(ent, stateManagerFeatureComponent, 'any');
      this.addComponent(ent, slots);

      let prevComponents = stateManagerFeature.prevComponents;
      let prevComponentsLength = prevComponents.length;

      let toRemove = [];
      for (let i = 0; i < prevComponentsLength; i++) {
        const c = prevComponents[i];
          if (!c) {
            continue;
          }
        values(ent).forEach( (val) => {
          if (val.id === c.id) {
            toRemove.push(val);
          }
        });
      }
      toRemove = clone(stateManagerFeature.prevComponents);
      stateManagerFeature.prevComponents = []
      for (let i = toRemove.length - 1; i >= 0;  i--) {
        this.removeComponentManually(ent, toRemove[i]);
        //ent.removeComponent(toRemove[i].__componentType);
      }

      const linksData = this.findSlots(ent, stateManagerFeatureComponent, undefined, undefined, true);
      for (let i = 0; i < linksData.length; i++) {
        const {link,component} = linksData[i];
        if (link.name === 'any') {
          // already added above?
          continue;
        }

        const stateData = link.meta;
        let addComponent = false;
        if (!stateData.stateType || stateData.stateType === 'variable') {
          addComponent = stateData.state == stateManagerFeature.state || stateData.state == (''+stateManagerFeature.state);
        } else {
          // run script and check return value
          const script = stateData.stateScript;
          const ret = this.runScript(dt, ent, stateManagerFeature, script);
          addComponent = ret;
        }

        if (addComponent) {
          const c = this.addComponent(ent, component, true);
          if (c) {
            stateManagerFeature.prevComponents.push(c);
          }
        }

      }

      stateManagerFeature.prevState = stateManagerFeature.state;
    }

  }

}


CreateSystems.prototype.updateGroupTransforms = function (dt, ent) {
  if (ent.groupTransform.sendToOrigin) {
    ent.transform.x = 0;
    ent.transform.y = 0;
    this.conditionallySetDirty(ent);
  }

  this.addComponent(ent, this.findSlots(ent, ent.groupTransform, 'link'))
  this.createSceneGraphChildren(ent, ent.transform);
  this.removeComponent(ent, this.Components.GroupTransform);
}

CreateSystems.prototype.updateConditionalTransforms = function (dt, ent) {
  if (!ent.uuid || !ent.uuid.uuid) {
    return;
  }
  const uuid = ent.uuid.uuid;
  const conditionalTransform = ent.conditionalTransform;
  const script = conditionalTransform.script;

  const key = `${conditionalTransform.componentId}-${script.id}`;
  if (!this.userScripts[key]) {
    this.userScripts[key] = this.luaVm.load(script);
  }
  let ret = this.userScripts[key].run(dt, ent, conditionalTransform);
  if (ret.length) {
      ret = ret[0];
  } else {
      ret = false;
  }

  if (ret) {
    this.createSceneGraphChildren(ent, ent.transform);
    //this.addComponent(ent, this.findSlots(ent, fetchTransform, 'true'));
    this.removeComponent(ent, this.Components.ConditionalTransform);
  } else {
    ent.addComponent(this.Components.Destroy);
    //this.addComponent(ent, this.findSlots(ent, fetchTransform, 'false'))
  }

}

CreateSystems.prototype.runScript = function (dt, ent, component, script) {
  if (!this.userScripts[script.id]) {
    this.userScripts[script.id] = this.luaVm.load(script);
  }
  let ret = this.userScripts[script.id].run(dt, ent, component, script);
  if (ret.length) {
      ret = ret[0];
  } else {
      ret = false;
  }

  return ret;

}

CreateSystems.prototype.updateForEachTransforms = function (dt, ent) {
  const uuid = ent.uuid.uuid;
  const forEachTransform = ent.forEachTransform;
  const script = forEachTransform.script;
  if (!ent.uuid || !ent.uuid.uuid) {
    return;
  }

  if (!forEachTransform.__addComponents) {
    const slots = this.findSlots(ent, forEachTransform);
    this.addComponent(ent, slots);
    forEachTransform.__addComponents = true;
  }

  this.prepareGlobalAndLocalVariables(ent);
  const ret = this.runScript(dt, ent, forEachTransform, script);
  /*
  if (!this.userScripts[script.id]) {
    this.userScripts[script.id] = this.luaVm.load(script);
  }
  let ret = this.userScripts[script.id].run(dt, ent, forEachTransform);
  if (ret.length) {
      ret = ret[0];
  } else {
      ret = false;
  }
  */

  if (ret) {
    const lst = this.luaVm.tableToList(ret);
    const xSpacing = this.getScalar(ent, forEachTransform.xSpacing, forEachTransform);
    const ySpacing = this.getScalar(ent, forEachTransform.ySpacing, forEachTransform);
    for (let j = 0; j < lst.length; j++) {
      const val = lst[j];
      const thisTransform = cloneDeep(ent.transform);
      thisTransform.children.forEach( (child) => {
        child.transform.pos.x += xSpacing*(j);
        child.transform.pos.y += ySpacing*(j);
      })
      let thisChildren = this.createSceneGraphChildren(ent, thisTransform);
      thisChildren.forEach( (newChild) => {
        let additional = {};
        if (val.__shine && val.__shine.type === 'table') {
          const tableValues = this.luaVm.tableToList(val);
          tableValues.forEach( (x,i) => {
            if (isObject(x)) {
              keys(x).forEach( (k) => {
                additional[`row_${k}`] = x[k];
              });
            }
            additional[`row_${i}`] = x;
            additional[`row__num`] = j;

          });
          additional['row'] = val;
        } else {
          toPairs(val).forEach( (x, i) => {
            additional[`row_${x[0]}`] = x[1];
            additional[`row_${i}`] = x[1];
            additional[`row__num`] = j;
          });
          additional['row'] = this.luaVm.objectToTable(val);
        }
        const props = Object.assign({
          row:val
        }, additional)
        this.updateTransformProps(newChild, props);
        //this.setProperties(newChild, props)
        //newChild.__props = {row:val}
      });
    }

    //const newEnts = this.createSceneGraphChildren(ent, ent.transform);

    //this.addComponent(ent, this.findSlots(ent, fetchTransform, 'true'));
    this.removeComponent(ent, this.Components.ForEachTransform);
  } else {
    ent.addComponent(this.Components.Destroy);
    //this.addComponent(ent, this.findSlots(ent, fetchTransform, 'false'))
  }

}

CreateSystems.prototype.updateGridTransforms = function (dt, ent) {
  this.createSceneGraphChildren(ent, ent.transform);
  this.removeComponent(ent, this.Components.GridTransform);
}

CreateSystems.prototype.createQueryString = function (params) {
  return toPairs(params).map( ([key,value]) => {
    return [encodeURIComponent(key), encodeURIComponent(value)].join('=');
  }).join('&');

}

CreateSystems.prototype.updateFetchTransform = function (dt, ent) {
  const uuid = ent.uuid.uuid;
  const fetchTransform = ent.fetchTransform;
  if (!ent.uuid || !ent.uuid.uuid) {
    return;
  }
  if (fetchTransform.state === 'loading') {
  }

  if (!fetchTransform.__addComponents) {
    const slots = this.findSlots(ent, fetchTransform, 'link');
    this.addComponent(ent, slots);
    fetchTransform.__addComponents = true;
  }
  if (!fetchTransform.state) {
    fetchTransform.state = 'loading';
    this.addComponent(ent, this.findSlots(ent, fetchTransform, 'link'));
    const queryData = {};
    fetchTransform.queryData.forEach( (qd) => {
      queryData[qd.key] = this.getScalar(ent, qd.value, fetchTransform);
    });
    queryData.userId = this.gameobjects.userId;
    //axios.get(fetchTransform.url + '?userId='+this.gameobjects.userId)
    const queryString = toPairs(queryData).map( ([key,value]) => {
      return [encodeURIComponent(key), encodeURIComponent(value)].join('=');
    }).join('&');
    let url = this.getScalar(ent, fetchTransform.url, fetchTransform);
    if (url.indexOf('http') !== 0) {
      url = 'https://' + url;
    }
    url = this.gameobjects.api.makeGameRestUrl(url);
    //let giveScoreUrl = this.gameobjects.api.makeUrl('score');
    fetchTransform.startEvent.split(",").forEach( (e) => {
      this.emitEvent(ent, e);
    });
    let data = {};
    if (fetchTransform.sendAsBody) {
      data = queryData;
    }
    axios({method:fetchTransform.method,url:`${url}?${queryString}`,data})
      .then( (data) => {
        if (!ent.uuid || !ent.uuid.uuid) {
          return;
        }
        fetchTransform.endEvent.split(",").forEach( (e) => {
          this.emitEvent(ent, e);
        });
        fetchTransform.state = 'success';

        if (data.status != 200 || data.data.error) {
          fetchTransform.state = 'error';
        } else {
          const newProps = {};
          keys(data.data).forEach( (k) => {
            if (!isObject(data.data[k])) {
              newProps[`api_${k}`] = data.data[k];
            } else {
              newProps[`api_${k}`] = this.luaVm.listToTable(data.data[k]);
            }
          });
          newProps['api'] = this.luaVm.listToTable(data.data);

          this.updateTransformProps(ent, newProps);

          const script = fetchTransform.script;

          if (!this.userScripts[script.id]) {
            this.userScripts[script.id] = this.luaVm.load(script);
          }
          this.prepareGlobalAndLocalVariables(ent);
          this.userScripts[script.id].run(dt, ent, fetchTransform);

          if ((fetchTransform.slotActivated||[]).length) {
            for (let p = 0; p < fetchTransform.slotActivated.length; p++) {
              const slotName = fetchTransform.slotActivated[p];
              const slotties = this.findSlots(ent, fetchTransform, slotName);
              this.addComponent(ent, slotties);
            }
            fetchTransform.slotActivated = [];
          }

          // clear api_ variables
          keys(newProps).forEach( (k) => {
            this.clearTransformProp(ent, k);
          });
        }

      }, (err) => {
        //console.error('error fetching data', err.message, err);
        fetchTransform.errorEvent.split(",").forEach( (e) => {
          this.emitEvent(ent, e);
        });
        fetchTransform.state = 'error';
      });
  }
  if (fetchTransform.state !== fetchTransform.prevState) {
    this.addComponent(ent, this.findSlots(ent, ent.fetchTransform, fetchTransform.state));

    if (fetchTransform.prevState) {
      const previousEnts = this.gameobjects.entities.queryTag('child-' + ent.uuid.uuid);
      const previousEntsLength = previousEnts.length;
      for (let i = 0; i < previousEntsLength; i++) {
        const ent = previousEnts[i];
        if (ent.transform.vars.state === fetchTransform.prevState) {
          ent.addComponent(this.Components.Destroy);
        }
      }
    }
    this.createSceneGraphChildren(ent, ent.transform, false, (t) => {
      return t.vars.state === fetchTransform.state;
    });

    fetchTransform.prevState = fetchTransform.state;

  }

}

CreateSystems.prototype.updateFetchData = function (dt, ent) {
  const uuid = ent.uuid.uuid;
  const fetchData = ent.fetchData;
  if (!ent.uuid || !ent.uuid.uuid) {
    return;
  }
  if (!fetchData.state) {
    fetchData.state = 'loading';
    const data = {};
    const props = this.getProperties(ent);
    fetchData.data.forEach( (qd) => {
      data[qd.key] = this.getScalar(ent, qd.value, fetchData);
    });
    data.userId = this.gameobjects.userId;

    //fetchData.data.forEach( (k) => {
      //data[k] = props[k]
    //})
    fetchData.startEvent.split(",").forEach( (e) => {
      this.emitEvent(ent, e);
    });
    let url = this.getScalar(ent, fetchData.url, fetchData);
    if (url.indexOf('http') !== 0) {
      url = 'https://' + url;
    }
    if (!fetchData.sendAsBody) {
      url = [url, this.createQueryString(data)].join('?');
    }
    axios({method:fetchData.method,url:this.gameobjects.api.makeGameRestUrl(url), data : fetchData.sendAsBody ? data : undefined})
      .then( (data) => {
        if (!ent.uuid || !ent.uuid.uuid) {
          return;
        }
        fetchData.endEvent.split(",").forEach( (e) => {
          this.emitEvent(ent, e);
        });
        if (data.status != 200 || data.data.error) {
          fetchData.state = 'error';
        } else {
          fetchData.state = 'success';
          const newProps = {};
          keys(data.data).forEach( (k) => {
            if (!isObject(data.data[k])) {
              newProps[`api_${k}`] = data.data[k];
            } else {
              newProps[`api_${k}`] = this.luaVm.listToTable(data.data[k]);
            }
          });
          newProps['api'] = this.luaVm.listToTable(data.data);
          this.updateTransformProps(ent, newProps);

          const script = fetchData.script;

          if (!this.userScripts[script.id]) {
            this.userScripts[script.id] = this.luaVm.load(script);
          }

          try {
            this.prepareGlobalAndLocalVariables(ent);
            this.userScripts[script.id].run(dt, ent, fetchData);
          } catch (e) {
            //console.error('error in fetchdata script', e);
          }

          if ((fetchData.slotActivated||[]).length) {
            for (let p = 0; p < fetchData.slotActivated.length; p++) {
              const slotName = fetchData.slotActivated[p];
              const slotties = this.findSlots(ent, fetchData, slotName);
              this.addComponent(ent, slotties);
            }
            fetchData.slotActivated = [];
          }

          // clear api_ variables
          keys(newProps).forEach( (k) => {
            this.clearTransformProp(ent, k);
          });
        }

      }, (err) => {
        //console.error('error fetching data', err.message, err);
        fetchData.errorEvent.split(",").forEach( (e) => {
          this.emitEvent(ent, e);
        });
        //console.error('error here', err);
        fetchData.state = 'error';
      })
  }
  if (fetchData.state !== fetchData.prevState) {
    this.addComponent(ent, this.findSlots(ent, ent.fetchData, fetchData.state));
    fetchData.prevState = fetchData.state;
    if (fetchData.state !== 'loading') {
      this.removeComponent(ent, this.Components.FetchData);
    }
  }

}


CreateSystems.prototype.updateMisc = function (dt) {

  const root = this.findRoot();
  const properties = this.luaVm.props;
  properties.userId = this.gameobjects.userId;
  properties.gameId = this.gameobjects.gameId;


  let ents = this.gameobjects.entities.queryComponents([this.Components.GiveScore]);
  let length = ents.length;
  for (let i = 0; i < length; i++) {
    const ent = ents[i];
    const props = cloneDeep(properties);
    props.score = ent.giveScore.score;
    props.id = ent.giveScore.id;

    let giveScoreUrl = this.gameobjects.api.makeUrl('score');
    axios.post(giveScoreUrl, props)

    this.removeComponent(ent, this.Components.GiveScore);
  }

  ents = this.gameobjects.entities.queryComponents([this.Components.ParticleTransform]);
  length = ents.length;
  for (let i = 0; i < length; i++) {
    const ent = ents[i];
    const uuid = ent.uuid.uuid;
    const particleTransform = ent.particleTransform;
    if (!this.particleEmitters[uuid]) {
      const {inner,outer} = this.pixiContainers[uuid];
      let parent = inner;
      const texture = this.gameobjects.mipmappedTextures[ent.particleTransform.component.sprite]

      //const scale = this.GetWorldCenter
      const worldScale = this.getWorldScale(ent);


      const f = (t, tween, start, end) => {
        start = parseFloat(start);
        end = parseFloat(end);
        const x = this.applyTween(tween, t);
        return start + x * (end - start);
      }
      const speed = {
        list:[
        ],
        isStepped:false
      }
      const alpha = {
        list:[
        ],
        isStepped:false
      }
      const scale = {
        list:[
        ],
        isStepped:false
      }
      for (let t = 0; t <= 1.1; t += 0.05) {
        speed.list.push({
          value:f(t, particleTransform.component.speedTween, particleTransform.component.startSpeed, particleTransform.component.endSpeed),
          time:t
        })
      }
      for (let t = 0; t <= 1.1; t += 0.05) {
        alpha.list.push({
          value:f(t, particleTransform.component.alphaTween, particleTransform.component.startAlpha, particleTransform.component.endAlpha),
          time:t
        })
      }
      for (let t = 0; t <= 1.1; t += 0.05) {
        scale.list.push({
          value:f(t, particleTransform.component.scaleTween, particleTransform.component.startScale, particleTransform.component.endScale),
          time:t
        })
      }
      const emitter = new PIXI.particles.Emitter(

	      // The PIXI.Container to put the emitter in
	      // if using blend modes, it's important to put this
	      // on top of a bitmap, and not use the root stage Container
	      parent,
	      // The collection of particle images to use
	      [texture],
	      //[PIXI.Texture.fromImage('image.jpg')],
	      // Emitter configuration, edit this to change the look
	      // of the emitter
	      {
		      alpha,
		      scale,
		      color: {
			      list: [
				      {
					      value: "fb1010",
					      time: 0
				      },
				      {
					      value: "f5b830",
					      time: 1
				      }
			      ],
			      isStepped: false
		      },
		      startRotation: {
			      min: 0,
			      max: 360
		      },
		      rotationSpeed: {
			      min: 0,
			      max: 0
		      },
		      lifetime: {
			      min: 0.5,
			      max: 0.5
		      },
		      frequency: 0.008,
		      spawnChance: 1,
		      particlesPerWave: 1,
		      emitterLifetime: 100,
		      maxParticles: 1000,
		      pos: {
			      x: 0,
			      y: 0
		      },
		      addAtBack: false,
		      spawnType: "circle",
		      spawnCircle: {
			      x: 0,
			      y: 0,
			      r: 10
		      }
	      }
      );
      emitter.emit = true;
      //inner.addChild(emitter);
      this.particleEmitters[uuid] = emitter;
    }

    this.particleEmitters[uuid].update(dt/1000);
    //this.removeComponent(ent, this.Components.ParticleTransform);
  }


}

CreateSystems.prototype.updateLog = function (dt, ent) {
  const properties = this.luaVm.props;
  properties.userId = this.gameobjects.userId;
  properties.gameId = this.gameobjects.gameId;
  const props = cloneDeep(properties);
  props.statName = ent.log.statName;
  props.statValue = ent.log.statValue;

  const logUrl = this.gameobjects.api.makeUrl('log')
  this.gameobjects.logStat(clone(ent.log));
  //axios.post(logUrl, props)

  this.addComponent(ent, this.findSlots(ent, ent.log, 'link'));

  this.removeComponent(ent, this.Components.Log);
}

CreateSystems.prototype.updateTimelines = function (dt, ent) {

  const timelines = values(ent.timeline.timelines);
  for (let j = 0; j < timelines.length; j++) {
    const timeline = timelines[j];
    timeline.prevT = timeline.t;
    timeline.t += dt / 1000;
    this.allTimelines.push(timeline);
  }

}

CreateSystems.prototype.updateStartTimelines = function (dt, ent) {

  const totalLength = ent.startTimeline.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.startTimeline.multi[j];
    const startTimeline = o.c;
    const component = o.component;
    let addEnt = ent;
    if (!startTimeline.localTimeline) {
      addEnt = this.findRoot();
    }

    if (!addEnt) {
      //console.error('lol, no ent');
      continue;
    }


    this.Components.Timeline.create(addEnt);
    ///addEnt.addComponent(this.Components.Timeline);
    this.Components.Timeline.start(addEnt, startTimeline.name);
    //addEnt.timeline.start(startTimeline.name);
    //addEnt.timeline.name = startTimeline.name;
    //addEnt.timeline.prevT = -1;
    //addEnt.timeline.t = 0;

  }
  this.removeComponent(ent, ent.startTimeline);
  //this.multiRemoveComponent(ent, this.Components.StartTimeline, startTimeline);

    //this.findSlots(ent, startTimeline);

}

CreateSystems.prototype.updateOnTimeline = function (dt, ent) {
  const totalLength = ent.onTimeline.multi.length;
  for (let j = 0; j < totalLength; j++) {
    const o = ent.onTimeline.multi[j];
    const onTimeline = o.c;
    const component = o.component;

    let thisTimeline;
    for (let j = 0; j < this.allTimelines.length; j++) {
      const t = this.allTimelines[j];
      if (t.name === onTimeline.name) {
        thisTimeline = t
        break;
      }
    }

    if (!thisTimeline) {
      //console.warn('could not find timeline', onTimeline);
      continue;
    }

    if (!onTimeline.slots) {
//CreateSystems.prototype.findSlots = function (ent, component, name, notNamed, raw=false) {
      const slots = this.findSlots(ent, component, null, ['link'], true);
      const onTimes = [];
      for (let j = 0; j < slots.length; j++) {
        const slot = slots[j];
        const {component, link} = slot;
        if (!link) {
          continue;
        }
        link.name.split(',').forEach( (timePart) => {
          const t = parseFloat(timePart);
          if (isNaN(t)) {
            return;
          }
          onTimes.push({
            t,
            component
          })
        });
      }
      onTimeline.onTimes = sortBy(onTimes, (x) => {
        return x.start;
      });
    }

    for (let j = 0; j < onTimeline.onTimes.length; j++) {
      const onTime = onTimeline.onTimes[j];

      if (thisTimeline.prevT <= onTime.t && thisTimeline.t >= onTime.t) {

        //const slots = this.findSlots(ent, ent.onTimeline);
        this.addComponent(ent, [onTime.component]);

        //this.removeComponent(ent, this.Components.OnTimeline);
      }
    }

  }

}

CreateSystems.prototype.beforeFrame = function (dt) {
  this.propertyNeedUpdating = false;
  this.propertiesUpdated = []
  //PIXI.UI.Ticker.update(dt);
}

CreateSystems.prototype.afterFrame = function (dt) {

  this.gameobjects.events = [];
  this.gameobjects.localEvents = [];

  delete this.gameobjects.interaction.tap;
  delete this.gameobjects.interaction.swipe;
  //delete this.gameobjects.interaction.press;

  this.delayFirstRenderCounter--;
  if (this.delayFirstRender && this.delayFirstRenderCounter < 0) {
    this.gameobjects.resumeScene();
    this.delayFirstRender = false;
    for (let i = 0; i < this.gameobjects.entities._entities.length; i++) {
      const ent = this.gameobjects.entities._entities[i];
      if (ent.transform) {
        this.conditionallySetDirty(ent);
        ent.transform.isDirty = Math.max(Math.abs(this.delayCameraForFrames),1)
      }
    }
  }
  for (let i = 0; i < this.endOfFrame.length; i++) {
    this.endOfFrame[i]();
  }
  this.endOfFrame = [];

  // STUFF HERE ONLY HAPPENS IN DEBUG MODE
  if (!this.gameobjects.DEBUG_DRAW) {
    return;
  }
  this.debug.updateDebug(this.gameobjects, dt);


}

CreateSystems.prototype.getBox2D = function (callback) {
  let wasmError = false;
  function hasWasm() {
    if (wasmError) {
      return false;
    }
    try {
        if (typeof WebAssembly === "object"
            && typeof WebAssembly.instantiate === "function") {
            const module = new WebAssembly.Module(Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00));
            if (module instanceof WebAssembly.Module)
                return new WebAssembly.Instance(module) instanceof WebAssembly.Instance;
        }
    } catch (e) {
    }
    return false;
  }
  const TOTAL_MEMORY = 6 * 1024 * 1024;
  let wasmLoaded = false;
  const isPreview = true;
  const wasmSupported = hasWasm();
  if (isPreview || !wasmSupported) {
    const b2d = Box2DNormal({TOTAL_MEMORY})
    return callback(b2d);
  } else {
    let wasmBox2D = 'https://static.playboxcade.com/box2d/Box2D_v2.3.1_min.wasm.js'
    if (this.gameobjects.api.locateExternalScript) {
      wasmBox2D = this.gameobjects.api.locateExternalScript(wasmBox2D);
    }
    return $script(wasmBox2D, () => {
      return Box2D({
        locateFile: (thing) => {
          if (this.gameobjects.api.locateWasmFile) {
            return this.gameobjects.api.locateWasmFile(thing);
          }
          return thing;
        },
        printErr: (msg) => {
          //console.error('box2d error', msg);
          if (!wasmError) {
            wasmError = true;
            wasmLoaded = true;
            this.gameobjects.box2DWasm = false;
            let b2d = Box2DNormal({TOTAL_MEMORY});
            return callback(b2d);
          }
        },
        print: (msg) => {
        }
      }).then( (Box2D) => {
        if (wasmLoaded) {
          return;
        }
        if (!wasmError) {
          this.gameobjects.box2DWasm = true;
          wasmLoaded = true;
          callback(Box2D);
        } else {
          let b2d = Box2DNormal({TOTAL_MEMORY});
          wasmLoaded = true;
          this.gameobjects.box2DWasm = false;
          return callback(b2d);
        }
      });
    });

  }

  //callback(Box2D);
  const Module = {
    printErr(txt) {
      //console.error('module err', txt);
    }

  }
  return Box2D(Module)
  .then(callback);
  /*
	//TOTAL_MEMORY:4096*1024*1024,
    //wasmBinaryFile:'https://static.playboxcade.com/Box2D_v2.3.1_min.wasm.wasm',
    wasmBinaryFile:'https://static.playboxcade.com/box2d-test/box2d.test.wasm',
    //wasmBinaryFile:'/Box2D_v2.3.1_min.wasm.wasm',
    //wasmBinaryFile:'/Box2D_v2.3.1_min.wasm.wasm',
  }).then(callback);
  */
  return Box2D({
      'asm2wasm':{"f64-rem":function(a,c){return a%c},"f64-to-int":function(a){return a|0},"i32s-div":function(a,c){return(a|0)/(c|0)|0},"i32u-div":function(a,c){return(a>>>0)/(c>>>0)>>>0},"i32s-rem":function(a,c){return(a|0)%(c|0)|0},"i32u-rem":function(a,c){return(a>>>0)%(c>>>0)>>>0},"debugger":function(){}},
      DYNAMICOP_PTR:123,
      global:{
      DYNAMICOP_PTR:123,
      },
    env:{
      DYNAMICOP_PTR:123,
      'memory': new WebAssembly.Memory({initial: 100, limit: 1000}),
      'table': new WebAssembly.Table({initial: 0, element: 'anyfunc'}),
  }
  }).then(callback);
return callback(Box2D);
    return $script('https://dmfvi031eu5u.cloudfront.net/Box2D_v2.3.1_min.js', () => {
      
      callback(Box2D);
    });

    if (__BOX_2D) {
      return callback(__BOX_2D);
    }

    $script('https://dmfvi031eu5u.cloudfront.net/Box2D_v2.3.1_min.js', () => {
      
      __BOX_2D = Box2D;

      callback(Box2D);
    });

}

CreateSystems.prototype.BeginContact = function (contactPtr) {
  let contact = this.gameobjects.Box2D.wrapPointer(contactPtr, this.gameobjects.Box2D.b2Contact);
  const fixtureA = contact.GetFixtureA();
  const fixtureB = contact.GetFixtureB();
  const bodyA = fixtureA.GetBody();
  const bodyB = fixtureB.GetBody();

  const entA = bodyA.userData;
  const entB = bodyB.userData;
  const entACollisionWith = this.findComponentInTree(entA, 'collisionWith');
  const entBCollisionWith = this.findComponentInTree(entB, 'collisionWith');
  const collisionObject = {
    entA:bodyA.userData,
    entB:bodyB.userData,
    bodyA:bodyA,
    bodyB:bodyB,
    fixtureA:fixtureA,
    fixtureB:fixtureB,
    entACollisionWith,
    entBCollisionWith,
    contact:contact
  }

  this.gameobjects.b2d_collisionsBegin.push(collisionObject);
  this.gameobjects.b2d_collisionsBusy.push(collisionObject);

  this.setEntityBusyColliding(entA, entB);
  this.setEntityBusyColliding(entB, entA);

}

CreateSystems.prototype.setEntityBusyColliding = function (entA, entB) {
  if (!entA || !entB) {
    return;
  }
  if (!entA.uuid) {
    //console.warn('entA',entA,'has no uuid')
    return;
  }
  if (!entB.uuid) {
    //console.warn('entB',entB,'has no uuid')
    return;
  }
  const key = entA.uuid.uuid;
  if (!this.gameobjects.b2d_collisionsCurrent[key]) {
    this.gameobjects.b2d_collisionsCurrent[key] = new Set();
  }
  this.gameobjects.b2d_collisionsCurrent[key].add(entB.uuid.uuid);
}
CreateSystems.prototype.setEntityStoppedColliding = function (entA, entB) {
  if (!entA || !entB) {
    return;
  }
  if (!entA.uuid) {
    //console.warn('entA',entA,'has no uuid')
    return;
  }
  if (!entB.uuid) {
    //console.warn('entB',entB,'has no uuid')
    return;
  }
  const key = entA.uuid.uuid;
  if (!this.gameobjects.b2d_collisionsCurrent[key]) {
    return;
  }
  const set = this.gameobjects.b2d_collisionsCurrent[key];
  set.delete(entB.uuid.uuid);

}

CreateSystems.prototype.EndContact = function (contactPtr) {
  let contact = this.gameobjects.Box2D.wrapPointer(contactPtr, this.gameobjects.Box2D.b2Contact);
  const fixtureA = contact.GetFixtureA();
  const fixtureB = contact.GetFixtureB();
  const bodyA = fixtureA.GetBody();
  const bodyB = fixtureB.GetBody();

  const entA = bodyA.userData;
  const entB = bodyB.userData;
  const entACollisionWith = this.findComponentInTree(entA, 'collisionWith');
  const entBCollisionWith = this.findComponentInTree(entB, 'collisionWith');
  const collisionObject = {
    entA,
    entB,
    bodyA,
    bodyB,
    fixtureA,
    fixtureB,
    contact,
    entACollisionWith,
    entBCollisionWith
  }
  this.gameobjects.b2d_collisionsEnd.push(collisionObject);

  const totalBusy = this.gameobjects.b2d_collisionsBusy.length;
  for (let i = totalBusy-1; i >= 0; i--) {
    const o = this.gameobjects.b2d_collisionsBusy[i];
    if (o.entA === collisionObject.entA && o.entB === collisionObject.entB) {
        this.gameobjects.b2d_collisionsBusy.splice(i, 1);
    }
  }

  if (entA && entB) {
    this.setEntityStoppedColliding(entA, entB);
    this.setEntityStoppedColliding(entB, entA);
  }

}

CreateSystems.prototype.PreSolve = function (contactPtr, oldManifoldPtr) {
}
CreateSystems.prototype.PostSolve = function (contactPtr, oldManifoldPtr) {
}

CreateSystems.prototype.createBox2d_b2Vec2 = function (x,y) {
  if (!this.__temp_b2Vec2) {
    this.__temp_b2Vec2 = new this.gameobjects.Box2D.b2Vec2(0.0, 0.0);
  }
  this.__temp_b2Vec2.Set(x,y);
  return this.__temp_b2Vec2;
}
CreateSystems.prototype.createBox2d_b2Vec2_b = function (x,y) {
  if (!this.__temp_b2Vec2_b) {
    this.__temp_b2Vec2_b = new this.gameobjects.Box2D.b2Vec2(0.0, 0.0);
  }
  this.__temp_b2Vec2_b.Set(x,y);
  return this.__temp_b2Vec2_b;
}


CreateSystems.prototype.destroy = function () {
  //this.gameobjects.box2d_world.RemoveContactListener(this.listener);

  if (this.gameobjects.box2d_world) {
    var b2Body = this.gameobjects.box2d_world.GetBodyList();
    var items = 0;
    while(this.gameobjects.Box2D.getPointer(b2Body)){
      this.gameobjects.box2d_world.DestroyBody(b2Body);
      b2Body = b2Body.GetNext();
      items++;
    }
    delete this.gameobjects.Box2D;

    this.gameobjects.box2d_world.SetContactListener(null);
    this.gameobjects.box2d_world = null;
  }

  this.__root = null;
}

CreateSystems.prototype.runSystems = function (dt) {
  const entityManager = this.gameobjects.entities;

  /*
  if (framesDone === 0) {

    this.beforeFrame(dt);
    this.removeComponents(dt);
    entityManager.runSystems(dt);
    this.addComponents(dt);
    this.afterFrame(dt);
  }
  */

  this.mainAccumulator += dt/1000;

  if (this.mainAccumulator > this.mainMaxFrameTime) {
    this.mainAccumulator = this.mainMaxFrameTime;
  }

  while (this.mainAccumulator >= this.mainIdealFps) {

    let mainFps = this.mainIdealFps;
    let mainDt = mainFps * 1000;

    this.beforeFrame(mainDt);
    this.removeComponents(mainDt);
    entityManager.runSystems(mainDt);
    this.addComponents(mainDt);
    this.afterFrame(mainDt);

    this.mainAccumulator -= mainFps;
  }

  //if (this.ranBox2D && this.physicsAccumulator > 0) {
    //this.gameobjects.box2d_world.Step(this.physicsAccumulator, 6, 2);
    //this.physicsAccumulator = 0;
  //}



}

CreateSystems.prototype.initFromScene = function (initialSceneNum, callback) {

  this.init( () => {
    this.endOfFrame.push( () => {
      const rootEnt = this.findRoot();
      if (!rootEnt) {
        console.warn('root lost');
        return;
      }
      this.activeSceneNum = initialSceneNum;
      this.Components.GotoScene.create(rootEnt, {
        scene:this.gameobjects.scenes[initialSceneNum],
        mode:'first',
        skipFrames:1
      })
    });

    callback();

  });

}

CreateSystems.prototype.startWithScene = function (sceneNumber) {
  const rootEnt = this.findRoot();
  if (!rootEnt) {
    console.warn('root lost');
    return;
  }
  this.activeSceneNum = sceneNumber;
  this.Components.GotoScene.create(rootEnt, {
    scene:this.gameobjects.scenes[sceneNumber],
    mode:'first',
    skipFrames:1
  })

}

CreateSystems.prototype.startWithTransforms = function (initialTransforms, layers) {
  const rootEnt = this.findRoot();
  const fakeScene = {
    components:this.gameobjects.components,
    links:this.gameobjects.links,
    transforms:initialTransforms,
    layers,
    name:'__Temporary Scene'
  }
  this.Components.GotoScene.create(rootEnt, {
    scene:fakeScene,
    mode:'first',
    skipFrames:1
  });

}

CreateSystems.prototype.initFromTransforms = function (initialTransforms, layers, callback) {
  this.init( () => {
    this.endOfFrame.push( () => {
      const rootEnt = this.findRoot();
      const fakeScene = {
        components:this.gameobjects.components,
        links:this.gameobjects.links,
        transforms:initialTransforms,
        layers,
        name:'__Temporary Scene'
      }
      this.activeSceneNum = 0;
      this.Components.GotoScene.create(rootEnt, {
        scene:fakeScene,
        mode:'first',
        skipFrames:1
      });

      const {screenWidth, screenHeight} = this.gameobjects;
      this.gameobjects.app.stage.position.x = screenWidth/2
      this.gameobjects.app.stage.position.y = screenHeight/2;

      const MAGIC_CAMERA_SCALE_VALUE = Math.min(screenHeight,screenWidth * 16/9) / 16;
      this.cameraContainer.scale.x = MAGIC_CAMERA_SCALE_VALUE;
      this.cameraContainer.scale.y = MAGIC_CAMERA_SCALE_VALUE;

    });

    callback();

  });
}

CreateSystems.prototype.init = function (callback) {
  const entityManager = this.gameobjects.entities;
  entityManager.addSystem(this.Components.Uuid, null);
  entityManager.addSystem(this.Components.Properties, null);
  entityManager.addSystem(this.Components.Unparent, this.updateUnparent.bind(this));
  entityManager.addSystem(this.Components.CollisionBox, null);
  entityManager.addSystem(this.Components.CollisionWith, null);

  entityManager.addSystem(this.Components.EmitEvent, this.updateEmitEvent.bind(this));
  entityManager.addSystem(this.Components.StartScene, this.updateStartScene.bind(this));
  entityManager.addSystem(this.Components.GotoScene, this.updateGotoScene.bind(this));
  entityManager.addSystem(this.Components.GotoGame, this.updateGotoGame.bind(this));
  entityManager.addSystem(this.Components.Tween, this.updateTween.bind(this));
  entityManager.addSystem(this.Components.SetState, this.updateSetState.bind(this));
  entityManager.addSystem(this.Components.CameraFollows, this.updateCameraFollows.bind(this));
  entityManager.addSystem(
    this.Components.Camera,
    this.cameraSystem.update.bind(this.cameraSystem),
    this.cameraSystem.before.bind(this.cameraSystem),
    this.cameraSystem.after.bind(this.cameraSystem),
  );

  entityManager.addSystem(this.Components.SetTransformProperties, this.updateSetTransformProperties.bind(this));

  entityManager.addSystem(this.Components.CreateToy, this.updateCreateToys.bind(this));

  entityManager.addSystem(this.Components.StateManagerFeature, this.updateStateManagerFeatures.bind(this));
  entityManager.addSystem(this.Components.LuaScript, this.updateUserSystems.bind(this), this.beforeUpdateUserSystems.bind(this), this.afterUpdateUserSystems.bind(this));
  entityManager.addSystem(this.Components.Multiple, this.updateMultiple.bind(this));
  entityManager.addSystem(this.Components.Path, this.updatePath.bind(this), this.beforeUpdatePath.bind(this), this.afterUpdatePath.bind(this));
  entityManager.addSystem(this.Components.Point, this.updatePoint.bind(this));
  entityManager.addSystem(this.Components.FollowPath, this.updateFollowPath.bind(this));
  entityManager.addSystem(this.Components.Move, this.updateMove.bind(this));
  entityManager.addSystem(this.Components.MoveTo, this.updateMoveTo.bind(this));
  entityManager.addSystem(this.Components.MoveHere, this.updateMoveHere.bind(this));
  entityManager.addSystem(this.Components.RestrictPosition, this.updateRestrictPosition.bind(this));
  entityManager.addSystem(this.Components.SetProperties, this.updateSetProperties.bind(this));
  entityManager.addSystem(this.Components.Jump, this.updateJump.bind(this));
  entityManager.addSystem(this.Components.AutoMove, this.updateAutoMove.bind(this));


  entityManager.addSystem(this.Components.TapController, this.runTapController.bind(this), this.beforeRunTapController.bind(this));
  entityManager.addSystem(this.Components.KeyController, this.runKeyController.bind(this));
  entityManager.addSystem(this.Components.PressController, this.runPressController.bind(this));
  entityManager.addSystem(this.Components.PanController, this.runPanController.bind(this), this.beforeRunPanController.bind(this), this.afterRunPanController.bind(this));
  entityManager.addSystem(this.Components.SwipeController, this.runSwipeController.bind(this));
  //this.runInteractionSystems(dt);

  entityManager.addSystem(this.Components.SetCollisionFilter, this.updateSetCollisionFilters.bind(this));
  entityManager.addSystem(this.Components.ApplyImpulse2D, this.updateApplyImpulse2D.bind(this));
  entityManager.addSystem(this.Components.ApplyForce2D, this.updateApplyForce2D.bind(this));
  entityManager.addSystem(this.Components.SetLinearVelocity2d, this.updateSetLinearVelocity.bind(this));
  entityManager.addSystem(this.Components.SetBodyProperties, this.updateSetBodyProperties.bind(this));
  //this.Systems.updateRemoveJoints(dt);
  entityManager.addSystem(this.Components.ApplyJoint, this.updateApplyJoints.bind(this));
  //this.Systems.updateApplyJoints(dt);

  entityManager.addSystem(this.Components.StopMovement, this.updateStopMovement.bind(this));
  entityManager.addSystem(this.Components.ChangeProperties, this.updateChangeProperties.bind(this));
  entityManager.addSystem(this.Components.LimitProperties, this.updateLimitProperties.bind(this));
  entityManager.addSystem(this.Components.Translate, this.updateTranslate.bind(this));

  //entityManager.addSystem(this.Components.PhysicsBody2D, this.updatePhysicsBody2D.bind(this));
  entityManager.addSystem(this.Components.PhysicsBody2D, () => {}, this.beforeUpdatePhysicsBody.bind(this), () => { });

  entityManager.addSystem(
    this.Components.CollisionBox,
    this.collisionBoxSystem.update.bind(this.collisionBoxSystem),
    this.collisionBoxSystem.before.bind(this.collisionBoxSystem),
    this.collisionBoxSystem.after.bind(this.collisionBoxSystem),
  );

  entityManager.addSystem(this.Components.TransformGraphCreate, this.updateSceneGraph.bind(this));
  entityManager.addSystem(this.Components.Transform, this.updateTransform.bind(this), this.beforeUpdateTransform.bind(this), this.afterUpdateTransform.bind(this));
  entityManager.addSystem(
    this.Components.SpriteMask,
    this.spriteMaskSystem.update.bind(this.spriteMaskSystem),
    this.spriteMaskSystem.before.bind(this.spriteMaskSystem),
    this.spriteMaskSystem.after.bind(this.spriteMaskSystem),
  );


  entityManager.addSystem(this.Components.PhysicsBody, () => {} , () => {}, this.afterUpdatePhysicsBody.bind(this));

  //this.Systems.updateCollisionBoxes(dt);

  //this.Systems.updateTiledSprites(dt);
  //this.Systems.updateAnimatedSprites(dt);
  entityManager.addSystem(this.Components.SetGameState, this.updateSetGameState.bind(this));
  entityManager.addSystem(this.Components.Cooldown, this.updateCooldown.bind(this), this.beforeUpdateCooldown.bind(this));
  entityManager.addSystem(this.Components.Delay, this.updateDelay.bind(this));
  entityManager.addSystem(this.Components.DelayTransform, this.updateDelayTransform.bind(this));
  entityManager.addSystem(this.Components.Goal, this.checkGoal.bind(this));
  entityManager.addSystem(this.Components.PlaySound, this.updatePlaySounds.bind(this));
  entityManager.addSystem(this.Components.Sequence, this.updateSequence.bind(this));
  entityManager.addSystem(this.Components.RemoveComponentFromToy, this.updateRemoveComponent.bind(this));

  entityManager.addSystem(this.Components.CreateFeature, this.updateCreateFeatures.bind(this));
  entityManager.addSystem(this.Components.Slot, this.updateSlots.bind(this));

  entityManager.addSystem(this.Components.OnDestroy, this.updateOnDestroy.bind(this));
  entityManager.addSystem(this.Components.Destroy, this.updateDestroy.bind(this));
  entityManager.addSystem(this.Components.Spawner, this.updateSpawner.bind(this));
  entityManager.addSystem(this.Components.Repeater, this.updateRepeater.bind(this));
  //entityManager.addSystem(this.Components.Random, this.updateRandom.bind(this));
  entityManager.addSystem(this.Components.RandomTransform, this.updateRandomTransform.bind(this));
  entityManager.addSystem(this.Components.RandomChoose, this.updateRandomChoose.bind(this));
  //this.Systems.updateAllTransforms(dt);

  entityManager.addSystem(this.Components.StateManager, this.updateStateManagers.bind(this));
  entityManager.addSystem(this.Components.GroupTransform, this.updateGroupTransforms.bind(this));
  entityManager.addSystem(this.Components.GridTransform, this.updateGridTransforms.bind(this));
  entityManager.addSystem(this.Components.ConditionalTransform, this.updateConditionalTransforms.bind(this));
  entityManager.addSystem(this.Components.ForEachTransform, this.updateForEachTransforms.bind(this));

  entityManager.addSystem(this.Components.AskInput, this.updateUserInput.bind(this), this.beforeUserInput.bind(this), this.afterUserInput.bind(this));
  //this.Systems.updateMisc(dt);
  entityManager.addSystem(this.Components.Log, this.updateLog.bind(this));
  entityManager.addSystem(this.Components.FetchTransform, this.updateFetchTransform.bind(this));
  entityManager.addSystem(this.Components.FetchData, this.updateFetchData.bind(this));

  entityManager.addSystem(this.Components.OnEvent, this.updateOnEvent.bind(this));
  entityManager.addSystem(this.Components.OnEventTransform, this.updateOnEventTransform.bind(this));
  entityManager.addSystem(this.Components.ParallaxTransform, this.updateParallaxTransform.bind(this), this.beforeParallaxTransform.bind(this), this.afterParallaxTransform.bind(this));

  /*
  entityManager.addSystem(this.Components.Timeline, this.updateTimelines.bind(this), () => {
    this.allTimelines = [];
  });
  entityManager.addSystem(this.Components.StartTimeline, this.updateStartTimelines.bind(this));
  entityManager.addSystem(this.Components.OnTimeline, this.updateOnTimeline.bind(this));
  */
  entityManager.addSystem(
    this.Components.Timeline,
    this.timelineSystem.update.bind(this.timelineSystem),
    this.timelineSystem.before.bind(this.timelineSystem),
    this.timelineSystem.after.bind(this.timelineSystem)
  )
  //this.Systems.updateTimelines(dt);

  entityManager.addSystem(
    this.Components.PlayAnimation,
    this.playAnimationSystem.update.bind(this.playAnimationSystem),
    this.playAnimationSystem.before.bind(this.playAnimationSystem),
    this.playAnimationSystem.after.bind(this.playAnimationSystem),
  );
  entityManager.addSystem(
    this.Components.Video,
    this.videoSystem.update.bind(this.videoSystem),
    this.videoSystem.before.bind(this.videoSystem),
    this.videoSystem.after.bind(this.videoSystem),
  );
  entityManager.addSystem(
    this.Components.TiledSprite,
    this.tilingSpriteSystem.update.bind(this.tilingSpriteSystem),
    this.tilingSpriteSystem.before.bind(this.tilingSpriteSystem),
    this.tilingSpriteSystem.after.bind(this.tilingSpriteSystem)
  );


  entityManager.addSystem(
    this.Components.GameText,
    this.textSystem.update.bind(this.textSystem),
    this.textSystem.before.bind(this.textSystem),
    this.textSystem.after.bind(this.textSystem),
  );
  entityManager.addSystem(
    this.Components.Sprite,
    this.spriteSystem.update.bind(this.spriteSystem),
    this.spriteSystem.before.bind(this.spriteSystem),
    this.spriteSystem.after.bind(this.spriteSystem),
  );

  entityManager.addSystem(this.Components.SpineTransform, this.updateSpine.bind(this), this.beforeUpdateSpine.bind(this), this.afterUpdateSpine.bind(this));
  entityManager.addSystem(this.Components.SpineControl, this.updateSpineControl.bind(this));
  //this.Systems.updateTileMap(dt);
  entityManager.addSystem(this.Components.Shape, this.updateShapes.bind(this), this.beforeUpdateShapes.bind(this), null);
  entityManager.addSystem(this.Components.Circle, this.updateCircles.bind(this), null, this.afterUpdateShapes.bind(this));
  entityManager.addSystem(this.Components.ChangeBodyType, this.updatePhysicsBodyType.bind(this))
  entityManager.addSystem(this.Components.ScrollTransform, this.updateScrollTransform.bind(this), this.beforeUpdateScrollTransform.bind(this), this.afterUpdateScrollTransform.bind(this));

  //topLevelComponents.forEach( (topLevelComponent) => {
    //const ent = entityManager.createEntity();
    //this.createUuid(ent);
    //this.Components.TransformGraphCreate.create(ent, topLevelComponent);
  //});

  // physics
  const hasAdvancedPhysics = this.gameobjects.components.filter( (c) => {
    return c.type === 'physicsbody2d';
  }).length > 0;
  //const hasAdvancedPhysics = false;

  if (!hasAdvancedPhysics) {
    this.gameobjects.b2d_collisionsBegin = [];
    this.gameobjects.b2d_collisionsBusy = [];
    this.gameobjects.b2d_collisionsCurrent = {};
    this.gameobjects.b2d_collisionsEnd = [];
    callback();
  } else {
    this.getBox2D( (Box2D) => {

        this.gameobjects.Box2D = Box2D

        this.gameobjects.b2d_collisionsBegin = [];
        this.gameobjects.b2d_collisionsBusy = [];
        this.gameobjects.b2d_collisionsCurrent = {};
        this.gameobjects.b2d_collisionsEnd = [];

        let box2d_gravity = this.createBox2d_b2Vec2(0.0, 10.0);

        let box2d_world = new this.gameobjects.Box2D.b2World(box2d_gravity);
        this.listener = new this.gameobjects.Box2D.JSContactListener();
        this.listener.BeginContact = this.BeginContact.bind(this);
        this.listener.EndContact = this.EndContact.bind(this);
        this.listener.PreSolve = this.PreSolve.bind(this);
        this.listener.PostSolve = this.PostSolve.bind(this);

        this.gameobjects.box2d_world = box2d_world;
        if (this.gameobjects.DEBUG_DRAW) {
          const debugDraw = box2d_debug_draw.getCanvasDebugDraw(this.gameobjects.Box2D,
            this.gameobjects);
          let e_shapeBit = 0x0001;
          let e_jointBit = 0x0002;
          let e_aabbBit = 0x0004;
          let e_pairBit = 0x0008;
          let e_centerOfMassBit = 0x0010;
          debugDraw.SetFlags(e_shapeBit | e_jointBit );
          this.gameobjects.box2d_world.SetDebugDraw(debugDraw);
        }

        this.gameobjects.box2d_world.SetContactListener(this.listener);

        callback();

      //})

  });
  }

}

CreateSystems.prototype.updateUnparent = function (dt, ent) {
  const rootEnt = this.findRoot();
  this.reparent(ent, rootEnt);
  this.addComponent(ent, this.findSlots(ent, ent.unparent, 'link'));
  this.removeComponent(ent, this.Components.Unparent);

}

function lerp(value1, value2, amount) {
  amount = amount < 0 ? 0 : amount;
  amount = amount > 1 ? 1 : amount;
  return value1 + (value2 - value1) * amount;

}

CreateSystems.prototype.updateCameraFollows = function (dt, ent) {
  //if (!this.isDirty(ent)) {
    //return;
  //}
  const camera = this.gameobjects.foundCamera;
  if (!camera) {
    return;
  }
  const worldPos = this.getWorldPosition(ent);
  if (typeof(worldPos) === 'undefined') {
    return;
  }
  if (typeof(camera.transform) === 'undefined') {
    return;
  }
  //console.log('worldPos', worldPos.x, worldPos.y);
  //console.log('camera follows', ent.uuid.uuid);

  const speed = 10000;

  const t = speed * (dt/1000);
  
  const {x,y} = camera.transform;
  const newX = lerp(x, worldPos.x, t);
  const newY = lerp(y, worldPos.y, t);

  camera.transform.x = newX;
  camera.transform.y = newY;

  this.conditionallySetDirty(camera);

}


export default CreateSystems;
